import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"notifyOnNetworkStatusChange":true} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  MongoID: { input: any; output: any; }
  NotificationTypeInput: { input: any; output: any; }
  RegExpAsString: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  _id: Scalars['MongoID']['output'];
  address_1: Scalars['String']['output'];
  address_2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  type: EnumAddressType;
};

export type AddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type: EnumAddressType;
};

/** List of items with pagination. */
export type AddressPagination = {
  __typename?: 'AddressPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Address>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type AnimalHeadInput = {
  cutsheetInformation?: InputMaybe<Array<CutsheetInformationInput>>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
};

export type AnimalHeadUpdatesInput = {
  _id?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
};

export type BlockedByInput = {
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
};

export type CancellationReason = {
  __typename?: 'CancellationReason';
  _id: Scalars['MongoID']['output'];
  index?: Maybe<Scalars['Float']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  reason: Scalars['String']['output'];
};

/** List of items with pagination. */
export type CancellationReasonPagination = {
  __typename?: 'CancellationReasonPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<CancellationReason>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CarcassTagsDocumentSettingsInput = {
  title: EnumProcessorSettingsDocumentSettingsCarcassTagTitle;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  _id: Scalars['MongoID']['output'];
  chatRoom?: Maybe<ChatRoom>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  sender?: Maybe<User>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type ChatMessagePagination = {
  __typename?: 'ChatMessagePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ChatMessage>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ChatRoom = {
  __typename?: 'ChatRoom';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  lastMessage?: Maybe<ChatMessage>;
  messages: Array<ChatMessage>;
  participants: Array<User>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
};


export type ChatRoomMessagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ChatRoomParticipantsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};

/** List of items with pagination. */
export type ChatRoomPagination = {
  __typename?: 'ChatRoomPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ChatRoom>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CheckoutSessionResponse = {
  __typename?: 'CheckoutSessionResponse';
  clientSecret: Scalars['String']['output'];
};

export type ComplexAnimalCapacity = SpeciesComplexAnimalCapacitySchema | SpeciesInspectionComplexAnimalCapacitySchema | WeightedAnimalComplexAnimalCapacitySchema;

export type CreateManyAddressInput = {
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type: EnumAddressType;
};

export type CreateManyAddressPayload = {
  __typename?: 'CreateManyAddressPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Address>>;
};

export type CreateManyCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
};

export type CreateManyCancellationReasonPayload = {
  __typename?: 'CreateManyCancellationReasonPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<CancellationReason>>;
};

export type CreateManyChatMessageInput = {
  chatRoom: Scalars['MongoID']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyChatMessagePayload = {
  __typename?: 'CreateManyChatMessagePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ChatMessage>>;
};

export type CreateManyChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyChatRoomPayload = {
  __typename?: 'CreateManyChatRoomPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ChatRoom>>;
};

export type CreateManyCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumCutsheetAnimalSpecies;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<CutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts: Array<InputMaybe<Scalars['MongoID']['input']>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<CutsheetTrimInput>>>;
  type: EnumCutsheetType;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateManyCutsheetPayload = {
  __typename?: 'CreateManyCutsheetPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Cutsheet>>;
};

export type CreateManyIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name: EnumIntegrationName;
  secret?: InputMaybe<Scalars['String']['input']>;
  type: EnumIntegrationType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyIntegrationPayload = {
  __typename?: 'CreateManyIntegrationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Integration>>;
};

export type CreateManyInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due: Scalars['Float']['input'];
  amount_paid: Scalars['Float']['input'];
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  discounts?: InputMaybe<Array<InputMaybe<InvoiceDiscountsInput>>>;
  due_date: Scalars['Date']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<InvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status: EnumInvoiceStatus;
  status_changes?: InputMaybe<Array<InputMaybe<InvoiceStatus_ChangesInput>>>;
  type: EnumInvoiceType;
  user: Scalars['MongoID']['input'];
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyInvoiceLineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceLineItemExternal_LinksInput>;
  invoice: Scalars['MongoID']['input'];
  links?: InputMaybe<Array<InputMaybe<InvoiceLineItemLinksInput>>>;
  quantity: Scalars['Float']['input'];
};

export type CreateManyInvoiceLineItemPayload = {
  __typename?: 'CreateManyInvoiceLineItemPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<InvoiceLineItem>>;
};

export type CreateManyInvoicePayload = {
  __typename?: 'CreateManyInvoicePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Invoice>>;
};

export type CreateManyModuleInput = {
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
};

export type CreateManyModulePayload = {
  __typename?: 'CreateManyModulePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Module>>;
};

export type CreateManyNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note: Scalars['String']['input'];
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type: EnumNoteType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyNotePayload = {
  __typename?: 'CreateManyNotePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Note>>;
};

export type CreateManyNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<NotificationSettingTimingsInput>>>;
  trigger: EnumNotificationSettingTrigger;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyNotificationSettingPayload = {
  __typename?: 'CreateManyNotificationSettingPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<NotificationSetting>>;
};

export type CreateManyPrimalCutBlockerInput = {
  animalSpecies: Scalars['String']['input'];
  blockedBy?: InputMaybe<Array<InputMaybe<PrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyPrimalCutBlockerPayload = {
  __typename?: 'CreateManyPrimalCutBlockerPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalCutBlocker>>;
};

export type CreateManyPrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  primal: Scalars['MongoID']['input'];
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalCutPayload = {
  __typename?: 'CreateManyPrimalCutPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalCut>>;
};

export type CreateManyPrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name: Scalars['String']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalCutTypePayload = {
  __typename?: 'CreateManyPrimalCutTypePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalCutType>>;
};

export type CreateManyPrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalGroupPayload = {
  __typename?: 'CreateManyPrimalGroupPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<PrimalGroup>>;
};

export type CreateManyPrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['MongoID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyPrimalPayload = {
  __typename?: 'CreateManyPrimalPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Primal>>;
};

export type CreateManyProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<ProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyProcessorCapabilityPayload = {
  __typename?: 'CreateManyProcessorCapabilityPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorCapability>>;
};

export type CreateManyProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyProcessorCapabilitySpecificationPayload = {
  __typename?: 'CreateManyProcessorCapabilitySpecificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorCapabilitySpecification>>;
};

export type CreateManyProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType: Scalars['String']['input'];
  sentOn: Scalars['Date']['input'];
  sentTo: Scalars['String']['input'];
  type: EnumProcessorNotificationType;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyProcessorNotificationPayload = {
  __typename?: 'CreateManyProcessorNotificationPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorNotification>>;
};

export type CreateManyProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies: EnumProcessorSchedulingAnimalSpecies;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<ProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount: Scalars['Float']['input'];
  invoice?: InputMaybe<ProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<ProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['String']['input'];
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<ProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings: Scalars['MongoID']['input'];
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status: EnumProcessorSchedulingStatus;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyProcessorSchedulingPayload = {
  __typename?: 'CreateManyProcessorSchedulingPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorScheduling>>;
};

export type CreateManyProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<DailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date: Scalars['Date']['input'];
  isDeleted: Scalars['Boolean']['input'];
  processorSettings: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateManyProcessorSettingsCustomCapacityPayload = {
  __typename?: 'CreateManyProcessorSettingsCustomCapacityPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorSettingsCustomCapacity>>;
};

export type CreateManyProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<ProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<ProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit: Scalars['Float']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<ProcessorSettingsValidationErrorsInput>>>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyProcessorSettingsPayload = {
  __typename?: 'CreateManyProcessorSettingsPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<ProcessorSettings>>;
};

export type CreateManyStateInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateManyStatePayload = {
  __typename?: 'CreateManyStatePayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<State>>;
};

export type CreateManyTenantInput = {
  date_created: Scalars['Date']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name: Scalars['String']['input'];
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManyTenantPayload = {
  __typename?: 'CreateManyTenantPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Tenant>>;
};

export type CreateManyUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UserSettingsInput>;
  tenant: Scalars['MongoID']['input'];
};

export type CreateManyUserPayload = {
  __typename?: 'CreateManyUserPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<User>>;
};

export type CreateManyVendorInput = {
  address: AddressInput;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name: Scalars['String']['input'];
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['MongoID']['input'];
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateManyVendorPayload = {
  __typename?: 'CreateManyVendorPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Vendor>>;
};

export type CreateManyWaitlistInput = {
  animal: EnumWaitlistAnimal;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateManyWaitlistPayload = {
  __typename?: 'CreateManyWaitlistPayload';
  /** Number of created documents */
  createdCount: Scalars['Int']['output'];
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Documents IDs */
  recordIds: Array<Scalars['MongoID']['output']>;
  /** Created documents */
  records?: Maybe<Array<Waitlist>>;
};

export type CreateOneAddressInput = {
  address_1: Scalars['String']['input'];
  address_2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  state: Scalars['String']['input'];
  type: EnumAddressType;
};

export type CreateOneAddressPayload = {
  __typename?: 'CreateOneAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Address>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  reason: Scalars['String']['input'];
};

export type CreateOneCancellationReasonPayload = {
  __typename?: 'CreateOneCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<CancellationReason>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneChatMessageInput = {
  chatRoom: Scalars['MongoID']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneChatMessagePayload = {
  __typename?: 'CreateOneChatMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ChatMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneChatRoomPayload = {
  __typename?: 'CreateOneChatRoomPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ChatRoom>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumCutsheetAnimalSpecies;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<CutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts: Array<InputMaybe<Scalars['MongoID']['input']>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<CutsheetTrimInput>>>;
  type: EnumCutsheetType;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type CreateOneCutsheetPayload = {
  __typename?: 'CreateOneCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Cutsheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name: EnumIntegrationName;
  secret?: InputMaybe<Scalars['String']['input']>;
  type: EnumIntegrationType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneIntegrationPayload = {
  __typename?: 'CreateOneIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Integration>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due: Scalars['Float']['input'];
  amount_paid: Scalars['Float']['input'];
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  description: Scalars['String']['input'];
  discounts?: InputMaybe<Array<InputMaybe<InvoiceDiscountsInput>>>;
  due_date: Scalars['Date']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<InvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status: EnumInvoiceStatus;
  status_changes?: InputMaybe<Array<InputMaybe<InvoiceStatus_ChangesInput>>>;
  type: EnumInvoiceType;
  user: Scalars['MongoID']['input'];
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneInvoiceLineItemInput = {
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<InvoiceLineItemExternal_LinksInput>;
  invoice: Scalars['MongoID']['input'];
  links?: InputMaybe<Array<InputMaybe<InvoiceLineItemLinksInput>>>;
  quantity: Scalars['Float']['input'];
};

export type CreateOneInvoiceLineItemPayload = {
  __typename?: 'CreateOneInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<InvoiceLineItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneInvoicePayload = {
  __typename?: 'CreateOneInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Invoice>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneModuleInput = {
  href: Scalars['String']['input'];
  label: Scalars['String']['input'];
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
};

export type CreateOneModulePayload = {
  __typename?: 'CreateOneModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Module>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note: Scalars['String']['input'];
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type: EnumNoteType;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneNotePayload = {
  __typename?: 'CreateOneNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<NotificationSettingTimingsInput>>>;
  trigger: EnumNotificationSettingTrigger;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneNotificationSettingPayload = {
  __typename?: 'CreateOneNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<NotificationSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalCutBlockerInput = {
  animalSpecies: Scalars['String']['input'];
  blockedBy?: InputMaybe<Array<InputMaybe<PrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOnePrimalCutBlockerPayload = {
  __typename?: 'CreateOnePrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalCutBlocker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  primal: Scalars['MongoID']['input'];
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalCutPayload = {
  __typename?: 'CreateOnePrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalCut>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name: Scalars['String']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalCutTypePayload = {
  __typename?: 'CreateOnePrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalCutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalGroupPayload = {
  __typename?: 'CreateOnePrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<PrimalGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOnePrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group: Scalars['MongoID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  order: Scalars['Float']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOnePrimalPayload = {
  __typename?: 'CreateOnePrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Primal>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<ProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneProcessorCapabilityPayload = {
  __typename?: 'CreateOneProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneProcessorCapabilitySpecificationPayload = {
  __typename?: 'CreateOneProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType: Scalars['String']['input'];
  sentOn: Scalars['Date']['input'];
  sentTo: Scalars['String']['input'];
  type: EnumProcessorNotificationType;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneProcessorNotificationPayload = {
  __typename?: 'CreateOneProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies: EnumProcessorSchedulingAnimalSpecies;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<ProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount: Scalars['Float']['input'];
  invoice?: InputMaybe<ProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<ProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId: Scalars['String']['input'];
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<ProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings: Scalars['MongoID']['input'];
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status: EnumProcessorSchedulingStatus;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneProcessorSchedulingPayload = {
  __typename?: 'CreateOneProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorScheduling>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<DailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date: Scalars['Date']['input'];
  isDeleted: Scalars['Boolean']['input'];
  processorSettings: Scalars['MongoID']['input'];
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type CreateOneProcessorSettingsCustomCapacityPayload = {
  __typename?: 'CreateOneProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorSettingsCustomCapacity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<ProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<ProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit: Scalars['Float']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<ProcessorSettingsValidationErrorsInput>>>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneProcessorSettingsPayload = {
  __typename?: 'CreateOneProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<ProcessorSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneStateInput = {
  code: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateOneStatePayload = {
  __typename?: 'CreateOneStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<State>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneTenantInput = {
  date_created: Scalars['Date']['input'];
  domain?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name: Scalars['String']['input'];
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOneTenantPayload = {
  __typename?: 'CreateOneTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Tenant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name: Scalars['String']['input'];
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UserSettingsInput>;
  tenant: Scalars['MongoID']['input'];
};

export type CreateOneUserPayload = {
  __typename?: 'CreateOneUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneVendorInput = {
  address: AddressInput;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created: Scalars['Date']['input'];
  enabled: Scalars['Boolean']['input'];
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name: Scalars['String']['input'];
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant: Scalars['MongoID']['input'];
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOneVendorPayload = {
  __typename?: 'CreateOneVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Vendor>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateOneWaitlistInput = {
  animal: EnumWaitlistAnimal;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateOneWaitlistPayload = {
  __typename?: 'CreateOneWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Created document */
  record?: Maybe<Waitlist>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type CreateProcessorScheduleResponse = {
  __typename?: 'CreateProcessorScheduleResponse';
  checkoutSession?: Maybe<CheckoutSessionResponse>;
  scheduling: ProcessorScheduling;
};

export type CreateProcessorSchedulingInput = {
  animalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadInput>>>;
  animalSpecies: Scalars['String']['input'];
  blockIndex?: InputMaybe<Scalars['Int']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  dropoffDate: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  headCount: Scalars['Int']['input'];
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings: Scalars['MongoID']['input'];
  refundDeadlineDays: Scalars['Int']['input'];
  requesterContactInformation?: InputMaybe<RequesterContactInformationInput>;
  vendor: Scalars['MongoID']['input'];
};

export type CreateProcessorSettingsCustomCapacityInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsDailyCapacityBlockInput>>>;
  date: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProcessorSettingsInvoicingInput = {
  defaultSplitRule?: InputMaybe<Scalars['String']['input']>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProcessorSettingsWithCustomCapacity = {
  __typename?: 'CreateProcessorSettingsWithCustomCapacity';
  customCapacities?: Maybe<Array<Maybe<ProcessorSettingsCustomCapacity>>>;
  processorSettings?: Maybe<ProcessorSettings>;
};

export type CreateProcessorSettingsWithCustomCapacityInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpsertProcessorSettingsAnimalSettings>>>;
  autoCarcassNumberSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoCarcassNumberSettingsInput>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingInput>>>;
  capacityConfigurationType?: InputMaybe<ProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  customCapacities?: InputMaybe<Array<InputMaybe<CreateProcessorSettingsCustomCapacityInput>>>;
  documentSettings?: InputMaybe<DocumentSettingsInput>;
  invoicing?: InputMaybe<CreateProcessorSettingsInvoicingInput>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays: Scalars['Int']['input'];
  schedulingDeposit: Scalars['Float']['input'];
  vendor: Scalars['MongoID']['input'];
};

export type Cutsheet = {
  __typename?: 'Cutsheet';
  _id: Scalars['MongoID']['output'];
  activeSpecification?: Maybe<ProcessorCapabilitySpecification>;
  animalSpecies: EnumCutsheetAnimalSpecies;
  animalType?: Maybe<EnumCutsheetAnimalType>;
  extras?: Maybe<Array<Maybe<CutsheetExtras>>>;
  groundMeatSize?: Maybe<Scalars['Float']['output']>;
  inspectionLevels?: Maybe<Array<Maybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['JSON']['output']>;
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  primalCuts: Array<PrimalCut>;
  roastSize?: Maybe<Scalars['String']['output']>;
  selectedSpecifications?: Maybe<Scalars['JSON']['output']>;
  splitTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  steakThickness?: Maybe<Scalars['Float']['output']>;
  steaksPerPack?: Maybe<Scalars['Float']['output']>;
  trim?: Maybe<Array<Maybe<CutsheetTrim>>>;
  type: EnumCutsheetType;
  user?: Maybe<Scalars['MongoID']['output']>;
  vendor?: Maybe<Scalars['MongoID']['output']>;
};


export type CutsheetPrimalCutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutInput>;
};

export type CutsheetDocumentSettingsInput = {
  format: EnumProcessorSettingsDocumentSettingsCutsheetFormat;
};

export type CutsheetExtras = {
  __typename?: 'CutsheetExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  type: EnumCutsheetExtrasType;
};

export type CutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type: EnumCutsheetExtrasType;
};

export type CutsheetExtrasTypeInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  type: EnumCutsheetExtrasType;
};

export type CutsheetInformationInput = {
  contactInformation: RequesterContactInformationInput;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  splitPart: Scalars['String']['input'];
  type?: InputMaybe<EnumCutsheetType>;
};

export type CutsheetInformationPartialUpdateInput = {
  _id: Scalars['MongoID']['input'];
  contactUser?: InputMaybe<ProcessorSchedulingPartialUpdateRequestedByInput>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  shouldUpdateExistingUser?: InputMaybe<Scalars['Boolean']['input']>;
};

/** List of items with pagination. */
export type CutsheetPagination = {
  __typename?: 'CutsheetPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Cutsheet>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type CutsheetPartialUpdateInput = {
  _id: Scalars['MongoID']['input'];
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type CutsheetTrim = {
  __typename?: 'CutsheetTrim';
  _id?: Maybe<Scalars['MongoID']['output']>;
  isActive: Scalars['Boolean']['output'];
  isAllTrim?: Maybe<Scalars['Boolean']['output']>;
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  trimSelection: EnumCutsheetTrimTrimSelection;
};

export type CutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive: Scalars['Boolean']['input'];
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection: EnumCutsheetTrimTrimSelection;
};

export type CutsheetTrimTypeInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type DailyCapacity = {
  __typename?: 'DailyCapacity';
  capacitiesByType?: Maybe<Array<Maybe<DailyCapacityCapacitiesByType>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DailyCapacityCapacitiesByType = {
  __typename?: 'DailyCapacityCapacitiesByType';
  /** Some Description */
  capacities?: Maybe<Array<Maybe<ComplexAnimalCapacity>>>;
  type: EnumDailyCapacityCapacitiesByTypeType;
};

export type DailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type: EnumDailyCapacityCapacitiesByTypeType;
};

export type DailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<DailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteDuplicatePrimalsPayload = {
  __typename?: 'DeleteDuplicatePrimalsPayload';
  duplicatesDeleted: Scalars['Int']['output'];
  duplicatesFound: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type DocumentSettingsInput = {
  carcassTag?: InputMaybe<CarcassTagsDocumentSettingsInput>;
  cutsheet?: InputMaybe<CutsheetDocumentSettingsInput>;
};

export enum EnumAddressType {
  Commercial = 'commercial',
  Residential = 'residential',
  Unknown = 'unknown'
}

export enum EnumCutsheetAnimalSpecies {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumCutsheetAnimalType {
  ExemptBeef = 'exempt_beef',
  ExemptHog = 'exempt_hog',
  StateBeef = 'state_beef',
  StateHog = 'state_hog',
  UsdaBeef = 'usda_beef',
  UsdaHog = 'usda_hog'
}

export enum EnumCutsheetExtrasType {
  FlatFee = 'flatFee',
  PricedPerPound = 'pricedPerPound'
}

export enum EnumCutsheetInspectionLevels {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumCutsheetTrimTrimSelection {
  AllowSelectionByPercentage = 'allowSelectionByPercentage',
  AllowSelectionByWeight = 'allowSelectionByWeight'
}

export enum EnumCutsheetType {
  Orphan = 'orphan',
  User = 'user',
  Vendor = 'vendor'
}

export enum EnumDailyCapacityCapacitiesByTypeType {
  Species = 'species',
  SpeciesInspection = 'species_inspection',
  WeightedAnimalUnit = 'weighted_animal_unit'
}

export enum EnumIntegrationName {
  QuickbooksOnline = 'quickbooks_online',
  Sendgrid = 'sendgrid',
  Stripe = 'stripe'
}

export enum EnumIntegrationType {
  Api = 'api'
}

export enum EnumInvoiceDiscountsType {
  Coupon = 'coupon',
  FixedAmount = 'fixed_amount',
  Percentage = 'percentage'
}

export enum EnumInvoiceLineItemLinksEntityType {
  Cutsheet = 'Cutsheet',
  ProcessorSchedulingAnimalHead = 'ProcessorSchedulingAnimalHead'
}

export enum EnumInvoiceLinksEntityType {
  Cutsheet = 'Cutsheet',
  ProcessorScheduling = 'ProcessorScheduling',
  ProcessorSchedulingAnimalHead = 'ProcessorSchedulingAnimalHead'
}

export enum EnumInvoiceStatus {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export enum EnumInvoiceStatus_ChangesNew_Status {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export enum EnumInvoiceStatus_ChangesPrevious_Status {
  Draft = 'draft',
  Open = 'open',
  Paid = 'paid',
  PartiallyRefunded = 'partially_refunded',
  Refunded = 'refunded',
  Uncollectible = 'uncollectible',
  Void = 'void'
}

export enum EnumInvoiceType {
  PartnersShipmentsMonthly = 'partners_shipments_monthly',
  ProcessingFees = 'processing_fees',
  ProcessorSchedulingDeposit = 'processor_scheduling_deposit',
  ProcessorSchedulingInvoice = 'processor_scheduling_invoice'
}

export enum EnumNoteType {
  ProcessorScheduling = 'processor_scheduling'
}

export enum EnumNotificationMessageChannel {
  Email = 'email',
  Sms = 'sms'
}

export enum EnumNotificationMessageTrigger {
  ChatMessage = 'Chat_Message',
  CutsheetNeeded = 'Cutsheet_Needed',
  CutsheetNotification = 'Cutsheet_Notification',
  CutsheetReminder = 'Cutsheet_Reminder',
  DropOffDateUpdated = 'Drop_off_Date_Updated',
  StatusUpdate = 'Status_Update',
  WaitlistCapacityAvailable = 'Waitlist_Capacity_Available',
  WaitlistSignupConfirmation = 'Waitlist_Signup_Confirmation',
  WaitlistUnsubscribeConfirmation = 'Waitlist_Unsubscribe_Confirmation'
}

export enum EnumNotificationMessageType {
  Custom = 'custom',
  System = 'system'
}

export enum EnumNotificationSettingTimingsRelation {
  After = 'after',
  At = 'at',
  Before = 'before'
}

export enum EnumNotificationSettingTrigger {
  ChatMessage = 'Chat_Message',
  CutsheetNeeded = 'Cutsheet_Needed',
  CutsheetNotification = 'Cutsheet_Notification',
  CutsheetReminder = 'Cutsheet_Reminder',
  DropOffDateUpdated = 'Drop_off_Date_Updated',
  StatusUpdate = 'Status_Update',
  WaitlistCapacityAvailable = 'Waitlist_Capacity_Available',
  WaitlistSignupConfirmation = 'Waitlist_Signup_Confirmation',
  WaitlistUnsubscribeConfirmation = 'Waitlist_Unsubscribe_Confirmation'
}

export enum EnumParentProductStock_Status {
  Instock = 'instock',
  Onbackorder = 'onbackorder',
  Outofstock = 'outofstock'
}

export enum EnumParentProductType {
  ProcessorDeposit = 'processor_deposit'
}

export enum EnumPrimalCutType {
  Chop = 'chop',
  Other = 'other',
  Rib = 'rib',
  Roast = 'roast',
  Steak = 'steak'
}

export enum EnumPrimalCutTypeAnimalSpecies {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumPrimalCutTypeLid {
  Chop = 'chop',
  Other = 'other',
  Rib = 'rib',
  Roast = 'roast',
  Steak = 'steak'
}

export enum EnumPrimalGroupAnimalSpecies {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumPrimalGroupInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorCapabilityAnimalSpecies {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorCapabilityExtrasType {
  FlatFee = 'flatFee',
  PricedPerPound = 'pricedPerPound'
}

export enum EnumProcessorCapabilityInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit {
  Inches = 'inches',
  None = 'none',
  Pounds = 'pounds'
}

export enum EnumProcessorCapabilityTrimSelection {
  AllowSelectionByPercentage = 'allowSelectionByPercentage',
  AllowSelectionByWeight = 'allowSelectionByWeight'
}

export enum EnumProcessorNotificationType {
  CutsheetConfirmation = 'cutsheetConfirmation',
  NewJob = 'newJob',
  QuickbooksReconnect = 'quickbooksReconnect',
  WaitlistJoin = 'waitlistJoin'
}

export enum EnumProcessorSchedulingAnimalHeadsInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorSchedulingAnimalSpecies {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSchedulingAnimalType {
  ExemptBeef = 'exempt_beef',
  ExemptHog = 'exempt_hog',
  StateBeef = 'state_beef',
  StateHog = 'state_hog',
  UsdaBeef = 'usda_beef',
  UsdaHog = 'usda_hog'
}

export enum EnumProcessorSchedulingInvoicesPricingType {
  CustomCutsheet = 'customCutsheet',
  KillAndChill = 'killAndChill',
  Killslot = 'killslot'
}

export enum EnumProcessorSchedulingNotificationHistoryNotificationType {
  Email = 'email',
  Sms = 'sms'
}

export enum EnumProcessorSchedulingSource {
  BulkUpload = 'bulk_upload',
  Farmshare = 'farmshare',
  Processor = 'processor',
  Producer = 'producer'
}

export enum EnumProcessorSchedulingStatus {
  Aging = 'Aging',
  CancelledByProcessor = 'Cancelled_By_Processor',
  CancelledByProducer = 'Cancelled_By_Producer',
  CheckoutExpired = 'Checkout_Expired',
  Completed = 'Completed',
  Curing = 'Curing',
  DeniedByProcessor = 'Denied_By_Processor',
  DepositFailed = 'Deposit_Failed',
  DroppedOff = 'Dropped_Off',
  Initial = 'Initial',
  InvoicePaid = 'Invoice_Paid',
  Invoicing = 'Invoicing',
  Killed = 'Killed',
  ReadyPayAtPickup = 'Ready__Pay_At_Pickup',
  Requested = 'Requested',
  Scheduled = 'Scheduled'
}

export enum EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsAnimalSettingsInspectionLevels {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumProcessorSettingsAnimalSettingsSpecies {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsAnimals {
  ExemptBeef = 'exempt_beef',
  ExemptHog = 'exempt_hog',
  StateBeef = 'state_beef',
  StateHog = 'state_hog',
  UsdaBeef = 'usda_beef',
  UsdaHog = 'usda_hog'
}

export enum EnumProcessorSettingsAutoSchedulingSettingsSpecies {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProcessorSettingsCapacityConfigurationType {
  Species = 'species',
  SpeciesInspection = 'species_inspection',
  WeightedAnimalUnit = 'weighted_animal_unit'
}

export enum EnumProcessorSettingsDocumentSettingsCarcassTagTitle {
  EarTag = 'ear_tag',
  TrackingNumber = 'tracking_number'
}

export enum EnumProcessorSettingsDocumentSettingsCutsheetFormat {
  Bold = 'bold',
  Classic = 'classic'
}

export enum EnumProcessorSettingsInvoicingDefaultSplitRule {
  Single = 'single',
  Split = 'split'
}

export enum EnumProcessorSettingsKillAndChillSettingsSpecies {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export enum EnumProductStock_Status {
  Instock = 'instock',
  Onbackorder = 'onbackorder',
  Outofstock = 'outofstock'
}

export enum EnumProductType {
  ProcessorDeposit = 'processor_deposit'
}

export enum EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel {
  Exempt = 'exempt',
  State = 'state',
  Usda = 'usda'
}

export enum EnumUserRole {
  Admin = 'admin',
  Basic = 'basic',
  Vendor = 'vendor'
}

export enum EnumWaitlistAnimal {
  Beef = 'beef',
  Bison = 'bison',
  Goat = 'goat',
  Hog = 'hog',
  Lamb = 'lamb',
  Venison = 'venison',
  Yak = 'yak'
}

export type ErrorInterface = {
  /** Generic error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type FilterCountAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterCountCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterCountCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterCountCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterCountCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterCountCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterCountCancellationReasonIndexOperatorsInput>;
};

export type FilterCountCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountChatMessageInput = {
  AND?: InputMaybe<Array<FilterCountChatMessageInput>>;
  OR?: InputMaybe<Array<FilterCountChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterCountChatMessage_IdOperatorsInput>;
};

export type FilterCountChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountChatRoomInput = {
  AND?: InputMaybe<Array<FilterCountChatRoomInput>>;
  OR?: InputMaybe<Array<FilterCountChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterCountChatRoom_IdOperatorsInput>;
};

export type FilterCountChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterCountCutsheetInput = {
  AND?: InputMaybe<Array<FilterCountCutsheetInput>>;
  OR?: InputMaybe<Array<FilterCountCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterCountCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterCountCutsheet_IdOperatorsInput>;
};

export type FilterCountCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterCountCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterCountDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterCountDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountIntegrationInput = {
  AND?: InputMaybe<Array<FilterCountIntegrationInput>>;
  OR?: InputMaybe<Array<FilterCountIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterCountIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterCountIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterCountIntegrationVendorOperatorsInput>;
};

export type FilterCountIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountInvoiceInput = {
  AND?: InputMaybe<Array<FilterCountInvoiceInput>>;
  OR?: InputMaybe<Array<FilterCountInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterCountInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterCountInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterCountInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterCountInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterCountInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterCountInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterCountInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterCountInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterCountInvoiceLineItem_IdOperatorsInput>;
};

export type FilterCountInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterCountInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterCountInvoiceStatusOperatorsInput>;
};

export type FilterCountInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterCountInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterCountInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountModuleInput = {
  AND?: InputMaybe<Array<FilterCountModuleInput>>;
  OR?: InputMaybe<Array<FilterCountModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountModuleOperatorsInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountModuleOperatorsInput = {
  _id?: InputMaybe<FilterCountModule_IdOperatorsInput>;
};

export type FilterCountModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNoteInput = {
  AND?: InputMaybe<Array<FilterCountNoteInput>>;
  OR?: InputMaybe<Array<FilterCountNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountNoteOperatorsInput = {
  _id?: InputMaybe<FilterCountNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterCountNoteUpdatedAtOperatorsInput>;
};

export type FilterCountNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterCountNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterCountNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterCountNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<EnumNotificationSettingTrigger>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterCountNotificationSetting_IdOperatorsInput>;
};

export type FilterCountNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterCountNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountPrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterCountPrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterCountPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalCutBlocker_IdOperatorsInput>;
};

export type FilterCountPrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCutInput = {
  AND?: InputMaybe<Array<FilterCountPrimalCutInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterCountPrimalCutPrimalOperatorsInput>;
};

export type FilterCountPrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterCountPrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterCountPrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterCountPrimalCutTypeNameOperatorsInput>;
};

export type FilterCountPrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalGroupInput = {
  AND?: InputMaybe<Array<FilterCountPrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterCountPrimalGroupOrderOperatorsInput>;
};

export type FilterCountPrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterCountPrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountPrimalInput = {
  AND?: InputMaybe<Array<FilterCountPrimalInput>>;
  OR?: InputMaybe<Array<FilterCountPrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountPrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountPrimalOperatorsInput = {
  _id?: InputMaybe<FilterCountPrimal_IdOperatorsInput>;
};

export type FilterCountPrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterCountProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterCountProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorCapability_IdOperatorsInput>;
};

export type FilterCountProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterCountProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterCountProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterCountProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterCountProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterCountProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorNotification_IdOperatorsInput>;
};

export type FilterCountProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterCountProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterCountProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterCountProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterCountProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterCountProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterCountProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterCountProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterCountProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterCountProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterCountProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountProcessorSchedulingNotificationHistoryErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterCountProcessorSchedulingNotificationHistoryInput = {
  errorMessage?: InputMaybe<FilterCountProcessorSchedulingNotificationHistoryErrorMessageInput>;
  notificationType?: InputMaybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterCountProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterCountProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterCountProcessorSchedulingStatusOperatorsInput>;
};

export type FilterCountProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterCountProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterCountProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterCountProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterCountDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterCountProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterCountProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterCountDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorSettingsCustomCapacity_IdOperatorsInput>;
};

export type FilterCountProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterCountProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterCountProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterCountProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterCountProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterCountProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterCountProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterCountProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterCountProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterCountProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterCountProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterCountProcessorSettingsVendorOperatorsInput>;
};

export type FilterCountProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterCountProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountStateInput = {
  AND?: InputMaybe<Array<FilterCountStateInput>>;
  OR?: InputMaybe<Array<FilterCountStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountStateOperatorsInput = {
  _id?: InputMaybe<FilterCountState_IdOperatorsInput>;
};

export type FilterCountState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountTenantInput = {
  AND?: InputMaybe<Array<FilterCountTenantInput>>;
  OR?: InputMaybe<Array<FilterCountTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountTenantOperatorsInput = {
  _id?: InputMaybe<FilterCountTenant_IdOperatorsInput>;
};

export type FilterCountTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserInput = {
  AND?: InputMaybe<Array<FilterCountUserInput>>;
  OR?: InputMaybe<Array<FilterCountUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterCountUserSettingsInput>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountUserOperatorsInput = {
  _id?: InputMaybe<FilterCountUser_IdOperatorsInput>;
  email?: InputMaybe<FilterCountUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterCountUserPhoneOperatorsInput>;
};

export type FilterCountUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterCountUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterCountUserSettingsInput = {
  calendar?: InputMaybe<FilterCountUserSettingsCalendarInput>;
};

export type FilterCountUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterCountVendorInput = {
  AND?: InputMaybe<Array<FilterCountVendorInput>>;
  OR?: InputMaybe<Array<FilterCountVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountVendorOperatorsInput>;
  address?: InputMaybe<FilterCountAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountVendorOperatorsInput = {
  _id?: InputMaybe<FilterCountVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterCountVendorDate_CreatedOperatorsInput>;
};

export type FilterCountVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterCountWaitlistInput = {
  AND?: InputMaybe<Array<FilterCountWaitlistInput>>;
  OR?: InputMaybe<Array<FilterCountWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterCountWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterCountWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterCountWaitlist_IdOperatorsInput>;
};

export type FilterCountWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterFindManyCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterFindManyCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterFindManyCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterFindManyCancellationReasonIndexOperatorsInput>;
};

export type FilterFindManyCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChatMessageInput = {
  AND?: InputMaybe<Array<FilterFindManyChatMessageInput>>;
  OR?: InputMaybe<Array<FilterFindManyChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChatMessage_IdOperatorsInput>;
};

export type FilterFindManyChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyChatRoomInput = {
  AND?: InputMaybe<Array<FilterFindManyChatRoomInput>>;
  OR?: InputMaybe<Array<FilterFindManyChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterFindManyChatRoom_IdOperatorsInput>;
};

export type FilterFindManyChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterFindManyCutsheetInput = {
  AND?: InputMaybe<Array<FilterFindManyCutsheetInput>>;
  OR?: InputMaybe<Array<FilterFindManyCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindManyCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterFindManyCutsheet_IdOperatorsInput>;
};

export type FilterFindManyCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterFindManyCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterFindManyDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterFindManyDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyIntegrationInput = {
  AND?: InputMaybe<Array<FilterFindManyIntegrationInput>>;
  OR?: InputMaybe<Array<FilterFindManyIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterFindManyIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyIntegrationVendorOperatorsInput>;
};

export type FilterFindManyIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyInvoiceInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindManyInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterFindManyInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterFindManyInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindManyInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterFindManyInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoiceLineItem_IdOperatorsInput>;
};

export type FilterFindManyInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterFindManyInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterFindManyInvoiceStatusOperatorsInput>;
};

export type FilterFindManyInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterFindManyInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterFindManyInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyModuleInput = {
  AND?: InputMaybe<Array<FilterFindManyModuleInput>>;
  OR?: InputMaybe<Array<FilterFindManyModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyModuleOperatorsInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyModuleOperatorsInput = {
  _id?: InputMaybe<FilterFindManyModule_IdOperatorsInput>;
};

export type FilterFindManyModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNoteInput = {
  AND?: InputMaybe<Array<FilterFindManyNoteInput>>;
  OR?: InputMaybe<Array<FilterFindManyNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindManyNoteUpdatedAtOperatorsInput>;
};

export type FilterFindManyNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterFindManyNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterFindManyNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterFindManyNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<EnumNotificationSettingTrigger>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyNotificationSetting_IdOperatorsInput>;
};

export type FilterFindManyNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterFindManyNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyPrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterFindManyPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalCutBlocker_IdOperatorsInput>;
};

export type FilterFindManyPrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCutInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalCutInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterFindManyPrimalCutPrimalOperatorsInput>;
};

export type FilterFindManyPrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindManyPrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterFindManyPrimalCutTypeNameOperatorsInput>;
};

export type FilterFindManyPrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalGroupInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterFindManyPrimalGroupOrderOperatorsInput>;
};

export type FilterFindManyPrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindManyPrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyPrimalInput = {
  AND?: InputMaybe<Array<FilterFindManyPrimalInput>>;
  OR?: InputMaybe<Array<FilterFindManyPrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyPrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyPrimalOperatorsInput = {
  _id?: InputMaybe<FilterFindManyPrimal_IdOperatorsInput>;
};

export type FilterFindManyPrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterFindManyProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorCapability_IdOperatorsInput>;
};

export type FilterFindManyProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterFindManyProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterFindManyProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorNotification_IdOperatorsInput>;
};

export type FilterFindManyProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterFindManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterFindManyProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterFindManyProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterFindManyProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterFindManyProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterFindManyProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterFindManyProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterFindManyProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterFindManyProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyProcessorSchedulingNotificationHistoryErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindManyProcessorSchedulingNotificationHistoryInput = {
  errorMessage?: InputMaybe<FilterFindManyProcessorSchedulingNotificationHistoryErrorMessageInput>;
  notificationType?: InputMaybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterFindManyProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterFindManyProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterFindManyProcessorSchedulingStatusOperatorsInput>;
};

export type FilterFindManyProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterFindManyProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterFindManyProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterFindManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindManyDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindManyProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindManyDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacity_IdOperatorsInput>;
};

export type FilterFindManyProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterFindManyProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterFindManyProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterFindManyProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterFindManyProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterFindManyProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterFindManyProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindManyProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindManyProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterFindManyProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindManyProcessorSettingsVendorOperatorsInput>;
};

export type FilterFindManyProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindManyProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyStateInput = {
  AND?: InputMaybe<Array<FilterFindManyStateInput>>;
  OR?: InputMaybe<Array<FilterFindManyStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyStateOperatorsInput = {
  _id?: InputMaybe<FilterFindManyState_IdOperatorsInput>;
};

export type FilterFindManyState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyTenantInput = {
  AND?: InputMaybe<Array<FilterFindManyTenantInput>>;
  OR?: InputMaybe<Array<FilterFindManyTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyTenantOperatorsInput = {
  _id?: InputMaybe<FilterFindManyTenant_IdOperatorsInput>;
};

export type FilterFindManyTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserInput = {
  AND?: InputMaybe<Array<FilterFindManyUserInput>>;
  OR?: InputMaybe<Array<FilterFindManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterFindManyUserSettingsInput>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyUserOperatorsInput = {
  _id?: InputMaybe<FilterFindManyUser_IdOperatorsInput>;
  email?: InputMaybe<FilterFindManyUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterFindManyUserPhoneOperatorsInput>;
};

export type FilterFindManyUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindManyUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindManyUserSettingsInput = {
  calendar?: InputMaybe<FilterFindManyUserSettingsCalendarInput>;
};

export type FilterFindManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindManyVendorInput = {
  AND?: InputMaybe<Array<FilterFindManyVendorInput>>;
  OR?: InputMaybe<Array<FilterFindManyVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyVendorOperatorsInput>;
  address?: InputMaybe<FilterFindManyAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyVendorOperatorsInput = {
  _id?: InputMaybe<FilterFindManyVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterFindManyVendorDate_CreatedOperatorsInput>;
};

export type FilterFindManyVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindManyWaitlistInput = {
  AND?: InputMaybe<Array<FilterFindManyWaitlistInput>>;
  OR?: InputMaybe<Array<FilterFindManyWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindManyWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindManyWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterFindManyWaitlist_IdOperatorsInput>;
};

export type FilterFindManyWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterFindOneCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindOneCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterFindOneCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterFindOneCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterFindOneCancellationReasonIndexOperatorsInput>;
};

export type FilterFindOneCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneChatMessageInput = {
  AND?: InputMaybe<Array<FilterFindOneChatMessageInput>>;
  OR?: InputMaybe<Array<FilterFindOneChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterFindOneChatMessage_IdOperatorsInput>;
};

export type FilterFindOneChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneChatRoomInput = {
  AND?: InputMaybe<Array<FilterFindOneChatRoomInput>>;
  OR?: InputMaybe<Array<FilterFindOneChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterFindOneChatRoom_IdOperatorsInput>;
};

export type FilterFindOneChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterFindOneCutsheetInput = {
  AND?: InputMaybe<Array<FilterFindOneCutsheetInput>>;
  OR?: InputMaybe<Array<FilterFindOneCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindOneCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterFindOneCutsheet_IdOperatorsInput>;
};

export type FilterFindOneCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterFindOneCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterFindOneDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterFindOneDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneIntegrationInput = {
  AND?: InputMaybe<Array<FilterFindOneIntegrationInput>>;
  OR?: InputMaybe<Array<FilterFindOneIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterFindOneIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneIntegrationVendorOperatorsInput>;
};

export type FilterFindOneIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneInvoiceInput = {
  AND?: InputMaybe<Array<FilterFindOneInvoiceInput>>;
  OR?: InputMaybe<Array<FilterFindOneInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindOneInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterFindOneInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterFindOneInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterFindOneInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterFindOneInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterFindOneInvoiceLineItem_IdOperatorsInput>;
};

export type FilterFindOneInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterFindOneInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterFindOneInvoiceStatusOperatorsInput>;
};

export type FilterFindOneInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterFindOneInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterFindOneInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneModuleInput = {
  AND?: InputMaybe<Array<FilterFindOneModuleInput>>;
  OR?: InputMaybe<Array<FilterFindOneModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneModuleOperatorsInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneModuleOperatorsInput = {
  _id?: InputMaybe<FilterFindOneModule_IdOperatorsInput>;
};

export type FilterFindOneModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNoteInput = {
  AND?: InputMaybe<Array<FilterFindOneNoteInput>>;
  OR?: InputMaybe<Array<FilterFindOneNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneNoteOperatorsInput = {
  _id?: InputMaybe<FilterFindOneNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterFindOneNoteUpdatedAtOperatorsInput>;
};

export type FilterFindOneNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterFindOneNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterFindOneNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterFindOneNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<EnumNotificationSettingTrigger>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneNotificationSetting_IdOperatorsInput>;
};

export type FilterFindOneNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterFindOneNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOnePrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterFindOnePrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalCutBlocker_IdOperatorsInput>;
};

export type FilterFindOnePrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCutInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalCutInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterFindOnePrimalCutPrimalOperatorsInput>;
};

export type FilterFindOnePrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterFindOnePrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterFindOnePrimalCutTypeNameOperatorsInput>;
};

export type FilterFindOnePrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalGroupInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterFindOnePrimalGroupOrderOperatorsInput>;
};

export type FilterFindOnePrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterFindOnePrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOnePrimalInput = {
  AND?: InputMaybe<Array<FilterFindOnePrimalInput>>;
  OR?: InputMaybe<Array<FilterFindOnePrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOnePrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOnePrimalOperatorsInput = {
  _id?: InputMaybe<FilterFindOnePrimal_IdOperatorsInput>;
};

export type FilterFindOnePrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterFindOneProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorCapability_IdOperatorsInput>;
};

export type FilterFindOneProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterFindOneProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterFindOneProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorNotification_IdOperatorsInput>;
};

export type FilterFindOneProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterFindOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterFindOneProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterFindOneProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterFindOneProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterFindOneProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterFindOneProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterFindOneProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterFindOneProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterFindOneProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneProcessorSchedulingNotificationHistoryErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterFindOneProcessorSchedulingNotificationHistoryInput = {
  errorMessage?: InputMaybe<FilterFindOneProcessorSchedulingNotificationHistoryErrorMessageInput>;
  notificationType?: InputMaybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterFindOneProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterFindOneProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterFindOneProcessorSchedulingStatusOperatorsInput>;
};

export type FilterFindOneProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterFindOneProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterFindOneProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterFindOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindOneDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterFindOneProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterFindOneDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacity_IdOperatorsInput>;
};

export type FilterFindOneProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterFindOneProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterFindOneProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterFindOneProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterFindOneProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterFindOneProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterFindOneProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterFindOneProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterFindOneProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterFindOneProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterFindOneProcessorSettingsVendorOperatorsInput>;
};

export type FilterFindOneProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterFindOneProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneStateInput = {
  AND?: InputMaybe<Array<FilterFindOneStateInput>>;
  OR?: InputMaybe<Array<FilterFindOneStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneStateOperatorsInput = {
  _id?: InputMaybe<FilterFindOneState_IdOperatorsInput>;
};

export type FilterFindOneState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneTenantInput = {
  AND?: InputMaybe<Array<FilterFindOneTenantInput>>;
  OR?: InputMaybe<Array<FilterFindOneTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneTenantOperatorsInput = {
  _id?: InputMaybe<FilterFindOneTenant_IdOperatorsInput>;
};

export type FilterFindOneTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserInput = {
  AND?: InputMaybe<Array<FilterFindOneUserInput>>;
  OR?: InputMaybe<Array<FilterFindOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterFindOneUserSettingsInput>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneUserOperatorsInput = {
  _id?: InputMaybe<FilterFindOneUser_IdOperatorsInput>;
  email?: InputMaybe<FilterFindOneUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterFindOneUserPhoneOperatorsInput>;
};

export type FilterFindOneUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterFindOneUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterFindOneUserSettingsInput = {
  calendar?: InputMaybe<FilterFindOneUserSettingsCalendarInput>;
};

export type FilterFindOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterFindOneVendorInput = {
  AND?: InputMaybe<Array<FilterFindOneVendorInput>>;
  OR?: InputMaybe<Array<FilterFindOneVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneVendorOperatorsInput>;
  address?: InputMaybe<FilterFindOneAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneVendorOperatorsInput = {
  _id?: InputMaybe<FilterFindOneVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterFindOneVendorDate_CreatedOperatorsInput>;
};

export type FilterFindOneVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterFindOneWaitlistInput = {
  AND?: InputMaybe<Array<FilterFindOneWaitlistInput>>;
  OR?: InputMaybe<Array<FilterFindOneWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterFindOneWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterFindOneWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterFindOneWaitlist_IdOperatorsInput>;
};

export type FilterFindOneWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterUpdateManyCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateManyCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterUpdateManyCancellationReasonIndexOperatorsInput>;
};

export type FilterUpdateManyCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyChatMessageInput = {
  AND?: InputMaybe<Array<FilterUpdateManyChatMessageInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyChatMessage_IdOperatorsInput>;
};

export type FilterUpdateManyChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyChatRoomInput = {
  AND?: InputMaybe<Array<FilterUpdateManyChatRoomInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyChatRoom_IdOperatorsInput>;
};

export type FilterUpdateManyChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterUpdateManyCutsheetInput = {
  AND?: InputMaybe<Array<FilterUpdateManyCutsheetInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateManyCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyCutsheet_IdOperatorsInput>;
};

export type FilterUpdateManyCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterUpdateManyCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterUpdateManyDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterUpdateManyDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyIntegrationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyIntegrationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterUpdateManyIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyIntegrationVendorOperatorsInput>;
};

export type FilterUpdateManyIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateManyInvoiceInput = {
  AND?: InputMaybe<Array<FilterUpdateManyInvoiceInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateManyInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateManyInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterUpdateManyInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateManyInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateManyInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyInvoiceLineItem_IdOperatorsInput>;
};

export type FilterUpdateManyInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyInvoiceStatusOperatorsInput>;
};

export type FilterUpdateManyInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterUpdateManyInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterUpdateManyInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyModuleInput = {
  AND?: InputMaybe<Array<FilterUpdateManyModuleInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyModuleOperatorsInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyModuleOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyModule_IdOperatorsInput>;
};

export type FilterUpdateManyModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNoteInput = {
  AND?: InputMaybe<Array<FilterUpdateManyNoteInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyNoteOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateManyNoteUpdatedAtOperatorsInput>;
};

export type FilterUpdateManyNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterUpdateManyNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterUpdateManyNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<EnumNotificationSettingTrigger>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyNotificationSetting_IdOperatorsInput>;
};

export type FilterUpdateManyNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterUpdateManyNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyPrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterUpdateManyPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalCutBlocker_IdOperatorsInput>;
};

export type FilterUpdateManyPrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCutInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalCutInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterUpdateManyPrimalCutPrimalOperatorsInput>;
};

export type FilterUpdateManyPrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterUpdateManyPrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterUpdateManyPrimalCutTypeNameOperatorsInput>;
};

export type FilterUpdateManyPrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterUpdateManyPrimalGroupOrderOperatorsInput>;
};

export type FilterUpdateManyPrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateManyPrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyPrimalInput = {
  AND?: InputMaybe<Array<FilterUpdateManyPrimalInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyPrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyPrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyPrimalOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyPrimal_IdOperatorsInput>;
};

export type FilterUpdateManyPrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterUpdateManyProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorCapability_IdOperatorsInput>;
};

export type FilterUpdateManyProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterUpdateManyProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterUpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorNotification_IdOperatorsInput>;
};

export type FilterUpdateManyProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterUpdateManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterUpdateManyProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterUpdateManyProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterUpdateManyProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterUpdateManyProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyProcessorSchedulingNotificationHistoryErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateManyProcessorSchedulingNotificationHistoryInput = {
  errorMessage?: InputMaybe<FilterUpdateManyProcessorSchedulingNotificationHistoryErrorMessageInput>;
  notificationType?: InputMaybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterUpdateManyProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateManyProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateManyProcessorSchedulingStatusOperatorsInput>;
};

export type FilterUpdateManyProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterUpdateManyProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterUpdateManyProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterUpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateManyDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateManyProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateManyDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacity_IdOperatorsInput>;
};

export type FilterUpdateManyProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterUpdateManyProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterUpdateManyProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterUpdateManyProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterUpdateManyProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterUpdateManyProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateManyProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateManyProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateManyProcessorSettingsVendorOperatorsInput>;
};

export type FilterUpdateManyProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateManyProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyStateInput = {
  AND?: InputMaybe<Array<FilterUpdateManyStateInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyStateOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyState_IdOperatorsInput>;
};

export type FilterUpdateManyState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyTenantInput = {
  AND?: InputMaybe<Array<FilterUpdateManyTenantInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyTenantOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyTenant_IdOperatorsInput>;
};

export type FilterUpdateManyTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyUserInput = {
  AND?: InputMaybe<Array<FilterUpdateManyUserInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterUpdateManyUserSettingsInput>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyUserOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyUser_IdOperatorsInput>;
  email?: InputMaybe<FilterUpdateManyUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterUpdateManyUserPhoneOperatorsInput>;
};

export type FilterUpdateManyUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateManyUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateManyUserSettingsInput = {
  calendar?: InputMaybe<FilterUpdateManyUserSettingsCalendarInput>;
};

export type FilterUpdateManyUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateManyVendorInput = {
  AND?: InputMaybe<Array<FilterUpdateManyVendorInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyVendorOperatorsInput>;
  address?: InputMaybe<FilterUpdateManyAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyVendorOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterUpdateManyVendorDate_CreatedOperatorsInput>;
};

export type FilterUpdateManyVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateManyWaitlistInput = {
  AND?: InputMaybe<Array<FilterUpdateManyWaitlistInput>>;
  OR?: InputMaybe<Array<FilterUpdateManyWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateManyWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateManyWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterUpdateManyWaitlist_IdOperatorsInput>;
};

export type FilterUpdateManyWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type FilterUpdateOneCancellationReasonIndexOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateOneCancellationReasonInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCancellationReasonInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCancellationReasonInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCancellationReasonOperatorsInput>;
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCancellationReasonOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCancellationReason_IdOperatorsInput>;
  index?: InputMaybe<FilterUpdateOneCancellationReasonIndexOperatorsInput>;
};

export type FilterUpdateOneCancellationReason_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneChatMessageInput = {
  AND?: InputMaybe<Array<FilterUpdateOneChatMessageInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneChatMessageInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneChatMessageOperatorsInput>;
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneChatMessageOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneChatMessage_IdOperatorsInput>;
};

export type FilterUpdateOneChatMessage_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneChatRoomInput = {
  AND?: InputMaybe<Array<FilterUpdateOneChatRoomInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneChatRoomInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneChatRoomOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneChatRoomOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneChatRoom_IdOperatorsInput>;
};

export type FilterUpdateOneChatRoom_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type FilterUpdateOneCutsheetInput = {
  AND?: InputMaybe<Array<FilterUpdateOneCutsheetInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneCutsheetInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneCutsheetOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateOneCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneCutsheetOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneCutsheet_IdOperatorsInput>;
};

export type FilterUpdateOneCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type FilterUpdateOneCutsheet_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type FilterUpdateOneDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<FilterUpdateOneDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneIntegrationEndpointOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneIntegrationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneIntegrationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneIntegrationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneIntegrationOperatorsInput>;
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneIntegrationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneIntegration_IdOperatorsInput>;
  endpoint?: InputMaybe<FilterUpdateOneIntegrationEndpointOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneIntegrationVendorOperatorsInput>;
};

export type FilterUpdateOneIntegrationVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneIntegration_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateOneInvoiceInput = {
  AND?: InputMaybe<Array<FilterUpdateOneInvoiceInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneInvoiceInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneInvoiceOperatorsInput>;
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateOneInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateOneInvoiceLineItemInput = {
  AND?: InputMaybe<Array<FilterUpdateOneInvoiceLineItemInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneInvoiceLineItemInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneInvoiceLineItemOperatorsInput>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<FilterUpdateOneInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<FilterUpdateOneInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneInvoiceLineItemOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneInvoiceLineItem_IdOperatorsInput>;
};

export type FilterUpdateOneInvoiceLineItem_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneInvoiceOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneInvoice_IdOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneInvoiceStatusOperatorsInput>;
};

export type FilterUpdateOneInvoiceStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumInvoiceStatus>;
  gte?: InputMaybe<EnumInvoiceStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
  lt?: InputMaybe<EnumInvoiceStatus>;
  lte?: InputMaybe<EnumInvoiceStatus>;
  ne?: InputMaybe<EnumInvoiceStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumInvoiceStatus>>>;
};

export type FilterUpdateOneInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type FilterUpdateOneInvoice_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneModuleInput = {
  AND?: InputMaybe<Array<FilterUpdateOneModuleInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneModuleInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneModuleOperatorsInput>;
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneModuleOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneModule_IdOperatorsInput>;
};

export type FilterUpdateOneModule_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNoteInput = {
  AND?: InputMaybe<Array<FilterUpdateOneNoteInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneNoteInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneNoteOperatorsInput>;
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneNoteOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneNote_IdOperatorsInput>;
  updatedAt?: InputMaybe<FilterUpdateOneNoteUpdatedAtOperatorsInput>;
};

export type FilterUpdateOneNoteUpdatedAtOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneNote_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneNotificationSettingInput = {
  AND?: InputMaybe<Array<FilterUpdateOneNotificationSettingInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneNotificationSettingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneNotificationSettingOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<FilterUpdateOneNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<EnumNotificationSettingTrigger>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneNotificationSettingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneNotificationSetting_IdOperatorsInput>;
};

export type FilterUpdateOneNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type FilterUpdateOneNotificationSetting_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOnePrimalCutBlockerInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalCutBlockerInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalCutBlockerInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalCutBlockerOperatorsInput>;
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<FilterUpdateOnePrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalCutBlockerOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalCutBlocker_IdOperatorsInput>;
};

export type FilterUpdateOnePrimalCutBlocker_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCutInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalCutInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalCutInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalCutOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalCutOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalCut_IdOperatorsInput>;
  primal?: InputMaybe<FilterUpdateOnePrimalCutPrimalOperatorsInput>;
};

export type FilterUpdateOnePrimalCutPrimalOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCutTypeInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalCutTypeInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalCutTypeInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalCutTypeOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterUpdateOnePrimalCutTypeNameOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalCutTypeOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalCutType_IdOperatorsInput>;
  name?: InputMaybe<FilterUpdateOnePrimalCutTypeNameOperatorsInput>;
};

export type FilterUpdateOnePrimalCutType_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalCut_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalGroupInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalGroupInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalGroupInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalGroupOperatorsInput>;
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalGroupOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimalGroup_IdOperatorsInput>;
  order?: InputMaybe<FilterUpdateOnePrimalGroupOrderOperatorsInput>;
};

export type FilterUpdateOnePrimalGroupOrderOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type FilterUpdateOnePrimalGroup_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOnePrimalInput = {
  AND?: InputMaybe<Array<FilterUpdateOnePrimalInput>>;
  OR?: InputMaybe<Array<FilterUpdateOnePrimalInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOnePrimalOperatorsInput>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOnePrimalOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOnePrimal_IdOperatorsInput>;
};

export type FilterUpdateOnePrimal_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type FilterUpdateOneProcessorCapabilityInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorCapabilityInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorCapabilityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorCapabilityOperatorsInput>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorCapabilityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorCapability_IdOperatorsInput>;
};

export type FilterUpdateOneProcessorCapabilitySpecificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorCapabilitySpecificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorCapabilitySpecificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationOperatorsInput>;
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorCapabilitySpecificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorCapabilitySpecification_IdOperatorsInput>;
};

export type FilterUpdateOneProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type FilterUpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorCapabilitySpecification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorCapability_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorNotificationInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorNotificationInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorNotificationInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorNotificationOperatorsInput>;
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorNotificationOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorNotification_IdOperatorsInput>;
};

export type FilterUpdateOneProcessorNotification_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type FilterUpdateOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<FilterUpdateOneProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingDropoffDateOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneProcessorSchedulingInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorSchedulingInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorSchedulingInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorSchedulingOperatorsInput>;
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<FilterUpdateOneProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSchedulingInvoicesPricingInput>>>;
};

export type FilterUpdateOneProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type FilterUpdateOneProcessorSchedulingJobIdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneProcessorSchedulingNotificationHistoryErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUpdateOneProcessorSchedulingNotificationHistoryInput = {
  errorMessage?: InputMaybe<FilterUpdateOneProcessorSchedulingNotificationHistoryErrorMessageInput>;
  notificationType?: InputMaybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorSchedulingOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorScheduling_IdOperatorsInput>;
  dropoffDate?: InputMaybe<FilterUpdateOneProcessorSchedulingDropoffDateOperatorsInput>;
  jobId?: InputMaybe<FilterUpdateOneProcessorSchedulingJobIdOperatorsInput>;
  status?: InputMaybe<FilterUpdateOneProcessorSchedulingStatusOperatorsInput>;
};

export type FilterUpdateOneProcessorSchedulingStatusOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<EnumProcessorSchedulingStatus>;
  gte?: InputMaybe<EnumProcessorSchedulingStatus>;
  in?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
  lt?: InputMaybe<EnumProcessorSchedulingStatus>;
  lte?: InputMaybe<EnumProcessorSchedulingStatus>;
  ne?: InputMaybe<EnumProcessorSchedulingStatus>;
  nin?: InputMaybe<Array<InputMaybe<EnumProcessorSchedulingStatus>>>;
};

export type FilterUpdateOneProcessorScheduling_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type FilterUpdateOneProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type FilterUpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateOneDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterUpdateOneProcessorSettingsCustomCapacityInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorSettingsCustomCapacityInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorSettingsCustomCapacityInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacityOperatorsInput>;
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<FilterUpdateOneDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorSettingsCustomCapacityOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacity_IdOperatorsInput>;
};

export type FilterUpdateOneProcessorSettingsCustomCapacity_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type FilterUpdateOneProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type FilterUpdateOneProcessorSettingsInput = {
  AND?: InputMaybe<Array<FilterUpdateOneProcessorSettingsInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneProcessorSettingsInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneProcessorSettingsOperatorsInput>;
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<FilterUpdateOneProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<FilterUpdateOneProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<FilterUpdateOneProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type FilterUpdateOneProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneProcessorSettingsOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneProcessorSettings_IdOperatorsInput>;
  vendor?: InputMaybe<FilterUpdateOneProcessorSettingsVendorOperatorsInput>;
};

export type FilterUpdateOneProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterUpdateOneProcessorSettingsVendorOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneProcessorSettings_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneStateInput = {
  AND?: InputMaybe<Array<FilterUpdateOneStateInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneStateInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneStateOperatorsInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneStateOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneState_IdOperatorsInput>;
};

export type FilterUpdateOneState_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneTenantInput = {
  AND?: InputMaybe<Array<FilterUpdateOneTenantInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneTenantInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneTenantOperatorsInput>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneTenantOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneTenant_IdOperatorsInput>;
};

export type FilterUpdateOneTenant_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneUserEmailOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUserInput = {
  AND?: InputMaybe<Array<FilterUpdateOneUserInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneUserInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneUserOperatorsInput>;
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<FilterUpdateOneUserSettingsInput>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneUserOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneUser_IdOperatorsInput>;
  email?: InputMaybe<FilterUpdateOneUserEmailOperatorsInput>;
  phone?: InputMaybe<FilterUpdateOneUserPhoneOperatorsInput>;
};

export type FilterUpdateOneUserPhoneOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['RegExpAsString']['input']>;
};

export type FilterUpdateOneUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterUpdateOneUserSettingsInput = {
  calendar?: InputMaybe<FilterUpdateOneUserSettingsCalendarInput>;
};

export type FilterUpdateOneUser_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneVendorDate_CreatedOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type FilterUpdateOneVendorInput = {
  AND?: InputMaybe<Array<FilterUpdateOneVendorInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneVendorInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneVendorOperatorsInput>;
  address?: InputMaybe<FilterUpdateOneAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneVendorOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneVendor_IdOperatorsInput>;
  date_created?: InputMaybe<FilterUpdateOneVendorDate_CreatedOperatorsInput>;
};

export type FilterUpdateOneVendor_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type FilterUpdateOneWaitlistInput = {
  AND?: InputMaybe<Array<FilterUpdateOneWaitlistInput>>;
  OR?: InputMaybe<Array<FilterUpdateOneWaitlistInput>>;
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  /** List of *indexed* fields that can be filtered via operators. */
  _operators?: InputMaybe<FilterUpdateOneWaitlistOperatorsInput>;
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

/** For performance reason this type contains only *indexed* fields. */
export type FilterUpdateOneWaitlistOperatorsInput = {
  _id?: InputMaybe<FilterUpdateOneWaitlist_IdOperatorsInput>;
};

export type FilterUpdateOneWaitlist_IdOperatorsInput = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['MongoID']['input']>;
  gte?: InputMaybe<Scalars['MongoID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  lt?: InputMaybe<Scalars['MongoID']['input']>;
  lte?: InputMaybe<Scalars['MongoID']['input']>;
  ne?: InputMaybe<Scalars['MongoID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
};

export type GenerateBillingStatementResponse = {
  __typename?: 'GenerateBillingStatementResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateCarcassTagsResponse = {
  __typename?: 'GenerateCarcassTagsResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateCsvResponse = {
  __typename?: 'GenerateCsvResponse';
  errors: Array<Maybe<Scalars['String']['output']>>;
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GenerateCutsheetResponse = {
  __typename?: 'GenerateCutsheetResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateHangingWeightCsvResponse = {
  __typename?: 'GenerateHangingWeightCsvResponse';
  errors: Array<Maybe<Scalars['String']['output']>>;
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export type GenerateInvoicePdfResponse = {
  __typename?: 'GenerateInvoicePdfResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type GenerateKillSheetResponse = {
  __typename?: 'GenerateKillSheetResponse';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  file?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type Integration = {
  __typename?: 'Integration';
  _id: Scalars['MongoID']['output'];
  config?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  endpoint?: Maybe<Scalars['String']['output']>;
  isSyncing?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lastSynced?: Maybe<Scalars['Date']['output']>;
  name: EnumIntegrationName;
  secret?: Maybe<Scalars['String']['output']>;
  type: EnumIntegrationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
};

/** List of items with pagination. */
export type IntegrationPagination = {
  __typename?: 'IntegrationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Integration>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Invoice = {
  __typename?: 'Invoice';
  _id: Scalars['MongoID']['output'];
  amount_discounted?: Maybe<Scalars['Float']['output']>;
  amount_due: Scalars['Float']['output'];
  amount_paid: Scalars['Float']['output'];
  amount_refunded?: Maybe<Scalars['Float']['output']>;
  billing_month?: Maybe<Scalars['Float']['output']>;
  billing_year?: Maybe<Scalars['Float']['output']>;
  date_created: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  discounts?: Maybe<Array<Maybe<InvoiceDiscounts>>>;
  due_date: Scalars['Date']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_links?: Maybe<InvoiceExternal_Links>;
  line_items: Array<InvoiceLineItem>;
  links?: Maybe<Array<Maybe<InvoiceLinks>>>;
  linksWithEntities?: Maybe<Array<Maybe<InvoiceLinks>>>;
  number?: Maybe<Scalars['String']['output']>;
  status: EnumInvoiceStatus;
  status_changes?: Maybe<Array<Maybe<InvoiceStatus_Changes>>>;
  type: EnumInvoiceType;
  user?: Maybe<User>;
  vendor?: Maybe<Vendor>;
};


export type InvoiceLine_ItemsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceLineItemInput>;
};

export type InvoiceDiscounts = {
  __typename?: 'InvoiceDiscounts';
  _id?: Maybe<Scalars['MongoID']['output']>;
  applied_amount: Scalars['Float']['output'];
  coupon_code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  type: EnumInvoiceDiscountsType;
  value: Scalars['Float']['output'];
};

export type InvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount: Scalars['Float']['input'];
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type: EnumInvoiceDiscountsType;
  value: Scalars['Float']['input'];
};

export type InvoiceExternal_Links = {
  __typename?: 'InvoiceExternal_links';
  _id?: Maybe<Scalars['MongoID']['output']>;
  quickbooks?: Maybe<Scalars['JSON']['output']>;
  stripe?: Maybe<Scalars['JSON']['output']>;
};

export type InvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  _id: Scalars['MongoID']['output'];
  amount: Scalars['Float']['output'];
  description: Scalars['String']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_links?: Maybe<InvoiceLineItemExternal_Links>;
  invoice?: Maybe<Invoice>;
  links?: Maybe<Array<Maybe<InvoiceLineItemLinks>>>;
  quantity: Scalars['Float']['output'];
};

export type InvoiceLineItemExternal_Links = {
  __typename?: 'InvoiceLineItemExternal_links';
  _id?: Maybe<Scalars['MongoID']['output']>;
  quickbooks?: Maybe<Scalars['JSON']['output']>;
  stripe?: Maybe<Scalars['JSON']['output']>;
};

export type InvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type InvoiceLineItemLinks = {
  __typename?: 'InvoiceLineItemLinks';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  entityType: EnumInvoiceLineItemLinksEntityType;
  parentEntityId: Scalars['MongoID']['output'];
  subEntityId?: Maybe<Scalars['MongoID']['output']>;
};

export type InvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  entityType: EnumInvoiceLineItemLinksEntityType;
  parentEntityId: Scalars['MongoID']['input'];
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** List of items with pagination. */
export type InvoiceLineItemPagination = {
  __typename?: 'InvoiceLineItemPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<InvoiceLineItem>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type InvoiceLinks = {
  __typename?: 'InvoiceLinks';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description: Scalars['String']['output'];
  /** The linked entity (ProcessorScheduling, AnimalHead, or Cutsheet) */
  entity?: Maybe<Scalars['JSON']['output']>;
  entityType: EnumInvoiceLinksEntityType;
  parentEntityId: Scalars['MongoID']['output'];
  subEntityId?: Maybe<Scalars['MongoID']['output']>;
};

export type InvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description: Scalars['String']['input'];
  entityType: EnumInvoiceLinksEntityType;
  parentEntityId: Scalars['MongoID']['input'];
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

/** List of items with pagination. */
export type InvoicePagination = {
  __typename?: 'InvoicePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Invoice>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type InvoiceStatus_Changes = {
  __typename?: 'InvoiceStatus_changes';
  _id?: Maybe<Scalars['MongoID']['output']>;
  date: Scalars['Date']['output'];
  new_status: EnumInvoiceStatus_ChangesNew_Status;
  previous_status: EnumInvoiceStatus_ChangesPrevious_Status;
};

export type InvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date: Scalars['Date']['input'];
  new_status: EnumInvoiceStatus_ChangesNew_Status;
  previous_status: EnumInvoiceStatus_ChangesPrevious_Status;
};

export type InvoiceUpdateLineItemInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount: Scalars['Float']['input'];
  description: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type MarkAsPaidInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['MongoID']['input'];
};

export type Module = {
  __typename?: 'Module';
  _id: Scalars['MongoID']['output'];
  href: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
};

/** List of items with pagination. */
export type ModulePagination = {
  __typename?: 'ModulePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Module>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type MongoError = ErrorInterface & {
  __typename?: 'MongoError';
  /** MongoDB error code */
  code?: Maybe<Scalars['Int']['output']>;
  /** MongoDB error message */
  message?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  addressCreateMany?: Maybe<CreateManyAddressPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  addressCreateOne?: Maybe<CreateOneAddressPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  addressUpdateById?: Maybe<UpdateByIdAddressPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  addressUpdateMany?: Maybe<UpdateManyAddressPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  addressUpdateOne?: Maybe<UpdateOneAddressPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cancellationReasonCreateMany?: Maybe<CreateManyCancellationReasonPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cancellationReasonCreateOne?: Maybe<CreateOneCancellationReasonPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cancellationReasonUpdateById?: Maybe<UpdateByIdCancellationReasonPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cancellationReasonUpdateMany?: Maybe<UpdateManyCancellationReasonPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cancellationReasonUpdateOne?: Maybe<UpdateOneCancellationReasonPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  chatMessageCreateMany?: Maybe<CreateManyChatMessagePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  chatMessageCreateOne?: Maybe<CreateOneChatMessagePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  chatMessageUpdateById?: Maybe<UpdateByIdChatMessagePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  chatMessageUpdateMany?: Maybe<UpdateManyChatMessagePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  chatMessageUpdateOne?: Maybe<UpdateOneChatMessagePayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  chatRoomCreateMany?: Maybe<CreateManyChatRoomPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  chatRoomCreateOne?: Maybe<CreateOneChatRoomPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  chatRoomUpdateById?: Maybe<UpdateByIdChatRoomPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  chatRoomUpdateMany?: Maybe<UpdateManyChatRoomPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  chatRoomUpdateOne?: Maybe<UpdateOneChatRoomPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  cutsheetCreateMany?: Maybe<CreateManyCutsheetPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  cutsheetCreateOne?: Maybe<CreateOneCutsheetPayload>;
  /** Soft delete of cutsheet */
  cutsheetSoftDelete?: Maybe<Cutsheet>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetUpdateById?: Maybe<UpdateByIdCutsheetPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  cutsheetUpdateMany?: Maybe<UpdateManyCutsheetPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  cutsheetUpdateOne?: Maybe<UpdateOneCutsheetPayload>;
  /** Upsert cutsheet for an animal type. */
  cutsheetUpsert?: Maybe<Cutsheet>;
  deleteDuplicatePrimals?: Maybe<DeleteDuplicatePrimalsPayload>;
  /** Generates a PDF for the specified invoice ID. */
  generateInvoicePdf?: Maybe<GenerateInvoicePdfResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  integrationCreateMany?: Maybe<CreateManyIntegrationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  integrationCreateOne?: Maybe<CreateOneIntegrationPayload>;
  /** Init integration. */
  integrationInit?: Maybe<Integration>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  integrationUpdateById?: Maybe<UpdateByIdIntegrationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  integrationUpdateMany?: Maybe<UpdateManyIntegrationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  integrationUpdateOne?: Maybe<UpdateOneIntegrationPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  invoiceCreateMany?: Maybe<CreateManyInvoicePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  invoiceCreateOne?: Maybe<CreateOneInvoicePayload>;
  /** Finalize and send an invoice */
  invoiceFinalizeAndSend?: Maybe<Invoice>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  invoiceLineItemCreateMany?: Maybe<CreateManyInvoiceLineItemPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  invoiceLineItemCreateOne?: Maybe<CreateOneInvoiceLineItemPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceLineItemUpdateById?: Maybe<UpdateByIdInvoiceLineItemPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  invoiceLineItemUpdateMany?: Maybe<UpdateManyInvoiceLineItemPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceLineItemUpdateOne?: Maybe<UpdateOneInvoiceLineItemPayload>;
  /** Mark an invoice as paid */
  invoiceMarkAsPaid?: Maybe<Invoice>;
  /** Refund an invoice (full or partial) */
  invoiceRefund?: Maybe<Invoice>;
  /** Update an existing invoice */
  invoiceUpdate?: Maybe<Invoice>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceUpdateById?: Maybe<UpdateByIdInvoicePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  invoiceUpdateMany?: Maybe<UpdateManyInvoicePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  invoiceUpdateOne?: Maybe<UpdateOneInvoicePayload>;
  /** Void an invoice */
  invoiceVoid?: Maybe<Invoice>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  moduleCreateMany?: Maybe<CreateManyModulePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  moduleCreateOne?: Maybe<CreateOneModulePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  moduleUpdateById?: Maybe<UpdateByIdModulePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  moduleUpdateMany?: Maybe<UpdateManyModulePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  moduleUpdateOne?: Maybe<UpdateOneModulePayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  noteCreateMany?: Maybe<CreateManyNotePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  noteCreateOne?: Maybe<CreateOneNotePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  noteUpdateById?: Maybe<UpdateByIdNotePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  noteUpdateMany?: Maybe<UpdateManyNotePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  noteUpdateOne?: Maybe<UpdateOneNotePayload>;
  /** Upsert a note for a processor scheduling. */
  noteUpsert?: Maybe<Note>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  notificationSettingsCreateMany?: Maybe<CreateManyNotificationSettingPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  notificationSettingsCreateOne?: Maybe<CreateOneNotificationSettingPayload>;
  /** Update notification settings by ID */
  notificationSettingsUpdate?: Maybe<NotificationSetting>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationSettingsUpdateById?: Maybe<UpdateByIdNotificationSettingPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  notificationSettingsUpdateMany?: Maybe<UpdateManyNotificationSettingPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  notificationSettingsUpdateOne?: Maybe<UpdateOneNotificationSettingPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCreateMany?: Maybe<CreateManyPrimalPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCreateOne?: Maybe<CreateOnePrimalPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCutBlockerCreateMany?: Maybe<CreateManyPrimalCutBlockerPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCutBlockerCreateOne?: Maybe<CreateOnePrimalCutBlockerPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutBlockerUpdateById?: Maybe<UpdateByIdPrimalCutBlockerPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalCutBlockerUpdateMany?: Maybe<UpdateManyPrimalCutBlockerPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutBlockerUpdateOne?: Maybe<UpdateOnePrimalCutBlockerPayload>;
  /** Upsert a primal cut blocker */
  primalCutBlockerUpsert?: Maybe<PrimalCutBlocker>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCutCreateMany?: Maybe<CreateManyPrimalCutPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCutCreateOne?: Maybe<CreateOnePrimalCutPayload>;
  /** Soft delete of primal cut */
  primalCutSoftDelete?: Maybe<PrimalCut>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalCutTypeCreateMany?: Maybe<CreateManyPrimalCutTypePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalCutTypeCreateOne?: Maybe<CreateOnePrimalCutTypePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutTypeUpdateById?: Maybe<UpdateByIdPrimalCutTypePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalCutTypeUpdateMany?: Maybe<UpdateManyPrimalCutTypePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutTypeUpdateOne?: Maybe<UpdateOnePrimalCutTypePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutUpdateById?: Maybe<UpdateByIdPrimalCutPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalCutUpdateMany?: Maybe<UpdateManyPrimalCutPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalCutUpdateOne?: Maybe<UpdateOnePrimalCutPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  primalGroupCreateMany?: Maybe<CreateManyPrimalGroupPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  primalGroupCreateOne?: Maybe<CreateOnePrimalGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalGroupUpdateById?: Maybe<UpdateByIdPrimalGroupPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalGroupUpdateMany?: Maybe<UpdateManyPrimalGroupPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalGroupUpdateOne?: Maybe<UpdateOnePrimalGroupPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalUpdateById?: Maybe<UpdateByIdPrimalPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  primalUpdateMany?: Maybe<UpdateManyPrimalPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  primalUpdateOne?: Maybe<UpdateOnePrimalPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processingPartnersCreateMany?: Maybe<CreateManyProcessorSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processingPartnersCreateOne?: Maybe<CreateOneProcessorSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processingPartnersOneCreateMany?: Maybe<CreateManyProcessorSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processingPartnersOneCreateOne?: Maybe<CreateOneProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersOneUpdateById?: Maybe<UpdateByIdProcessorSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processingPartnersOneUpdateMany?: Maybe<UpdateManyProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersOneUpdateOne?: Maybe<UpdateOneProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersUpdateById?: Maybe<UpdateByIdProcessorSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processingPartnersUpdateMany?: Maybe<UpdateManyProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processingPartnersUpdateOne?: Maybe<UpdateOneProcessorSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorCapabilityCreateMany?: Maybe<CreateManyProcessorCapabilityPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorCapabilityCreateOne?: Maybe<CreateOneProcessorCapabilityPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorCapabilitySpecificationCreateMany?: Maybe<CreateManyProcessorCapabilitySpecificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorCapabilitySpecificationCreateOne?: Maybe<CreateOneProcessorCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilitySpecificationUpdateById?: Maybe<UpdateByIdProcessorCapabilitySpecificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorCapabilitySpecificationUpdateMany?: Maybe<UpdateManyProcessorCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilitySpecificationUpdateOne?: Maybe<UpdateOneProcessorCapabilitySpecificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilityUpdateById?: Maybe<UpdateByIdProcessorCapabilityPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorCapabilityUpdateMany?: Maybe<UpdateManyProcessorCapabilityPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorCapabilityUpdateOne?: Maybe<UpdateOneProcessorCapabilityPayload>;
  /** Upsert processor capabilities for an animal type. */
  processorCapabilityUpsert?: Maybe<ProcessorCapability>;
  /** Exports a CSV for a vendor. */
  processorExportCsv?: Maybe<ProcessorExportCsvResponse>;
  /** Generates CSV for a vendor. */
  processorExportCsvByVendorId?: Maybe<ProcessorExportCsvResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorNotificationCreateMany?: Maybe<CreateManyProcessorNotificationPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorNotificationCreateOne?: Maybe<CreateOneProcessorNotificationPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorNotificationUpdateById?: Maybe<UpdateByIdProcessorNotificationPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorNotificationUpdateMany?: Maybe<UpdateManyProcessorNotificationPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorNotificationUpdateOne?: Maybe<UpdateOneProcessorNotificationPayload>;
  /** Bulk update of animal heads on a particular processing job. */
  processorSchedulingAnimalHeadBulkUpdate?: Maybe<ProcessorSchedulingPartialUpdateResponse>;
  /** Delete an animal head from a scheduled job. */
  processorSchedulingAnimalHeadDelete?: Maybe<ProcessorScheduling>;
  /** Partial update of a single animal head on a particular processing job. */
  processorSchedulingAnimalHeadPartialUpdateById?: Maybe<ProcessorSchedulingPartialUpdateResponse>;
  /** Create a new processor scheduling. */
  processorSchedulingCreate?: Maybe<CreateProcessorScheduleResponse>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorSchedulingCreateMany?: Maybe<CreateManyProcessorSchedulingPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorSchedulingCreateOne?: Maybe<CreateOneProcessorSchedulingPayload>;
  processorSchedulingCutsheetReminder?: Maybe<ProcessorScheduling>;
  /** Update the dropoff date, cut date, and kill date, if exists, for a processor scheduling job. This is only used for the calendar drag and drop feature. */
  processorSchedulingDragAndDropUpdate?: Maybe<ProcessorScheduling>;
  /** Generates the billing statement for the proceessing job and returns it to be downloaded. */
  processorSchedulingGenerateBillingStatement?: Maybe<GenerateBillingStatementResponse>;
  /** Generates carcass tag pdfs for a scheduled job or specific animal heads in the job. */
  processorSchedulingGenerateCarcassTags?: Maybe<GenerateCarcassTagsResponse>;
  /** Generates CSV for a vendor. */
  processorSchedulingGenerateCsvByVendorId?: Maybe<GenerateCsvResponse>;
  /** Generates the cutsheet pdf(s) for a scheduled job and cutsheet request. */
  processorSchedulingGenerateCutsheetRequest?: Maybe<GenerateCutsheetResponse>;
  /** Generates CSV for a vendor for hanging weights. */
  processorSchedulingGenerateHangingWeightCsv?: Maybe<GenerateHangingWeightCsvResponse>;
  /** Generates kill sheet pdf for the selected date. */
  processorSchedulingGenerateKillSheet?: Maybe<GenerateKillSheetResponse>;
  /** Manually send out an email. You will have to give us the type and the right information. */
  processorSchedulingNotificationSend?: Maybe<ProcessorScheduling>;
  /** Partial update of a single processor scheduling job with support for adding new animal heads */
  processorSchedulingPartialUpdateById?: Maybe<ProcessorSchedulingPartialUpdateResponse>;
  /** Update the split type and contact information for a specific animal head on a processor scheduling. */
  processorSchedulingSplitTypeUpdateById?: Maybe<ProcessorSchedulingSplitTypeUpdateResponse>;
  /** Update a processor scheduling job */
  processorSchedulingUpdate?: Maybe<UpdateByIdProcessorSchedulingPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSchedulingUpdateById?: Maybe<UpdateByIdProcessorSchedulingPayload>;
  /** Partial update of cutsheets associated to a processor scheduling */
  processorSchedulingUpdateCutsheets?: Maybe<UpdateByIdProcessorSchedulingPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorSchedulingUpdateMany?: Maybe<UpdateManyProcessorSchedulingPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSchedulingUpdateOne?: Maybe<UpdateOneProcessorSchedulingPayload>;
  /** Add new processor settings to the partners platform. Can include custom capacities for specific days. */
  processorSettingsCreate?: Maybe<CreateProcessorSettingsWithCustomCapacity>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorSettingsCreateMany?: Maybe<CreateManyProcessorSettingsPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorSettingsCreateOne?: Maybe<CreateOneProcessorSettingsPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  processorSettingsCustomCapacityCreateMany?: Maybe<CreateManyProcessorSettingsCustomCapacityPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  processorSettingsCustomCapacityCreateOne?: Maybe<CreateOneProcessorSettingsCustomCapacityPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsCustomCapacityUpdateById?: Maybe<UpdateByIdProcessorSettingsCustomCapacityPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorSettingsCustomCapacityUpdateMany?: Maybe<UpdateManyProcessorSettingsCustomCapacityPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsCustomCapacityUpdateOne?: Maybe<UpdateOneProcessorSettingsCustomCapacityPayload>;
  /** Update processor settings to the partners platform. Supports customized day scheduling updates. */
  processorSettingsUpdate?: Maybe<UpdateProcessorSettingsWithCustomCapacity>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsUpdateById?: Maybe<UpdateByIdProcessorSettingsPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  processorSettingsUpdateMany?: Maybe<UpdateManyProcessorSettingsPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  processorSettingsUpdateOne?: Maybe<UpdateOneProcessorSettingsPayload>;
  /** Sending message between customer and processor */
  sendMessage?: Maybe<ChatMessage>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  stateCreateMany?: Maybe<CreateManyStatePayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  stateCreateOne?: Maybe<CreateOneStatePayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  stateUpdateById?: Maybe<UpdateByIdStatePayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  stateUpdateMany?: Maybe<UpdateManyStatePayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  stateUpdateOne?: Maybe<UpdateOneStatePayload>;
  /** Create an stripe account for active_vendor. */
  stripeAccountCreate?: Maybe<Vendor>;
  /** Create an stripe session for active_vendor. */
  stripeSessionCreate?: Maybe<Vendor>;
  /** Add new tenant to Partners platform. */
  tenantCreate?: Maybe<Tenant>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  tenantCreateMany?: Maybe<CreateManyTenantPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  tenantCreateOne?: Maybe<CreateOneTenantPayload>;
  /** Modify tenant modules on the Partners platform. */
  tenantModulesEdit?: Maybe<Tenant>;
  /** Modify tenant picture_url. */
  tenantPictureUrlEdit?: Maybe<Tenant>;
  /** Modify tenant subscription on the Partners platform. */
  tenantSubscriptionEdit?: Maybe<Tenant>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tenantUpdateById?: Maybe<UpdateByIdTenantPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  tenantUpdateMany?: Maybe<UpdateManyTenantPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  tenantUpdateOne?: Maybe<UpdateOneTenantPayload>;
  /** Activate user on Partners platform. */
  userActivate?: Maybe<User>;
  /** Add new user to Partners platform. */
  userCreate?: Maybe<User>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  userCreateMany?: Maybe<CreateManyUserPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  userCreateOne?: Maybe<CreateOneUserPayload>;
  /** Deactivate user on Partners platform. */
  userDeactivate?: Maybe<User>;
  /** Update the current authenticated user's settings. */
  userSettingsUpdate?: Maybe<User>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  userUpdateById?: Maybe<UpdateByIdUserPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  userUpdateMany?: Maybe<UpdateManyUserPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  userUpdateOne?: Maybe<UpdateOneUserPayload>;
  /** Add new vendor to Partners platform. */
  vendorCreate?: Maybe<Vendor>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  vendorCreateMany?: Maybe<CreateManyVendorPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  vendorCreateOne?: Maybe<CreateOneVendorPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  vendorUpdateById?: Maybe<UpdateByIdVendorPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  vendorUpdateMany?: Maybe<UpdateManyVendorPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  vendorUpdateOne?: Maybe<UpdateOneVendorPayload>;
  waitlistAdd?: Maybe<Waitlist>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  waitlistCreateMany?: Maybe<CreateManyWaitlistPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  waitlistCreateOne?: Maybe<CreateOneWaitlistPayload>;
  waitlistDelete?: Maybe<Waitlist>;
  waitlistUnsubscribe?: Maybe<Waitlist>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  waitlistUpdateById?: Maybe<UpdateByIdWaitlistPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  waitlistUpdateMany?: Maybe<UpdateManyWaitlistPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  waitlistUpdateOne?: Maybe<UpdateOneWaitlistPayload>;
  /** Creates Many documents with mongoose defaults, setters, hooks and validation */
  webhookCreateMany?: Maybe<CreateManyVendorPayload>;
  /** Create one document with mongoose defaults, setters, hooks and validation */
  webhookCreateOne?: Maybe<CreateOneVendorPayload>;
  /** Update one document: 1) Retrieve one document by findById. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  webhookUpdateById?: Maybe<UpdateByIdVendorPayload>;
  /** Update many documents without returning them: Use Query.update mongoose method. Do not apply mongoose defaults, setters, hooks and validation.  */
  webhookUpdateMany?: Maybe<UpdateManyVendorPayload>;
  /** Update one document: 1) Retrieve one document via findOne. 2) Apply updates to mongoose document. 3) Mongoose applies defaults, setters, hooks and validation. 4) And save it. */
  webhookUpdateOne?: Maybe<UpdateOneVendorPayload>;
};


export type MutationAddressCreateManyArgs = {
  records: Array<CreateManyAddressInput>;
};


export type MutationAddressCreateOneArgs = {
  record: CreateOneAddressInput;
};


export type MutationAddressUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdAddressInput;
};


export type MutationAddressUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyAddressInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyAddressInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyAddressInput>;
};


export type MutationAddressUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneAddressInput>;
  record: UpdateOneAddressInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneAddressInput>;
};


export type MutationCancellationReasonCreateManyArgs = {
  records: Array<CreateManyCancellationReasonInput>;
};


export type MutationCancellationReasonCreateOneArgs = {
  record: CreateOneCancellationReasonInput;
};


export type MutationCancellationReasonUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCancellationReasonInput;
};


export type MutationCancellationReasonUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCancellationReasonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCancellationReasonInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCancellationReasonInput>;
};


export type MutationCancellationReasonUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCancellationReasonInput>;
  record: UpdateOneCancellationReasonInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCancellationReasonInput>;
};


export type MutationChatMessageCreateManyArgs = {
  records: Array<CreateManyChatMessageInput>;
};


export type MutationChatMessageCreateOneArgs = {
  record: CreateOneChatMessageInput;
};


export type MutationChatMessageUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdChatMessageInput;
};


export type MutationChatMessageUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyChatMessageInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyChatMessageInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyChatMessageInput>;
};


export type MutationChatMessageUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneChatMessageInput>;
  record: UpdateOneChatMessageInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneChatMessageInput>;
};


export type MutationChatRoomCreateManyArgs = {
  records: Array<CreateManyChatRoomInput>;
};


export type MutationChatRoomCreateOneArgs = {
  record: CreateOneChatRoomInput;
};


export type MutationChatRoomUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdChatRoomInput;
};


export type MutationChatRoomUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyChatRoomInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyChatRoomInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyChatRoomInput>;
};


export type MutationChatRoomUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneChatRoomInput>;
  record: UpdateOneChatRoomInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneChatRoomInput>;
};


export type MutationCutsheetCreateManyArgs = {
  records: Array<CreateManyCutsheetInput>;
};


export type MutationCutsheetCreateOneArgs = {
  record: CreateOneCutsheetInput;
};


export type MutationCutsheetSoftDeleteArgs = {
  cutsheetId: Scalars['MongoID']['input'];
};


export type MutationCutsheetUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdCutsheetInput;
};


export type MutationCutsheetUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyCutsheetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyCutsheetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyCutsheetInput>;
};


export type MutationCutsheetUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneCutsheetInput>;
  record: UpdateOneCutsheetInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneCutsheetInput>;
};


export type MutationCutsheetUpsertArgs = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  cutsheetId?: InputMaybe<Scalars['MongoID']['input']>;
  extras?: InputMaybe<Array<InputMaybe<CutsheetExtrasTypeInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<Scalars['MongoID']['input']>>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  trim?: InputMaybe<Array<InputMaybe<CutsheetTrimTypeInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
};


export type MutationGenerateInvoicePdfArgs = {
  invoiceId: Scalars['MongoID']['input'];
};


export type MutationIntegrationCreateManyArgs = {
  records: Array<CreateManyIntegrationInput>;
};


export type MutationIntegrationCreateOneArgs = {
  record: CreateOneIntegrationInput;
};


export type MutationIntegrationInitArgs = {
  integrationName: EnumIntegrationName;
  shop?: InputMaybe<Scalars['String']['input']>;
};


export type MutationIntegrationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdIntegrationInput;
};


export type MutationIntegrationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyIntegrationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyIntegrationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyIntegrationInput>;
};


export type MutationIntegrationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneIntegrationInput>;
  record: UpdateOneIntegrationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneIntegrationInput>;
};


export type MutationInvoiceCreateManyArgs = {
  records: Array<CreateManyInvoiceInput>;
};


export type MutationInvoiceCreateOneArgs = {
  record: CreateOneInvoiceInput;
};


export type MutationInvoiceFinalizeAndSendArgs = {
  input?: InputMaybe<VoidInvoiceInput>;
};


export type MutationInvoiceLineItemCreateManyArgs = {
  records: Array<CreateManyInvoiceLineItemInput>;
};


export type MutationInvoiceLineItemCreateOneArgs = {
  record: CreateOneInvoiceLineItemInput;
};


export type MutationInvoiceLineItemUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdInvoiceLineItemInput;
};


export type MutationInvoiceLineItemUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyInvoiceLineItemInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyInvoiceLineItemInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyInvoiceLineItemInput>;
};


export type MutationInvoiceLineItemUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneInvoiceLineItemInput>;
  record: UpdateOneInvoiceLineItemInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneInvoiceLineItemInput>;
};


export type MutationInvoiceMarkAsPaidArgs = {
  input?: InputMaybe<MarkAsPaidInput>;
};


export type MutationInvoiceRefundArgs = {
  input?: InputMaybe<RefundInvoiceInput>;
};


export type MutationInvoiceUpdateArgs = {
  input?: InputMaybe<UpdateInvoiceInput>;
};


export type MutationInvoiceUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdInvoiceInput;
};


export type MutationInvoiceUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyInvoiceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyInvoiceInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyInvoiceInput>;
};


export type MutationInvoiceUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneInvoiceInput>;
  record: UpdateOneInvoiceInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneInvoiceInput>;
};


export type MutationInvoiceVoidArgs = {
  input?: InputMaybe<VoidInvoiceInput>;
};


export type MutationModuleCreateManyArgs = {
  records: Array<CreateManyModuleInput>;
};


export type MutationModuleCreateOneArgs = {
  record: CreateOneModuleInput;
};


export type MutationModuleUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdModuleInput;
};


export type MutationModuleUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyModuleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyModuleInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyModuleInput>;
};


export type MutationModuleUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneModuleInput>;
  record: UpdateOneModuleInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneModuleInput>;
};


export type MutationNoteCreateManyArgs = {
  records: Array<CreateManyNoteInput>;
};


export type MutationNoteCreateOneArgs = {
  record: CreateOneNoteInput;
};


export type MutationNoteUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNoteInput;
};


export type MutationNoteUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyNoteInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyNoteInput>;
};


export type MutationNoteUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneNoteInput>;
  record: UpdateOneNoteInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneNoteInput>;
};


export type MutationNoteUpsertArgs = {
  attachment?: InputMaybe<Scalars['Upload']['input']>;
  note: Scalars['String']['input'];
  noteId?: InputMaybe<Scalars['MongoID']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
};


export type MutationNotificationSettingsCreateManyArgs = {
  records: Array<CreateManyNotificationSettingInput>;
};


export type MutationNotificationSettingsCreateOneArgs = {
  record: CreateOneNotificationSettingInput;
};


export type MutationNotificationSettingsUpdateArgs = {
  notificationSettingId: Scalars['MongoID']['input'];
  settings: NotificationSettingsInput;
};


export type MutationNotificationSettingsUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdNotificationSettingInput;
};


export type MutationNotificationSettingsUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyNotificationSettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyNotificationSettingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyNotificationSettingInput>;
};


export type MutationNotificationSettingsUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneNotificationSettingInput>;
  record: UpdateOneNotificationSettingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneNotificationSettingInput>;
};


export type MutationPrimalCreateManyArgs = {
  records: Array<CreateManyPrimalInput>;
};


export type MutationPrimalCreateOneArgs = {
  record: CreateOnePrimalInput;
};


export type MutationPrimalCutBlockerCreateManyArgs = {
  records: Array<CreateManyPrimalCutBlockerInput>;
};


export type MutationPrimalCutBlockerCreateOneArgs = {
  record: CreateOnePrimalCutBlockerInput;
};


export type MutationPrimalCutBlockerUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutBlockerInput;
};


export type MutationPrimalCutBlockerUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalCutBlockerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalCutBlockerInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalCutBlockerInput>;
};


export type MutationPrimalCutBlockerUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalCutBlockerInput>;
  record: UpdateOnePrimalCutBlockerInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalCutBlockerInput>;
};


export type MutationPrimalCutBlockerUpsertArgs = {
  animalSpecies: Scalars['String']['input'];
  blockedBy?: InputMaybe<Array<InputMaybe<BlockedByInput>>>;
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
};


export type MutationPrimalCutCreateManyArgs = {
  records: Array<CreateManyPrimalCutInput>;
};


export type MutationPrimalCutCreateOneArgs = {
  record: CreateOnePrimalCutInput;
};


export type MutationPrimalCutSoftDeleteArgs = {
  primalCutId: Scalars['MongoID']['input'];
};


export type MutationPrimalCutTypeCreateManyArgs = {
  records: Array<CreateManyPrimalCutTypeInput>;
};


export type MutationPrimalCutTypeCreateOneArgs = {
  record: CreateOnePrimalCutTypeInput;
};


export type MutationPrimalCutTypeUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutTypeInput;
};


export type MutationPrimalCutTypeUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalCutTypeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalCutTypeInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalCutTypeInput>;
};


export type MutationPrimalCutTypeUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalCutTypeInput>;
  record: UpdateOnePrimalCutTypeInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalCutTypeInput>;
};


export type MutationPrimalCutUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutInput;
};


export type MutationPrimalCutUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalCutInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalCutInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalCutInput>;
};


export type MutationPrimalCutUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalCutInput>;
  record: UpdateOnePrimalCutInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalCutInput>;
};


export type MutationPrimalGroupCreateManyArgs = {
  records: Array<CreateManyPrimalGroupInput>;
};


export type MutationPrimalGroupCreateOneArgs = {
  record: CreateOnePrimalGroupInput;
};


export type MutationPrimalGroupUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalGroupInput;
};


export type MutationPrimalGroupUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalGroupInput>;
};


export type MutationPrimalGroupUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalGroupInput>;
  record: UpdateOnePrimalGroupInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalGroupInput>;
};


export type MutationPrimalUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalInput;
};


export type MutationPrimalUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyPrimalInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyPrimalInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyPrimalInput>;
};


export type MutationPrimalUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOnePrimalInput>;
  record: UpdateOnePrimalInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOnePrimalInput>;
};


export type MutationProcessingPartnersCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersCreateOneArgs = {
  record: CreateOneProcessorSettingsInput;
};


export type MutationProcessingPartnersOneCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersOneCreateOneArgs = {
  record: CreateOneProcessorSettingsInput;
};


export type MutationProcessingPartnersOneUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
};


export type MutationProcessingPartnersOneUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersOneUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsInput>;
  record: UpdateOneProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsInput>;
};


export type MutationProcessingPartnersUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
};


export type MutationProcessingPartnersUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsInput>;
};


export type MutationProcessingPartnersUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsInput>;
  record: UpdateOneProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsInput>;
};


export type MutationProcessorCapabilityCreateManyArgs = {
  records: Array<CreateManyProcessorCapabilityInput>;
};


export type MutationProcessorCapabilityCreateOneArgs = {
  record: CreateOneProcessorCapabilityInput;
};


export type MutationProcessorCapabilitySpecificationCreateManyArgs = {
  records: Array<CreateManyProcessorCapabilitySpecificationInput>;
};


export type MutationProcessorCapabilitySpecificationCreateOneArgs = {
  record: CreateOneProcessorCapabilitySpecificationInput;
};


export type MutationProcessorCapabilitySpecificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorCapabilitySpecificationInput;
};


export type MutationProcessorCapabilitySpecificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorCapabilitySpecificationInput>;
};


export type MutationProcessorCapabilitySpecificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorCapabilitySpecificationInput>;
  record: UpdateOneProcessorCapabilitySpecificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorCapabilitySpecificationInput>;
};


export type MutationProcessorCapabilityUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorCapabilityInput;
};


export type MutationProcessorCapabilityUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorCapabilityInput>;
};


export type MutationProcessorCapabilityUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorCapabilityInput>;
  record: UpdateOneProcessorCapabilityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorCapabilityInput>;
};


export type MutationProcessorCapabilityUpsertArgs = {
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  canSelectMoreThanOneTrim: Scalars['Boolean']['input'];
  extras?: InputMaybe<Array<InputMaybe<ProcessorCapabilityExtrasModelInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  newCutBlockers?: InputMaybe<Scalars['JSON']['input']>;
  primalCuts: Array<Scalars['MongoID']['input']>;
  primalGroups?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  specifications?: InputMaybe<Array<ProcessorCapabilitySpecificationSpecificationsInput>>;
  trim?: InputMaybe<Array<InputMaybe<ProcessorCapabilityTrimModelInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProcessorExportCsvArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  type: ProcessorExportTypeEnum;
  vendorId: Scalars['MongoID']['input'];
};


export type MutationProcessorExportCsvByVendorIdArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationProcessorNotificationCreateManyArgs = {
  records: Array<CreateManyProcessorNotificationInput>;
};


export type MutationProcessorNotificationCreateOneArgs = {
  record: CreateOneProcessorNotificationInput;
};


export type MutationProcessorNotificationUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorNotificationInput;
};


export type MutationProcessorNotificationUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorNotificationInput>;
};


export type MutationProcessorNotificationUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorNotificationInput>;
  record: UpdateOneProcessorNotificationInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorNotificationInput>;
};


export type MutationProcessorSchedulingAnimalHeadBulkUpdateArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  updatedAnimalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadUpdatesInput>>>;
};


export type MutationProcessorSchedulingAnimalHeadDeleteArgs = {
  animalHeadId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingAnimalHeadPartialUpdateByIdArgs = {
  animalHeadId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<ProcessorSchedulingPartialUpdateAnimalHeadInput>;
};


export type MutationProcessorSchedulingCreateArgs = {
  newSchedule?: InputMaybe<CreateProcessorSchedulingInput>;
};


export type MutationProcessorSchedulingCreateManyArgs = {
  records: Array<CreateManyProcessorSchedulingInput>;
};


export type MutationProcessorSchedulingCreateOneArgs = {
  record: CreateOneProcessorSchedulingInput;
};


export type MutationProcessorSchedulingCutsheetReminderArgs = {
  schedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingDragAndDropUpdateArgs = {
  eventDate: Scalars['String']['input'];
  eventType: Scalars['String']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateBillingStatementArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateCarcassTagsArgs = {
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateCsvByVendorIdArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationProcessorSchedulingGenerateCutsheetRequestArgs = {
  cutsheetRequestId: Scalars['MongoID']['input'];
  processorSchedulingId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingGenerateHangingWeightCsvArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationProcessorSchedulingGenerateKillSheetArgs = {
  date: Scalars['Date']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type MutationProcessorSchedulingNotificationSendArgs = {
  request?: InputMaybe<NotificationRequestInput>;
  type?: InputMaybe<Scalars['NotificationTypeInput']['input']>;
};


export type MutationProcessorSchedulingPartialUpdateByIdArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<ProcessorSchedulingPartialUpdateInput>;
};


export type MutationProcessorSchedulingSplitTypeUpdateByIdArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<ProcessorSchedulingSplitTypeUpdateInput>;
};


export type MutationProcessorSchedulingUpdateArgs = {
  _id: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindOneProcessorSchedulingInput>;
  record: UpdateByIdProcessorSchedulingInput;
};


export type MutationProcessorSchedulingUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSchedulingInput;
};


export type MutationProcessorSchedulingUpdateCutsheetsArgs = {
  processorSchedulingId: Scalars['MongoID']['input'];
  record?: InputMaybe<Array<InputMaybe<CutsheetPartialUpdateInput>>>;
};


export type MutationProcessorSchedulingUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSchedulingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSchedulingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSchedulingInput>;
};


export type MutationProcessorSchedulingUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSchedulingInput>;
  record: UpdateOneProcessorSchedulingInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSchedulingInput>;
};


export type MutationProcessorSettingsCreateArgs = {
  newProcessor?: InputMaybe<CreateProcessorSettingsWithCustomCapacityInput>;
};


export type MutationProcessorSettingsCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsInput>;
};


export type MutationProcessorSettingsCreateOneArgs = {
  record: CreateOneProcessorSettingsInput;
};


export type MutationProcessorSettingsCustomCapacityCreateManyArgs = {
  records: Array<CreateManyProcessorSettingsCustomCapacityInput>;
};


export type MutationProcessorSettingsCustomCapacityCreateOneArgs = {
  record: CreateOneProcessorSettingsCustomCapacityInput;
};


export type MutationProcessorSettingsCustomCapacityUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsCustomCapacityInput;
};


export type MutationProcessorSettingsCustomCapacityUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsCustomCapacityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsCustomCapacityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsCustomCapacityInput>;
};


export type MutationProcessorSettingsCustomCapacityUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsCustomCapacityInput>;
  record: UpdateOneProcessorSettingsCustomCapacityInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsCustomCapacityInput>;
};


export type MutationProcessorSettingsUpdateArgs = {
  updateProcessor?: InputMaybe<UpdateProcessorSettingsWithCustomCapacityInput>;
};


export type MutationProcessorSettingsUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
};


export type MutationProcessorSettingsUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyProcessorSettingsInput>;
};


export type MutationProcessorSettingsUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneProcessorSettingsInput>;
  record: UpdateOneProcessorSettingsInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneProcessorSettingsInput>;
};


export type MutationSendMessageArgs = {
  chatRoomId: Scalars['MongoID']['input'];
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  message: Scalars['String']['input'];
};


export type MutationStateCreateManyArgs = {
  records: Array<CreateManyStateInput>;
};


export type MutationStateCreateOneArgs = {
  record: CreateOneStateInput;
};


export type MutationStateUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdStateInput;
};


export type MutationStateUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyStateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyStateInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyStateInput>;
};


export type MutationStateUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneStateInput>;
  record: UpdateOneStateInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneStateInput>;
};


export type MutationStripeAccountCreateArgs = {
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationStripeSessionCreateArgs = {
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationTenantCreateArgs = {
  newTenant: CreateOneTenantInput;
};


export type MutationTenantCreateManyArgs = {
  records: Array<CreateManyTenantInput>;
};


export type MutationTenantCreateOneArgs = {
  record: CreateOneTenantInput;
};


export type MutationTenantModulesEditArgs = {
  moduleIds: Array<InputMaybe<Scalars['MongoID']['input']>>;
  tenantId: Scalars['MongoID']['input'];
};


export type MutationTenantPictureUrlEditArgs = {
  picture_url?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['MongoID']['input'];
};


export type MutationTenantSubscriptionEditArgs = {
  subscription: Scalars['String']['input'];
  tenantId: Scalars['MongoID']['input'];
};


export type MutationTenantUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdTenantInput;
};


export type MutationTenantUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyTenantInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyTenantInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyTenantInput>;
};


export type MutationTenantUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneTenantInput>;
  record: UpdateOneTenantInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneTenantInput>;
};


export type MutationUserActivateArgs = {
  userId: Scalars['MongoID']['input'];
};


export type MutationUserCreateArgs = {
  newUser: CreateOneUserInput;
};


export type MutationUserCreateManyArgs = {
  records: Array<CreateManyUserInput>;
};


export type MutationUserCreateOneArgs = {
  record: CreateOneUserInput;
};


export type MutationUserDeactivateArgs = {
  userId: Scalars['MongoID']['input'];
};


export type MutationUserSettingsUpdateArgs = {
  settings: UserSettingsInput;
  userId: Scalars['MongoID']['input'];
};


export type MutationUserUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdUserInput;
};


export type MutationUserUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyUserInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyUserInput>;
};


export type MutationUserUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneUserInput>;
  record: UpdateOneUserInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneUserInput>;
};


export type MutationVendorCreateArgs = {
  newVendor: CreateOneVendorInput;
};


export type MutationVendorCreateManyArgs = {
  records: Array<CreateManyVendorInput>;
};


export type MutationVendorCreateOneArgs = {
  record: CreateOneVendorInput;
};


export type MutationVendorUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdVendorInput;
};


export type MutationVendorUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyVendorInput>;
};


export type MutationVendorUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneVendorInput>;
  record: UpdateOneVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneVendorInput>;
};


export type MutationWaitlistAddArgs = {
  animal: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type MutationWaitlistCreateManyArgs = {
  records: Array<CreateManyWaitlistInput>;
};


export type MutationWaitlistCreateOneArgs = {
  record: CreateOneWaitlistInput;
};


export type MutationWaitlistDeleteArgs = {
  _id: Scalars['MongoID']['input'];
};


export type MutationWaitlistUnsubscribeArgs = {
  token: Scalars['String']['input'];
};


export type MutationWaitlistUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdWaitlistInput;
};


export type MutationWaitlistUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyWaitlistInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyWaitlistInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyWaitlistInput>;
};


export type MutationWaitlistUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneWaitlistInput>;
  record: UpdateOneWaitlistInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneWaitlistInput>;
};


export type MutationWebhookCreateManyArgs = {
  records: Array<CreateManyVendorInput>;
};


export type MutationWebhookCreateOneArgs = {
  record: CreateOneVendorInput;
};


export type MutationWebhookUpdateByIdArgs = {
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdVendorInput;
};


export type MutationWebhookUpdateManyArgs = {
  filter?: InputMaybe<FilterUpdateManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  record: UpdateManyVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateManyVendorInput>;
};


export type MutationWebhookUpdateOneArgs = {
  filter?: InputMaybe<FilterUpdateOneVendorInput>;
  record: UpdateOneVendorInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortUpdateOneVendorInput>;
};

export type Note = {
  __typename?: 'Note';
  _id: Scalars['MongoID']['output'];
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<User>;
  note: Scalars['String']['output'];
  processorScheduling?: Maybe<Scalars['MongoID']['output']>;
  type: EnumNoteType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type NotePagination = {
  __typename?: 'NotePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Note>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type NotificationMessage = {
  __typename?: 'NotificationMessage';
  _id: Scalars['MongoID']['output'];
  channel: EnumNotificationMessageChannel;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  trigger: EnumNotificationMessageTrigger;
  type: EnumNotificationMessageType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type NotificationRequestInput = {
  contactUserId: Scalars['MongoID']['input'];
  scheduledJobId: Scalars['MongoID']['input'];
};

export type NotificationSetting = {
  __typename?: 'NotificationSetting';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  emailMessage?: Maybe<NotificationMessage>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  sendSMS?: Maybe<Scalars['Boolean']['output']>;
  smsMessage?: Maybe<NotificationMessage>;
  timings?: Maybe<Array<Maybe<NotificationSettingTimings>>>;
  trigger: EnumNotificationSettingTrigger;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type NotificationSettingPagination = {
  __typename?: 'NotificationSettingPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<NotificationSetting>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type NotificationSettingTimings = {
  __typename?: 'NotificationSettingTimings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  days: Scalars['Float']['output'];
  relation: EnumNotificationSettingTimingsRelation;
};

export type NotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days: Scalars['Float']['input'];
  relation: EnumNotificationSettingTimingsRelation;
};

export type NotificationSettingsInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  timings?: InputMaybe<Array<InputMaybe<NotificationTimingInput>>>;
};

export type NotificationTimingInput = {
  days: Scalars['Int']['input'];
  relation: Scalars['String']['input'];
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  itemCount?: Maybe<Scalars['Int']['output']>;
  pageCount?: Maybe<Scalars['Int']['output']>;
  perPage: Scalars['Int']['output'];
};

export type ParentProduct = {
  __typename?: 'ParentProduct';
  _id: Scalars['MongoID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  integration?: Maybe<Scalars['MongoID']['output']>;
  is_internal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stock_quantity?: Maybe<Scalars['Float']['output']>;
  stock_status?: Maybe<EnumParentProductStock_Status>;
  type?: Maybe<EnumParentProductType>;
  vendor: Scalars['MongoID']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type Primal = {
  __typename?: 'Primal';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  cuts: Array<PrimalCut>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<PrimalGroup>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type PrimalCutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutInput>;
};

export type PrimalCut = {
  __typename?: 'PrimalCut';
  _id: Scalars['MongoID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  cutType?: Maybe<PrimalCutType>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  primal?: Maybe<Primal>;
  type?: Maybe<EnumPrimalCutType>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PrimalCutBlocker = {
  __typename?: 'PrimalCutBlocker';
  _id: Scalars['MongoID']['output'];
  animalSpecies: Scalars['String']['output'];
  blockedBy?: Maybe<Array<Maybe<PrimalCutBlockerBlockedBy>>>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  inspectionLevel: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primalCutId: Scalars['MongoID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

export type PrimalCutBlockerBlockedBy = {
  __typename?: 'PrimalCutBlockerBlockedBy';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name: Scalars['String']['output'];
  primalCutId: Scalars['MongoID']['output'];
};

export type PrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
};

/** List of items with pagination. */
export type PrimalCutBlockerPagination = {
  __typename?: 'PrimalCutBlockerPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalCutBlocker>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type PrimalCutPagination = {
  __typename?: 'PrimalCutPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalCut>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PrimalCutType = {
  __typename?: 'PrimalCutType';
  _id: Scalars['MongoID']['output'];
  animalSpecies?: Maybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lid?: Maybe<EnumPrimalCutTypeLid>;
  name: Scalars['String']['output'];
  processorSettings?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type PrimalCutTypePagination = {
  __typename?: 'PrimalCutTypePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalCutType>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type PrimalGroup = {
  __typename?: 'PrimalGroup';
  _id: Scalars['MongoID']['output'];
  animalSpecies?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  animalType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  deletedAt?: Maybe<Scalars['Date']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  inspectionLevel?: Maybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  primals: Array<Primal>;
  processorSettings?: Maybe<Scalars['MongoID']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};


export type PrimalGroupPrimalsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalInput>;
};

/** List of items with pagination. */
export type PrimalGroupPagination = {
  __typename?: 'PrimalGroupPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<PrimalGroup>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

/** List of items with pagination. */
export type PrimalPagination = {
  __typename?: 'PrimalPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Primal>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessingPartnerTenant = {
  __typename?: 'ProcessingPartnerTenant';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
};

export type ProcessingPartnerVendor = {
  __typename?: 'ProcessingPartnerVendor';
  _id?: Maybe<Scalars['MongoID']['output']>;
  address?: Maybe<Address>;
  shop_name?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<ProcessingPartnerTenant>;
};

export type ProcessingPartners = {
  __typename?: 'ProcessingPartners';
  _id?: Maybe<Scalars['MongoID']['output']>;
  enabledAnimals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimalSettingsSpecies>>>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<ProcessingPartnerVendor>;
};

export type ProcessorCapability = {
  __typename?: 'ProcessorCapability';
  _id: Scalars['MongoID']['output'];
  activeSpecification?: Maybe<ProcessorCapabilitySpecification>;
  animalSpecies?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  animalType?: Maybe<Scalars['String']['output']>;
  canSelectMoreThanOneTrim?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cuts: Array<PrimalCut>;
  extras?: Maybe<Array<Maybe<ProcessorCapabilityExtras>>>;
  extrasDescription?: Maybe<Scalars['String']['output']>;
  inspectionLevel?: Maybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  primalCuts?: Maybe<Array<Maybe<Scalars['MongoID']['output']>>>;
  primalGroups: Array<PrimalGroup>;
  specificationSnapshots: Array<ProcessorCapabilitySpecification>;
  trim?: Maybe<Array<Maybe<ProcessorCapabilityTrim>>>;
  trimDescription?: Maybe<Scalars['String']['output']>;
  trimSelection: EnumProcessorCapabilityTrimSelection;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
  wizardWelcomeContent?: Maybe<Scalars['String']['output']>;
  wizardWelcomeTitle?: Maybe<Scalars['String']['output']>;
};


export type ProcessorCapabilityCutsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutInput>;
};


export type ProcessorCapabilityPrimalGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
};


export type ProcessorCapabilitySpecificationSnapshotsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorCapabilitySpecificationInput>;
};

export type ProcessorCapabilityExtras = {
  __typename?: 'ProcessorCapabilityExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fee?: Maybe<Scalars['Float']['output']>;
  isActive: Scalars['Boolean']['output'];
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound?: Maybe<Scalars['Float']['output']>;
  type: EnumProcessorCapabilityExtrasType;
};

export type ProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type: EnumProcessorCapabilityExtrasType;
};

export type ProcessorCapabilityExtrasModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type: Scalars['String']['input'];
};

/** List of items with pagination. */
export type ProcessorCapabilityPagination = {
  __typename?: 'ProcessorCapabilityPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorCapability>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorCapabilitySpecification = {
  __typename?: 'ProcessorCapabilitySpecification';
  _id: Scalars['MongoID']['output'];
  capability?: Maybe<ProcessorCapability>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  specifications?: Maybe<Array<Maybe<ProcessorCapabilitySpecificationSpecifications>>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type ProcessorCapabilitySpecificationPagination = {
  __typename?: 'ProcessorCapabilitySpecificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorCapabilitySpecification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorCapabilitySpecificationSpecifications = {
  __typename?: 'ProcessorCapabilitySpecificationSpecifications';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fid?: Maybe<Scalars['String']['output']>;
  isRequired: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  measurementUnit?: Maybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name: Scalars['String']['output'];
  options: Array<Maybe<ProcessorCapabilitySpecificationSpecificationsOptions>>;
};

export type ProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  isRequired: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  measurementUnit: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit;
  name: Scalars['String']['input'];
  options: Array<InputMaybe<ProcessorCapabilitySpecificationSpecificationsOptionsInput>>;
};

export type ProcessorCapabilitySpecificationSpecificationsOptions = {
  __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type ProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault: Scalars['Boolean']['input'];
  isVisible: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ProcessorCapabilityTrim = {
  __typename?: 'ProcessorCapabilityTrim';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  minLbs?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  pricePerPound: Scalars['Float']['output'];
};

export type ProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound: Scalars['Float']['input'];
};

export type ProcessorCapabilityTrimModelInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pricePerPound: Scalars['Float']['input'];
};

export type ProcessorExportCsvResponse = {
  __typename?: 'ProcessorExportCsvResponse';
  errors: Array<Maybe<Scalars['String']['output']>>;
  file: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

export enum ProcessorExportTypeEnum {
  /** Export job data */
  Job = 'job',
  /** Export splits data */
  Splits = 'splits',
  /** Export user data */
  User = 'user'
}

export type ProcessorNotification = {
  __typename?: 'ProcessorNotification';
  _id: Scalars['MongoID']['output'];
  errorMessage?: Maybe<Scalars['JSON']['output']>;
  notificationType: Scalars['String']['output'];
  sentOn: Scalars['Date']['output'];
  sentTo: Scalars['String']['output'];
  type: EnumProcessorNotificationType;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type ProcessorNotificationPagination = {
  __typename?: 'ProcessorNotificationPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorNotification>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorScheduling = {
  __typename?: 'ProcessorScheduling';
  _id: Scalars['MongoID']['output'];
  additionalPickupDetails?: Maybe<Scalars['String']['output']>;
  animalHeads?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeads>>>;
  animalSpecies: EnumProcessorSchedulingAnimalSpecies;
  animalType?: Maybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: Maybe<Scalars['Float']['output']>;
  blockTitle?: Maybe<Scalars['String']['output']>;
  butcherSlotPrice?: Maybe<Scalars['Float']['output']>;
  cancellationCustomText?: Maybe<Scalars['String']['output']>;
  cancellationReason?: Maybe<Scalars['MongoID']['output']>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  completedDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  cutsheetInformation?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsCutsheetInformation>>>;
  deposit?: Maybe<ProcessorSchedulingDeposit>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: Maybe<Scalars['Date']['output']>;
  /** The date formatted from UTC time to be MM/DD/YYYY */
  dropoffDateStr?: Maybe<Scalars['String']['output']>;
  /** Return Kill Date from the first animal head */
  firstKillDate?: Maybe<Scalars['Date']['output']>;
  headCount: Scalars['Float']['output'];
  invoice?: Maybe<ProcessorSchedulingInvoice>;
  invoices?: Maybe<ProcessorSchedulingInvoices>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isOnBehalfOf?: Maybe<Scalars['Boolean']['output']>;
  jobId: Scalars['String']['output'];
  killedDate?: Maybe<Scalars['Date']['output']>;
  linkedInvoices?: Maybe<Array<Maybe<Invoice>>>;
  notificationHistory?: Maybe<Array<Maybe<ProcessorSchedulingNotificationHistory>>>;
  processorCapabilities: Array<ProcessorCapability>;
  processorSettings?: Maybe<ProcessorSettings>;
  refundDeadlineDays?: Maybe<Scalars['Float']['output']>;
  requestedBy?: Maybe<User>;
  scheduledDate?: Maybe<Scalars['Date']['output']>;
  source?: Maybe<EnumProcessorSchedulingSource>;
  status: EnumProcessorSchedulingStatus;
  statusLastUpdated?: Maybe<Scalars['Date']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor?: Maybe<Vendor>;
  vendorCutsheets: Array<Cutsheet>;
};


export type ProcessorSchedulingProcessorCapabilitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilityInput>;
};


export type ProcessorSchedulingVendorCutsheetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetInput>;
};

export type ProcessorSchedulingAnimalHeads = {
  __typename?: 'ProcessorSchedulingAnimalHeads';
  _id?: Maybe<Scalars['MongoID']['output']>;
  butcherSlotPrice?: Maybe<Scalars['Float']['output']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: Maybe<Scalars['Date']['output']>;
  /** The date formatted from UTC time to be MM/DD/YYYY */
  cutDateStr?: Maybe<Scalars['String']['output']>;
  cutsheetInformation?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsCutsheetInformation>>>;
  dateFirstEnteredHangingWeight?: Maybe<Scalars['Date']['output']>;
  dateUpdatedHangingWeight?: Maybe<Scalars['Date']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  hangingWeight?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideA?: Maybe<Scalars['Float']['output']>;
  hangingWeightSideB?: Maybe<Scalars['Float']['output']>;
  inspectionLevel?: Maybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: Maybe<ProcessorSchedulingAnimalHeadsInvoice>;
  invoice_line_item?: Maybe<Scalars['MongoID']['output']>;
  isHangingWeightPerSide?: Maybe<Scalars['Boolean']['output']>;
  isKillAndChill?: Maybe<Scalars['Boolean']['output']>;
  isOverThirtyMonths?: Maybe<Scalars['Boolean']['output']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: Maybe<Scalars['Date']['output']>;
  /** The date formatted from UTC time to be MM/DD/YYYY */
  killDateStr?: Maybe<Scalars['String']['output']>;
  liveWeight?: Maybe<Scalars['Float']['output']>;
  producerIdentifier?: Maybe<Scalars['String']['output']>;
  publicId: Scalars['String']['output'];
  sex?: Maybe<Scalars['String']['output']>;
  splitType?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Scalars['String']['output']>;
  /** The ratio of carcass weight to live weight, expressed as a percentage. */
  yield?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsCutsheetInformation = {
  __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation';
  _id?: Maybe<Scalars['MongoID']['output']>;
  contactUser?: Maybe<User>;
  cutsheet?: Maybe<Cutsheet>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  splitPart?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId: Scalars['String']['input'];
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoice = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoice';
  _id?: Maybe<Scalars['MongoID']['output']>;
  additionalCharges?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges>>>;
  additionalCost?: Maybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost>;
  extras?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceExtras>>>;
  finishedWeights?: Maybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights>;
  trims?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceTrims>>>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost';
  cost?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceExtras = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights';
  categories?: Maybe<Array<Maybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories>>>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<ProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceTrims = {
  __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingDeposit = {
  __typename?: 'ProcessorSchedulingDeposit';
  amount?: Maybe<Scalars['Float']['output']>;
  checkoutSession?: Maybe<ProcessorSchedulingDepositCheckoutSession>;
  price_external_id?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingDepositCheckoutSession = {
  __typename?: 'ProcessorSchedulingDepositCheckoutSession';
  customer_id?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['String']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<ProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoice = {
  __typename?: 'ProcessorSchedulingInvoice';
  additionalCost?: Maybe<ProcessorSchedulingInvoiceAdditionalCost>;
  invoice_external_id?: Maybe<Scalars['String']['output']>;
  invoice_status?: Maybe<Scalars['String']['output']>;
  isPayAtPickup?: Maybe<Scalars['Boolean']['output']>;
  sendInvoicePDF?: Maybe<Scalars['Boolean']['output']>;
  sendPaymentLink?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessorSchedulingInvoiceAdditionalCost = {
  __typename?: 'ProcessorSchedulingInvoiceAdditionalCost';
  cost?: Maybe<Scalars['Float']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<ProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSchedulingInvoices = {
  __typename?: 'ProcessorSchedulingInvoices';
  _id?: Maybe<Scalars['MongoID']['output']>;
  contacts?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContacts>>>;
  pricing?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesPricing>>>;
};

export type ProcessorSchedulingInvoicesContacts = {
  __typename?: 'ProcessorSchedulingInvoicesContacts';
  _id?: Maybe<Scalars['MongoID']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  invoice_external_id?: Maybe<Scalars['String']['output']>;
  invoice_status?: Maybe<Scalars['String']['output']>;
  isPayAtPickup?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  sendPaymentLink?: Maybe<Scalars['Boolean']['output']>;
  splits?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplits>>>;
  userId?: Maybe<Scalars['MongoID']['output']>;
};

export type ProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplits = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplits';
  _id?: Maybe<Scalars['MongoID']['output']>;
  additionalCharges?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsAdditionalCharges>>>;
  animalHeadPublicId?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsExtras>>>;
  finishedWeights?: Maybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeights>;
  splitType?: Maybe<Scalars['String']['output']>;
  trims?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsTrims>>>;
};

export type ProcessorSchedulingInvoicesContactsSplitsAdditionalCharges = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsAdditionalCharges';
  _id?: Maybe<Scalars['MongoID']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsExtras = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsExtras';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeights = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsFinishedWeights';
  categories?: Maybe<Array<Maybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategories>>>;
  totalWeight?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategories = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategories';
  _id?: Maybe<Scalars['MongoID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<ProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type ProcessorSchedulingInvoicesContactsSplitsTrims = {
  __typename?: 'ProcessorSchedulingInvoicesContactsSplitsTrims';
  _id?: Maybe<Scalars['MongoID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<ProcessorSchedulingInvoicesPricingInput>>>;
};

export type ProcessorSchedulingInvoicesPricing = {
  __typename?: 'ProcessorSchedulingInvoicesPricing';
  _id?: Maybe<Scalars['MongoID']['output']>;
  inspectionLevel?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type ProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type ProcessorSchedulingNotificationHistory = {
  __typename?: 'ProcessorSchedulingNotificationHistory';
  errorMessage?: Maybe<ProcessorSchedulingNotificationHistoryErrorMessage>;
  notificationType?: Maybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: Maybe<Scalars['Date']['output']>;
  sentTo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ProcessorSchedulingNotificationHistoryErrorMessage = {
  __typename?: 'ProcessorSchedulingNotificationHistoryErrorMessage';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingNotificationHistoryErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingNotificationHistoryInput = {
  errorMessage?: InputMaybe<ProcessorSchedulingNotificationHistoryErrorMessageInput>;
  notificationType?: InputMaybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

/** List of items with pagination. */
export type ProcessorSchedulingPagination = {
  __typename?: 'ProcessorSchedulingPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorScheduling>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorSchedulingPartialUpdateAnimalHeadInput = {
  cutDate?: InputMaybe<Scalars['String']['input']>;
  cutsheetInformation?: InputMaybe<CutsheetInformationPartialUpdateInput>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  killDate?: InputMaybe<Scalars['String']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingPartialUpdateInput = {
  addAnimalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadInput>>>;
  dropoffDate?: InputMaybe<Scalars['String']['input']>;
  markInvoicePaid?: InputMaybe<Scalars['Boolean']['input']>;
  requestedBy?: InputMaybe<ProcessorSchedulingPartialUpdateRequestedByInput>;
  shouldUpdateExistingUser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSchedulingPartialUpdateRequestedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingPartialUpdateResponse = {
  __typename?: 'ProcessorSchedulingPartialUpdateResponse';
  error?: Maybe<ErrorInterface>;
  record?: Maybe<ProcessorScheduling>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
  warnings?: Maybe<Array<Maybe<ProcessorSchedulingPartialUpdateWarning>>>;
};

export type ProcessorSchedulingPartialUpdateWarning = {
  __typename?: 'ProcessorSchedulingPartialUpdateWarning';
  message?: Maybe<Scalars['String']['output']>;
};

export type ProcessorSchedulingSplitTypeUpdateInput = {
  animalHeadId: Scalars['MongoID']['input'];
  cutsheetInformation?: InputMaybe<Array<InputMaybe<CutsheetInformationInput>>>;
  splitType?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSchedulingSplitTypeUpdateResponse = {
  __typename?: 'ProcessorSchedulingSplitTypeUpdateResponse';
  record?: Maybe<ProcessorScheduling>;
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type ProcessorSettings = {
  __typename?: 'ProcessorSettings';
  _id: Scalars['MongoID']['output'];
  about?: Maybe<Scalars['String']['output']>;
  animalSettings?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettings>>>;
  animals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: Maybe<Array<Maybe<ProcessorSettingsAutoSchedulingSettings>>>;
  butcherSlotPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  capacityConfigurationType?: Maybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: Maybe<Array<Maybe<ProcessorSettingsCapacitySettings>>>;
  carcassSettings?: Maybe<Array<Maybe<ProcessorSettingsCarcassSettings>>>;
  commercialStartDate?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  customCapacities: Array<ProcessorSettingsCustomCapacity>;
  customCutsheetPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  documentSettings?: Maybe<ProcessorSettingsDocumentSettings>;
  enabledAnimalSplits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The enabled animals are ones that don't currently have validation errors associated to them. */
  enabledAnimals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimals>>>;
  faq?: Maybe<Scalars['String']['output']>;
  invoicing?: Maybe<ProcessorSettingsInvoicing>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isProcessorNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistFunctionalityDisabled?: Maybe<Scalars['Boolean']['output']>;
  killAndChillSettings?: Maybe<Array<Maybe<ProcessorSettingsKillAndChillSettings>>>;
  processorNotificationEmailAddresses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  refundDeadlineDays?: Maybe<Scalars['Float']['output']>;
  schedulingDeposit: Scalars['Float']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validationErrors?: Maybe<Array<Maybe<ProcessorSettingsValidationErrors>>>;
  vendor?: Maybe<Vendor>;
};


export type ProcessorSettingsCustomCapacitiesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ProcessorSettingsAnimalSettings = {
  __typename?: 'ProcessorSettingsAnimalSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  butcherSlotPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  customCutsheetPricing?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettingsButcherSlotPricing>>>;
  inspectionLevels?: Maybe<Array<Maybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled: Scalars['Boolean']['output'];
  species: EnumProcessorSettingsAnimalSettingsSpecies;
  splitTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  weightedAnimalUnit?: Maybe<Scalars['Float']['output']>;
};

export type ProcessorSettingsAnimalSettingsButcherSlotPricing = {
  __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing';
  animal?: Maybe<Scalars['String']['output']>;
  inspectionLevel?: Maybe<Scalars['String']['output']>;
  price: Scalars['Float']['output'];
  species?: Maybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type ProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Float']['input'];
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type ProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled: Scalars['Boolean']['input'];
  species: EnumProcessorSettingsAnimalSettingsSpecies;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type ProcessorSettingsAnimalSettingsPricingInput = {
  inspectionLevel: Scalars['String']['input'];
  price: Scalars['Float']['input'];
};

export type ProcessorSettingsAutoCarcassNumberSettingsInput = {
  currentNumber: Scalars['Float']['input'];
  inspectionLevel: EnumProcessorSettingsAnimalSettingsInspectionLevels;
  species: EnumProcessorSettingsAnimalSettingsSpecies;
};

export type ProcessorSettingsAutoSchedulingInput = {
  cutDateDays: Scalars['Int']['input'];
  harvestDateDays: Scalars['Int']['input'];
  isEnabled: Scalars['Boolean']['input'];
  species: EnumProcessorSettingsAutoSchedulingSettingsSpecies;
};

export type ProcessorSettingsAutoSchedulingSettings = {
  __typename?: 'ProcessorSettingsAutoSchedulingSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  cutDateDays: Scalars['Float']['output'];
  harvestDateDays: Scalars['Float']['output'];
  isEnabled: Scalars['Boolean']['output'];
  species: EnumProcessorSettingsAutoSchedulingSettingsSpecies;
};

export type ProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays: Scalars['Float']['input'];
  harvestDateDays: Scalars['Float']['input'];
  isEnabled: Scalars['Boolean']['input'];
  species: EnumProcessorSettingsAutoSchedulingSettingsSpecies;
};

export enum ProcessorSettingsCapacityConfigurationType {
  Species = 'species',
  SpeciesInspection = 'species_inspection',
  WeightedAnimalUnit = 'weighted_animal_unit'
}

export type ProcessorSettingsCapacitySettings = {
  __typename?: 'ProcessorSettingsCapacitySettings';
  dailyCapacities?: Maybe<Array<Maybe<DailyCapacity>>>;
  dayOfWeek: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
};

export type ProcessorSettingsCapacitySettingsDailyCapacityBlockInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<DailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value: Scalars['Float']['input'];
};

export type ProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<DailyCapacityInput>>>;
  dayOfWeek: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
};

export type ProcessorSettingsCarcassSettings = {
  __typename?: 'ProcessorSettingsCarcassSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  currentNumber: Scalars['Float']['output'];
  inspectionLevel: Scalars['String']['output'];
  lastTakenNumber: Scalars['Float']['output'];
  species: Scalars['String']['output'];
  year: Scalars['Float']['output'];
};

export type ProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber: Scalars['Float']['input'];
  inspectionLevel: Scalars['String']['input'];
  lastTakenNumber: Scalars['Float']['input'];
  species: Scalars['String']['input'];
  year: Scalars['Float']['input'];
};

export type ProcessorSettingsCustomCapacity = {
  __typename?: 'ProcessorSettingsCustomCapacity';
  _id: Scalars['MongoID']['output'];
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: Maybe<Scalars['JSON']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  dailyCapacities?: Maybe<Array<Maybe<DailyCapacity>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date: Scalars['Date']['output'];
  /** The date formatted from UTC time to be MM/DD/YYYY */
  dateStr?: Maybe<Scalars['String']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  processorSettings?: Maybe<ProcessorSettings>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** List of items with pagination. */
export type ProcessorSettingsCustomCapacityPagination = {
  __typename?: 'ProcessorSettingsCustomCapacityPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorSettingsCustomCapacity>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorSettingsDocumentSettings = {
  __typename?: 'ProcessorSettingsDocumentSettings';
  carcassTag?: Maybe<ProcessorSettingsDocumentSettingsCarcassTag>;
  cutsheet?: Maybe<ProcessorSettingsDocumentSettingsCutsheet>;
};

export type ProcessorSettingsDocumentSettingsCarcassTag = {
  __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag';
  title?: Maybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type ProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type ProcessorSettingsDocumentSettingsCutsheet = {
  __typename?: 'ProcessorSettingsDocumentSettingsCutsheet';
  format: EnumProcessorSettingsDocumentSettingsCutsheetFormat;
};

export type ProcessorSettingsDocumentSettingsCutsheetInput = {
  format: EnumProcessorSettingsDocumentSettingsCutsheetFormat;
};

export type ProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<ProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<ProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type ProcessorSettingsInvoicing = {
  __typename?: 'ProcessorSettingsInvoicing';
  _id?: Maybe<Scalars['MongoID']['output']>;
  defaultSplitRule?: Maybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: Maybe<Scalars['Boolean']['output']>;
  trackYields?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProcessorSettingsKillAndChillInput = {
  isEnabled: Scalars['Boolean']['input'];
  pricePerHead: Scalars['Float']['input'];
  species: EnumProcessorSettingsKillAndChillSettingsSpecies;
};

export type ProcessorSettingsKillAndChillSettings = {
  __typename?: 'ProcessorSettingsKillAndChillSettings';
  _id?: Maybe<Scalars['MongoID']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  pricePerHead: Scalars['Float']['output'];
  species: EnumProcessorSettingsKillAndChillSettingsSpecies;
};

export type ProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  pricePerHead: Scalars['Float']['input'];
  species: EnumProcessorSettingsKillAndChillSettingsSpecies;
};

/** List of items with pagination. */
export type ProcessorSettingsPagination = {
  __typename?: 'ProcessorSettingsPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<ProcessorSettings>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type ProcessorSettingsValidationErrors = {
  __typename?: 'ProcessorSettingsValidationErrors';
  group?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  property?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type ProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type Product = {
  __typename?: 'Product';
  _id: Scalars['MongoID']['output'];
  children?: Maybe<Array<Maybe<ParentProduct>>>;
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['Float']['output']>;
  integration?: Maybe<Integration>;
  is_internal?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ParentProduct>;
  permalink?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  short_description?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stock_quantity?: Maybe<Scalars['Float']['output']>;
  stock_status?: Maybe<EnumProductStock_Status>;
  type?: Maybe<EnumProductType>;
  vendor?: Maybe<Vendor>;
  weight?: Maybe<Scalars['Float']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a list of all active vendors. */
  activeVendorList?: Maybe<Array<Maybe<Vendor>>>;
  addressById?: Maybe<Address>;
  addressByIds: Array<Address>;
  addressCount?: Maybe<Scalars['Int']['output']>;
  addressMany: Array<Address>;
  addressOne?: Maybe<Address>;
  addressPagination?: Maybe<AddressPagination>;
  cancellationReasonById?: Maybe<CancellationReason>;
  cancellationReasonByIds: Array<CancellationReason>;
  cancellationReasonCount?: Maybe<Scalars['Int']['output']>;
  cancellationReasonMany: Array<CancellationReason>;
  cancellationReasonOne?: Maybe<CancellationReason>;
  cancellationReasonPagination?: Maybe<CancellationReasonPagination>;
  chatMessageById?: Maybe<ChatMessage>;
  chatMessageByIds: Array<ChatMessage>;
  chatMessageCount?: Maybe<Scalars['Int']['output']>;
  chatMessageMany: Array<ChatMessage>;
  chatMessageOne?: Maybe<ChatMessage>;
  chatMessagePagination?: Maybe<ChatMessagePagination>;
  chatRoomById?: Maybe<ChatRoom>;
  chatRoomByIds: Array<ChatRoom>;
  chatRoomCount?: Maybe<Scalars['Int']['output']>;
  chatRoomMany: Array<ChatRoom>;
  chatRoomOne?: Maybe<ChatRoom>;
  chatRoomPagination?: Maybe<ChatRoomPagination>;
  cutsheetById?: Maybe<Cutsheet>;
  cutsheetByIds: Array<Cutsheet>;
  cutsheetCount?: Maybe<Scalars['Int']['output']>;
  cutsheetMany: Array<Cutsheet>;
  cutsheetOne?: Maybe<Cutsheet>;
  cutsheetPagination?: Maybe<CutsheetPagination>;
  /** Get all notification settings for a given vendorId */
  findNotificationSettingsByVendorId?: Maybe<NotificationSettingPagination>;
  /** Retrieve a single processor scheduling job. */
  findProcessorSchedulingById?: Maybe<ProcessorScheduling>;
  /** Get all records with missing cutsheets in valid statuses for notifications */
  findProcessorSchedulingsWithMissingCutsheets?: Maybe<ProcessorSchedulingPagination>;
  /** Get all records with missing hanging weights that killDate is in past and there is no hanging weights */
  findProcessorSchedulingsWithMissingHangingWeights?: Maybe<ProcessorSchedulingPagination>;
  /** Get all jobs with custom filters */
  getFilteredProcessorScheduling?: Maybe<ProcessorSchedulingPagination>;
  /** Get all customers with custom filters */
  getProcessorCustomers?: Maybe<UserPagination>;
  /** Get processor scheduled jobs between the two dates. */
  getProcessorSchedulingCalendar?: Maybe<Array<Maybe<ProcessorScheduling>>>;
  integrationById?: Maybe<Integration>;
  integrationByIds: Array<Integration>;
  integrationCount?: Maybe<Scalars['Int']['output']>;
  integrationMany: Array<Integration>;
  integrationOne?: Maybe<Integration>;
  integrationPagination?: Maybe<IntegrationPagination>;
  invoiceById?: Maybe<Invoice>;
  invoiceByIds: Array<Invoice>;
  invoiceCount?: Maybe<Scalars['Int']['output']>;
  invoiceLineItemById?: Maybe<InvoiceLineItem>;
  invoiceLineItemByIds: Array<InvoiceLineItem>;
  invoiceLineItemCount?: Maybe<Scalars['Int']['output']>;
  invoiceLineItemMany: Array<InvoiceLineItem>;
  invoiceLineItemOne?: Maybe<InvoiceLineItem>;
  invoiceLineItemPagination?: Maybe<InvoiceLineItemPagination>;
  invoiceMany: Array<Invoice>;
  invoiceOne?: Maybe<Invoice>;
  invoicePagination?: Maybe<InvoicePagination>;
  /** Get all chat rooms for the logged in user */
  messagesByChatRoom?: Maybe<ChatMessagePagination>;
  moduleById?: Maybe<Module>;
  moduleByIds: Array<Module>;
  moduleCount?: Maybe<Scalars['Int']['output']>;
  moduleMany: Array<Module>;
  moduleOne?: Maybe<Module>;
  modulePagination?: Maybe<ModulePagination>;
  /** Get all chat-rooms for given processor for logged in user and Basic user */
  myChatRooms?: Maybe<ChatRoomPagination>;
  noteById?: Maybe<Note>;
  noteByIds: Array<Note>;
  noteCount?: Maybe<Scalars['Int']['output']>;
  noteMany: Array<Note>;
  noteOne?: Maybe<Note>;
  notePagination?: Maybe<NotePagination>;
  notificationSettingsById?: Maybe<NotificationSetting>;
  notificationSettingsByIds: Array<NotificationSetting>;
  notificationSettingsCount?: Maybe<Scalars['Int']['output']>;
  notificationSettingsMany: Array<NotificationSetting>;
  notificationSettingsOne?: Maybe<NotificationSetting>;
  notificationSettingsPagination?: Maybe<NotificationSettingPagination>;
  primalById?: Maybe<Primal>;
  primalByIds: Array<Primal>;
  primalCount?: Maybe<Scalars['Int']['output']>;
  primalCutBlockerById?: Maybe<PrimalCutBlocker>;
  primalCutBlockerByIds: Array<PrimalCutBlocker>;
  primalCutBlockerCount?: Maybe<Scalars['Int']['output']>;
  primalCutBlockerMany: Array<PrimalCutBlocker>;
  primalCutBlockerOne?: Maybe<PrimalCutBlocker>;
  primalCutBlockerPagination?: Maybe<PrimalCutBlockerPagination>;
  primalCutById?: Maybe<PrimalCut>;
  primalCutByIds: Array<PrimalCut>;
  primalCutCount?: Maybe<Scalars['Int']['output']>;
  primalCutMany: Array<PrimalCut>;
  primalCutOne?: Maybe<PrimalCut>;
  primalCutPagination?: Maybe<PrimalCutPagination>;
  primalCutTypeById?: Maybe<PrimalCutType>;
  primalCutTypeByIds: Array<PrimalCutType>;
  primalCutTypeCount?: Maybe<Scalars['Int']['output']>;
  primalCutTypeMany: Array<PrimalCutType>;
  primalCutTypeOne?: Maybe<PrimalCutType>;
  primalCutTypePagination?: Maybe<PrimalCutTypePagination>;
  primalGroupById?: Maybe<PrimalGroup>;
  primalGroupByIds: Array<PrimalGroup>;
  primalGroupCount?: Maybe<Scalars['Int']['output']>;
  primalGroupMany: Array<PrimalGroup>;
  primalGroupOne?: Maybe<PrimalGroup>;
  primalGroupPagination?: Maybe<PrimalGroupPagination>;
  primalMany: Array<Primal>;
  primalOne?: Maybe<Primal>;
  primalPagination?: Maybe<PrimalPagination>;
  /** Retrieve a complete list of our processing partners */
  processingPartners?: Maybe<Array<Maybe<ProcessingPartners>>>;
  processingPartnersById?: Maybe<ProcessorSettings>;
  processingPartnersByIds: Array<ProcessorSettings>;
  processingPartnersCount?: Maybe<Scalars['Int']['output']>;
  processingPartnersMany: Array<ProcessorSettings>;
  /** Retrieve a single processing partner */
  processingPartnersOne?: Maybe<ProcessingPartnersOne>;
  processingPartnersOneById?: Maybe<ProcessorSettings>;
  processingPartnersOneByIds: Array<ProcessorSettings>;
  processingPartnersOneCount?: Maybe<Scalars['Int']['output']>;
  processingPartnersOneMany: Array<ProcessorSettings>;
  processingPartnersOneOne?: Maybe<ProcessorSettings>;
  processingPartnersOnePagination?: Maybe<ProcessorSettingsPagination>;
  processingPartnersPagination?: Maybe<ProcessorSettingsPagination>;
  processorCapabilityById?: Maybe<ProcessorCapability>;
  processorCapabilityByIds: Array<ProcessorCapability>;
  processorCapabilityCount?: Maybe<Scalars['Int']['output']>;
  processorCapabilityMany: Array<ProcessorCapability>;
  processorCapabilityOne?: Maybe<ProcessorCapability>;
  processorCapabilityPagination?: Maybe<ProcessorCapabilityPagination>;
  processorCapabilitySpecificationById?: Maybe<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationByIds: Array<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationCount?: Maybe<Scalars['Int']['output']>;
  processorCapabilitySpecificationMany: Array<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationOne?: Maybe<ProcessorCapabilitySpecification>;
  processorCapabilitySpecificationPagination?: Maybe<ProcessorCapabilitySpecificationPagination>;
  processorNotificationById?: Maybe<ProcessorNotification>;
  processorNotificationByIds: Array<ProcessorNotification>;
  processorNotificationCount?: Maybe<Scalars['Int']['output']>;
  processorNotificationMany: Array<ProcessorNotification>;
  processorNotificationOne?: Maybe<ProcessorNotification>;
  processorNotificationPagination?: Maybe<ProcessorNotificationPagination>;
  processorSchedulingById?: Maybe<ProcessorScheduling>;
  processorSchedulingByIds: Array<ProcessorScheduling>;
  processorSchedulingCount?: Maybe<Scalars['Int']['output']>;
  processorSchedulingMany: Array<ProcessorScheduling>;
  processorSchedulingOne?: Maybe<ProcessorScheduling>;
  processorSchedulingPagination?: Maybe<ProcessorSchedulingPagination>;
  processorSettingsById?: Maybe<ProcessorSettings>;
  processorSettingsByIds: Array<ProcessorSettings>;
  processorSettingsCount?: Maybe<Scalars['Int']['output']>;
  processorSettingsCustomCapacityById?: Maybe<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityByIds: Array<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityCount?: Maybe<Scalars['Int']['output']>;
  processorSettingsCustomCapacityMany: Array<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityOne?: Maybe<ProcessorSettingsCustomCapacity>;
  processorSettingsCustomCapacityPagination?: Maybe<ProcessorSettingsCustomCapacityPagination>;
  processorSettingsMany: Array<ProcessorSettings>;
  processorSettingsOne?: Maybe<ProcessorSettings>;
  processorSettingsPagination?: Maybe<ProcessorSettingsPagination>;
  /** Get all invoices with custom filters */
  searchInvoices?: Maybe<InvoicePagination>;
  stateById?: Maybe<State>;
  stateByIds: Array<State>;
  stateCount?: Maybe<Scalars['Int']['output']>;
  stateMany: Array<State>;
  stateOne?: Maybe<State>;
  statePagination?: Maybe<StatePagination>;
  tenantById?: Maybe<Tenant>;
  tenantByIds: Array<Tenant>;
  tenantCount?: Maybe<Scalars['Int']['output']>;
  tenantMany: Array<Tenant>;
  tenantOne?: Maybe<Tenant>;
  tenantPagination?: Maybe<TenantPagination>;
  userById?: Maybe<User>;
  userByIds: Array<User>;
  userCount?: Maybe<Scalars['Int']['output']>;
  userMany: Array<User>;
  userOne?: Maybe<User>;
  userPagination?: Maybe<UserPagination>;
  /** Get a user's settings by their user ID. */
  userSettingsByUserId?: Maybe<UserSettingsByUserId>;
  /** Get the user/tenant/vendor associated with a user. */
  userTenantVendor?: Maybe<User>;
  vendorById?: Maybe<Vendor>;
  vendorByIds: Array<Vendor>;
  vendorCount?: Maybe<Scalars['Int']['output']>;
  /** Retrieve a list of all vendors. */
  vendorList?: Maybe<Array<Maybe<Vendor>>>;
  vendorMany: Array<Vendor>;
  vendorOne?: Maybe<Vendor>;
  vendorPagination?: Maybe<VendorPagination>;
  waitlistById?: Maybe<Waitlist>;
  waitlistByIds: Array<Waitlist>;
  /** Retrieve the waitlist for a vendor. */
  waitlistByVendorId?: Maybe<Array<Maybe<Waitlist>>>;
  waitlistCount?: Maybe<Scalars['Int']['output']>;
  waitlistMany: Array<Waitlist>;
  waitlistOne?: Maybe<Waitlist>;
  waitlistPagination?: Maybe<WaitlistPagination>;
  webhookById?: Maybe<Vendor>;
  webhookByIds: Array<Vendor>;
  webhookCount?: Maybe<Scalars['Int']['output']>;
  webhookMany: Array<Vendor>;
  webhookOne?: Maybe<Vendor>;
  webhookPagination?: Maybe<VendorPagination>;
};


export type QueryAddressByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryAddressByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsAddressInput>;
};


export type QueryAddressCountArgs = {
  filter?: InputMaybe<FilterCountAddressInput>;
};


export type QueryAddressManyArgs = {
  filter?: InputMaybe<FilterFindManyAddressInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAddressInput>;
};


export type QueryAddressOneArgs = {
  filter?: InputMaybe<FilterFindOneAddressInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneAddressInput>;
};


export type QueryAddressPaginationArgs = {
  filter?: InputMaybe<FilterFindManyAddressInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyAddressInput>;
};


export type QueryCancellationReasonByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCancellationReasonByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCancellationReasonInput>;
};


export type QueryCancellationReasonCountArgs = {
  filter?: InputMaybe<FilterCountCancellationReasonInput>;
};


export type QueryCancellationReasonManyArgs = {
  filter?: InputMaybe<FilterFindManyCancellationReasonInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCancellationReasonInput>;
};


export type QueryCancellationReasonOneArgs = {
  filter?: InputMaybe<FilterFindOneCancellationReasonInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCancellationReasonInput>;
};


export type QueryCancellationReasonPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCancellationReasonInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCancellationReasonInput>;
};


export type QueryChatMessageByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryChatMessageByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsChatMessageInput>;
};


export type QueryChatMessageCountArgs = {
  filter?: InputMaybe<FilterCountChatMessageInput>;
};


export type QueryChatMessageManyArgs = {
  filter?: InputMaybe<FilterFindManyChatMessageInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChatMessageInput>;
};


export type QueryChatMessageOneArgs = {
  filter?: InputMaybe<FilterFindOneChatMessageInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneChatMessageInput>;
};


export type QueryChatMessagePaginationArgs = {
  filter?: InputMaybe<FilterFindManyChatMessageInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChatMessageInput>;
};


export type QueryChatRoomByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryChatRoomByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsChatRoomInput>;
};


export type QueryChatRoomCountArgs = {
  filter?: InputMaybe<FilterCountChatRoomInput>;
};


export type QueryChatRoomManyArgs = {
  filter?: InputMaybe<FilterFindManyChatRoomInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChatRoomInput>;
};


export type QueryChatRoomOneArgs = {
  filter?: InputMaybe<FilterFindOneChatRoomInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneChatRoomInput>;
};


export type QueryChatRoomPaginationArgs = {
  filter?: InputMaybe<FilterFindManyChatRoomInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyChatRoomInput>;
};


export type QueryCutsheetByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryCutsheetByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsCutsheetInput>;
};


export type QueryCutsheetCountArgs = {
  filter?: InputMaybe<FilterCountCutsheetInput>;
};


export type QueryCutsheetManyArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetInput>;
};


export type QueryCutsheetOneArgs = {
  filter?: InputMaybe<FilterFindOneCutsheetInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneCutsheetInput>;
};


export type QueryCutsheetPaginationArgs = {
  filter?: InputMaybe<FilterFindManyCutsheetInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyCutsheetInput>;
};


export type QueryFindNotificationSettingsByVendorIdArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryFindProcessorSchedulingByIdArgs = {
  _id: Scalars['MongoID']['input'];
  filter?: InputMaybe<FilterFindOneProcessorSchedulingInput>;
};


export type QueryFindProcessorSchedulingsWithMissingCutsheetsArgs = {
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryFindProcessorSchedulingsWithMissingHangingWeightsArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetFilteredProcessorSchedulingArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  searchByContact?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyProcessorSchedulingInput;
  statusFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetProcessorCustomersArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyUserInput;
  vendorId: Scalars['MongoID']['input'];
};


export type QueryGetProcessorSchedulingCalendarArgs = {
  endDate: Scalars['Date']['input'];
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  startDate: Scalars['Date']['input'];
  vendorId: Scalars['MongoID']['input'];
};


export type QueryIntegrationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryIntegrationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsIntegrationInput>;
};


export type QueryIntegrationCountArgs = {
  filter?: InputMaybe<FilterCountIntegrationInput>;
};


export type QueryIntegrationManyArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInput>;
};


export type QueryIntegrationOneArgs = {
  filter?: InputMaybe<FilterFindOneIntegrationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneIntegrationInput>;
};


export type QueryIntegrationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyIntegrationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInput>;
};


export type QueryInvoiceByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInvoiceByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsInvoiceInput>;
};


export type QueryInvoiceCountArgs = {
  filter?: InputMaybe<FilterCountInvoiceInput>;
};


export type QueryInvoiceLineItemByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryInvoiceLineItemByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemCountArgs = {
  filter?: InputMaybe<FilterCountInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemManyArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceLineItemInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemOneArgs = {
  filter?: InputMaybe<FilterFindOneInvoiceLineItemInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneInvoiceLineItemInput>;
};


export type QueryInvoiceLineItemPaginationArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceLineItemInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceLineItemInput>;
};


export type QueryInvoiceManyArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceInput>;
};


export type QueryInvoiceOneArgs = {
  filter?: InputMaybe<FilterFindOneInvoiceInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneInvoiceInput>;
};


export type QueryInvoicePaginationArgs = {
  filter?: InputMaybe<FilterFindManyInvoiceInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyInvoiceInput>;
};


export type QueryMessagesByChatRoomArgs = {
  chatRoomId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
};


export type QueryModuleByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryModuleByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsModuleInput>;
};


export type QueryModuleCountArgs = {
  filter?: InputMaybe<FilterCountModuleInput>;
};


export type QueryModuleManyArgs = {
  filter?: InputMaybe<FilterFindManyModuleInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyModuleInput>;
};


export type QueryModuleOneArgs = {
  filter?: InputMaybe<FilterFindOneModuleInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneModuleInput>;
};


export type QueryModulePaginationArgs = {
  filter?: InputMaybe<FilterFindManyModuleInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyModuleInput>;
};


export type QueryMyChatRoomsArgs = {
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort?: InputMaybe<SortFindManyChatRoomInput>;
};


export type QueryNoteByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNoteByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNoteInput>;
};


export type QueryNoteCountArgs = {
  filter?: InputMaybe<FilterCountNoteInput>;
};


export type QueryNoteManyArgs = {
  filter?: InputMaybe<FilterFindManyNoteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNoteInput>;
};


export type QueryNoteOneArgs = {
  filter?: InputMaybe<FilterFindOneNoteInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneNoteInput>;
};


export type QueryNotePaginationArgs = {
  filter?: InputMaybe<FilterFindManyNoteInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNoteInput>;
};


export type QueryNotificationSettingsByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryNotificationSettingsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsNotificationSettingInput>;
};


export type QueryNotificationSettingsCountArgs = {
  filter?: InputMaybe<FilterCountNotificationSettingInput>;
};


export type QueryNotificationSettingsManyArgs = {
  filter?: InputMaybe<FilterFindManyNotificationSettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationSettingInput>;
};


export type QueryNotificationSettingsOneArgs = {
  filter?: InputMaybe<FilterFindOneNotificationSettingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneNotificationSettingInput>;
};


export type QueryNotificationSettingsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyNotificationSettingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyNotificationSettingInput>;
};


export type QueryPrimalByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalInput>;
};


export type QueryPrimalCountArgs = {
  filter?: InputMaybe<FilterCountPrimalInput>;
};


export type QueryPrimalCutBlockerByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalCutBlockerByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerCountArgs = {
  filter?: InputMaybe<FilterCountPrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutBlockerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalCutBlockerInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalCutBlockerInput>;
};


export type QueryPrimalCutBlockerPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutBlockerInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutBlockerInput>;
};


export type QueryPrimalCutByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalCutByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutInput>;
};


export type QueryPrimalCutCountArgs = {
  filter?: InputMaybe<FilterCountPrimalCutInput>;
};


export type QueryPrimalCutManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutInput>;
};


export type QueryPrimalCutOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalCutInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalCutInput>;
};


export type QueryPrimalCutPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutInput>;
};


export type QueryPrimalCutTypeByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalCutTypeByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalCutTypeInput>;
};


export type QueryPrimalCutTypeCountArgs = {
  filter?: InputMaybe<FilterCountPrimalCutTypeInput>;
};


export type QueryPrimalCutTypeManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutTypeInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutTypeInput>;
};


export type QueryPrimalCutTypeOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalCutTypeInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalCutTypeInput>;
};


export type QueryPrimalCutTypePaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalCutTypeInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalCutTypeInput>;
};


export type QueryPrimalGroupByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryPrimalGroupByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsPrimalGroupInput>;
};


export type QueryPrimalGroupCountArgs = {
  filter?: InputMaybe<FilterCountPrimalGroupInput>;
};


export type QueryPrimalGroupManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
};


export type QueryPrimalGroupOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalGroupInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalGroupInput>;
};


export type QueryPrimalGroupPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalGroupInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
};


export type QueryPrimalManyArgs = {
  filter?: InputMaybe<FilterFindManyPrimalInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalInput>;
};


export type QueryPrimalOneArgs = {
  filter?: InputMaybe<FilterFindOnePrimalInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOnePrimalInput>;
};


export type QueryPrimalPaginationArgs = {
  filter?: InputMaybe<FilterFindManyPrimalInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyPrimalInput>;
};


export type QueryProcessingPartnersArgs = {
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryProcessingPartnersByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessingPartnersByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsInput>;
};


export type QueryProcessingPartnersCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsInput>;
};


export type QueryProcessingPartnersManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
};


export type QueryProcessingPartnersOneByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessingPartnersOneByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessingPartnersOneOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsInput>;
};


export type QueryProcessingPartnersOnePaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessingPartnersPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessorCapabilityByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorCapabilityByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityCountArgs = {
  filter?: InputMaybe<FilterCountProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorCapabilityInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorCapabilityInput>;
};


export type QueryProcessorCapabilityPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilityInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilityInput>;
};


export type QueryProcessorCapabilitySpecificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorCapabilitySpecificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationCountArgs = {
  filter?: InputMaybe<FilterCountProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilitySpecificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorCapabilitySpecificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorCapabilitySpecificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorCapabilitySpecificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorCapabilitySpecificationInput>;
};


export type QueryProcessorNotificationByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorNotificationByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorNotificationInput>;
};


export type QueryProcessorNotificationCountArgs = {
  filter?: InputMaybe<FilterCountProcessorNotificationInput>;
};


export type QueryProcessorNotificationManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorNotificationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorNotificationInput>;
};


export type QueryProcessorNotificationOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorNotificationInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorNotificationInput>;
};


export type QueryProcessorNotificationPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorNotificationInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorNotificationInput>;
};


export type QueryProcessorSchedulingByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorSchedulingByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSchedulingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSchedulingInput>;
};


export type QueryProcessorSchedulingPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSchedulingInput>;
};


export type QueryProcessorSettingsByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorSettingsByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsInput>;
};


export type QueryProcessorSettingsCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsInput>;
};


export type QueryProcessorSettingsCustomCapacityByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryProcessorSettingsCustomCapacityByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityCountArgs = {
  filter?: InputMaybe<FilterCountProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSettingsCustomCapacityInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsCustomCapacityPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsCustomCapacityInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsCustomCapacityInput>;
};


export type QueryProcessorSettingsManyArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QueryProcessorSettingsOneArgs = {
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsInput>;
};


export type QueryProcessorSettingsPaginationArgs = {
  filter?: InputMaybe<FilterFindManyProcessorSettingsInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProcessorSettingsInput>;
};


export type QuerySearchInvoicesArgs = {
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyInvoiceInput;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  type: Scalars['String']['input'];
};


export type QueryStateByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryStateByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsStateInput>;
};


export type QueryStateCountArgs = {
  filter?: InputMaybe<FilterCountStateInput>;
};


export type QueryStateManyArgs = {
  filter?: InputMaybe<FilterFindManyStateInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyStateInput>;
};


export type QueryStateOneArgs = {
  filter?: InputMaybe<FilterFindOneStateInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneStateInput>;
};


export type QueryStatePaginationArgs = {
  filter?: InputMaybe<FilterFindManyStateInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyStateInput>;
};


export type QueryTenantByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryTenantByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsTenantInput>;
};


export type QueryTenantCountArgs = {
  filter?: InputMaybe<FilterCountTenantInput>;
};


export type QueryTenantManyArgs = {
  filter?: InputMaybe<FilterFindManyTenantInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTenantInput>;
};


export type QueryTenantOneArgs = {
  filter?: InputMaybe<FilterFindOneTenantInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneTenantInput>;
};


export type QueryTenantPaginationArgs = {
  filter?: InputMaybe<FilterFindManyTenantInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyTenantInput>;
};


export type QueryUserByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryUserByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsUserInput>;
};


export type QueryUserCountArgs = {
  filter?: InputMaybe<FilterCountUserInput>;
};


export type QueryUserManyArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryUserOneArgs = {
  filter?: InputMaybe<FilterFindOneUserInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneUserInput>;
};


export type QueryUserPaginationArgs = {
  filter?: InputMaybe<FilterFindManyUserInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type QueryUserSettingsByUserIdArgs = {
  userId: Scalars['MongoID']['input'];
};


export type QueryVendorByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryVendorByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsVendorInput>;
};


export type QueryVendorCountArgs = {
  filter?: InputMaybe<FilterCountVendorInput>;
};


export type QueryVendorListArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type QueryVendorManyArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};


export type QueryVendorOneArgs = {
  filter?: InputMaybe<FilterFindOneVendorInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVendorInput>;
};


export type QueryVendorPaginationArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};


export type QueryWaitlistByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWaitlistByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsWaitlistInput>;
};


export type QueryWaitlistByVendorIdArgs = {
  vendorId: Scalars['MongoID']['input'];
};


export type QueryWaitlistCountArgs = {
  filter?: InputMaybe<FilterCountWaitlistInput>;
};


export type QueryWaitlistManyArgs = {
  filter?: InputMaybe<FilterFindManyWaitlistInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWaitlistInput>;
};


export type QueryWaitlistOneArgs = {
  filter?: InputMaybe<FilterFindOneWaitlistInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneWaitlistInput>;
};


export type QueryWaitlistPaginationArgs = {
  filter?: InputMaybe<FilterFindManyWaitlistInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyWaitlistInput>;
};


export type QueryWebhookByIdArgs = {
  _id: Scalars['MongoID']['input'];
};


export type QueryWebhookByIdsArgs = {
  _ids: Array<Scalars['MongoID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsVendorInput>;
};


export type QueryWebhookCountArgs = {
  filter?: InputMaybe<FilterCountVendorInput>;
};


export type QueryWebhookManyArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};


export type QueryWebhookOneArgs = {
  filter?: InputMaybe<FilterFindOneVendorInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneVendorInput>;
};


export type QueryWebhookPaginationArgs = {
  filter?: InputMaybe<FilterFindManyVendorInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};

export type RefundInvoiceInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['MongoID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RequesterContactInformationInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RuntimeError = ErrorInterface & {
  __typename?: 'RuntimeError';
  /** Runtime error message */
  message?: Maybe<Scalars['String']['output']>;
};

export enum SortFindByIdsAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsChatMessageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsChatRoomInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsInvoiceInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsModuleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsPrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorCapabilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorSettingsCustomCapacityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsUserInput {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindByIdsWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyChatMessageInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyChatRoomInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInvoiceInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyModuleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyPrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorCapabilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorSettingsCustomCapacityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyProductInput {
  IsInternalAsc = 'IS_INTERNAL_ASC',
  IsInternalDesc = 'IS_INTERNAL_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyStateInput {
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyUserInput {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyVendorInput {
  /** Sort by date created ascending. */
  DateCreatedAsc = 'DATE_CREATED_ASC',
  /** Sort by date created descending. */
  DateCreatedDesc = 'DATE_CREATED_DESC',
  VendorNameAsc = 'VENDOR_NAME_ASC',
  VendorNameDesc = 'VENDOR_NAME_DESC',
  VendorNumberAsc = 'VENDOR_NUMBER_ASC',
  VendorNumberDesc = 'VENDOR_NUMBER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindManyWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneChatMessageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneChatRoomInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneInvoiceInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneModuleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOnePrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorCapabilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorSettingsCustomCapacityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneUserInput {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortFindOneWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyChatMessageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyChatRoomInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyInvoiceInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyModuleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyPrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorCapabilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorSettingsCustomCapacityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyUserInput {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateManyWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneAddressInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCancellationReasonInput {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneChatMessageInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneChatRoomInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneCutsheetInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneIntegrationInput {
  EndpointAsc = 'ENDPOINT_ASC',
  EndpointDesc = 'ENDPOINT_DESC',
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  VendorNameAsc = 'VENDOR__NAME_ASC',
  VendorNameDesc = 'VENDOR__NAME_DESC',
  VendorNameKeyAsc = 'VENDOR__NAME__KEY_ASC',
  VendorNameKeyDesc = 'VENDOR__NAME__KEY_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneInvoiceInput {
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneInvoiceLineItemInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneModuleInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneNoteInput {
  UpdatedatAsc = 'UPDATEDAT_ASC',
  UpdatedatDesc = 'UPDATEDAT_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneNotificationSettingInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalCutBlockerInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalCutInput {
  PrimalAsc = 'PRIMAL_ASC',
  PrimalDesc = 'PRIMAL_DESC',
  PrimalTypeAsc = 'PRIMAL__TYPE_ASC',
  PrimalTypeDesc = 'PRIMAL__TYPE_DESC',
  PrimalTypeOrderAsc = 'PRIMAL__TYPE__ORDER_ASC',
  PrimalTypeOrderDesc = 'PRIMAL__TYPE__ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalCutTypeInput {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  NameProcessorsettingsAsc = 'NAME__PROCESSORSETTINGS_ASC',
  NameProcessorsettingsDesc = 'NAME__PROCESSORSETTINGS_DESC',
  NameProcessorsettingsAnimalspeciesAsc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_ASC',
  NameProcessorsettingsAnimalspeciesDesc = 'NAME__PROCESSORSETTINGS__ANIMALSPECIES_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalGroupInput {
  OrderAsc = 'ORDER_ASC',
  OrderDesc = 'ORDER_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOnePrimalInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorCapabilityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorCapabilitySpecificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorNotificationInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorSchedulingInput {
  DropoffdateAsc = 'DROPOFFDATE_ASC',
  DropoffdateDesc = 'DROPOFFDATE_DESC',
  JobidAsc = 'JOBID_ASC',
  JobidDesc = 'JOBID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorSettingsCustomCapacityInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneProcessorSettingsInput {
  VendorAsc = 'VENDOR_ASC',
  VendorDesc = 'VENDOR_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneStateInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneTenantInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneUserInput {
  EmailAsc = 'EMAIL_ASC',
  EmailDesc = 'EMAIL_DESC',
  PhoneAsc = 'PHONE_ASC',
  PhoneDesc = 'PHONE_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneVendorInput {
  DateCreatedAsc = 'DATE_CREATED_ASC',
  DateCreatedDesc = 'DATE_CREATED_DESC',
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export enum SortUpdateOneWaitlistInput {
  IdAsc = '_ID_ASC',
  IdDesc = '_ID_DESC'
}

export type SpeciesComplexAnimalCapacitySchema = {
  __typename?: 'SpeciesComplexAnimalCapacitySchema';
  species?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type SpeciesInspectionComplexAnimalCapacitySchema = {
  __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema';
  inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel;
  species?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type State = {
  __typename?: 'State';
  _id: Scalars['MongoID']['output'];
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** List of items with pagination. */
export type StatePagination = {
  __typename?: 'StatePagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<State>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type Tenant = {
  __typename?: 'Tenant';
  _id: Scalars['MongoID']['output'];
  date_created: Scalars['Date']['output'];
  domain?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_ids?: Maybe<Scalars['JSON']['output']>;
  modules: Array<Module>;
  name: Scalars['String']['output'];
  picture_url?: Maybe<Scalars['String']['output']>;
  primary_color?: Maybe<Scalars['String']['output']>;
  users: Array<User>;
  vendors: Array<Vendor>;
};


export type TenantModulesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindByIdsModuleInput>;
};


export type TenantUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyUserInput>;
};


export type TenantVendorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyVendorInput>;
};

/** List of items with pagination. */
export type TenantPagination = {
  __typename?: 'TenantPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Tenant>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UpdateByIdAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type UpdateByIdAddressPayload = {
  __typename?: 'UpdateByIdAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Address>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdCancellationReasonPayload = {
  __typename?: 'UpdateByIdCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CancellationReason>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChatMessageInput = {
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdChatMessagePayload = {
  __typename?: 'UpdateByIdChatMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChatMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdChatRoomPayload = {
  __typename?: 'UpdateByIdChatRoomPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChatRoom>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type UpdateByIdCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<UpdateByIdCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdCutsheetPayload = {
  __typename?: 'UpdateByIdCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Cutsheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type UpdateByIdDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type UpdateByIdDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<UpdateByIdDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdIntegrationPayload = {
  __typename?: 'UpdateByIdIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Integration>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateByIdInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdInvoiceLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateByIdInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<UpdateByIdInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInvoiceLineItemPayload = {
  __typename?: 'UpdateByIdInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<InvoiceLineItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdInvoicePayload = {
  __typename?: 'UpdateByIdInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Invoice>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type UpdateByIdModuleInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdModulePayload = {
  __typename?: 'UpdateByIdModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Module>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdNotePayload = {
  __typename?: 'UpdateByIdNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<UpdateByIdNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<EnumNotificationSettingTrigger>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdNotificationSettingPayload = {
  __typename?: 'UpdateByIdNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NotificationSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type UpdateByIdPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPrimalCutBlockerInput = {
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<UpdateByIdPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdPrimalCutBlockerPayload = {
  __typename?: 'UpdateByIdPrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutBlocker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalCutPayload = {
  __typename?: 'UpdateByIdPrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCut>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalCutTypePayload = {
  __typename?: 'UpdateByIdPrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalGroupPayload = {
  __typename?: 'UpdateByIdPrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdPrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdPrimalPayload = {
  __typename?: 'UpdateByIdPrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Primal>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type UpdateByIdProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorCapabilityPayload = {
  __typename?: 'UpdateByIdProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdProcessorCapabilitySpecificationPayload = {
  __typename?: 'UpdateByIdProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type UpdateByIdProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorNotificationPayload = {
  __typename?: 'UpdateByIdProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type UpdateByIdProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<UpdateByIdProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<UpdateByIdProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<UpdateByIdProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<UpdateByIdProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<UpdateByIdProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type UpdateByIdProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSchedulingInvoicesPricingInput>>>;
};

export type UpdateByIdProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type UpdateByIdProcessorSchedulingNotificationHistoryErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdProcessorSchedulingNotificationHistoryInput = {
  errorMessage?: InputMaybe<UpdateByIdProcessorSchedulingNotificationHistoryErrorMessageInput>;
  notificationType?: InputMaybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorSchedulingPayload = {
  __typename?: 'UpdateByIdProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorScheduling>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type UpdateByIdProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type UpdateByIdProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateByIdDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateByIdDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateByIdProcessorSettingsCustomCapacityPayload = {
  __typename?: 'UpdateByIdProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettingsCustomCapacity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type UpdateByIdProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type UpdateByIdProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<UpdateByIdProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<UpdateByIdProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateByIdProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type UpdateByIdProcessorSettingsPayload = {
  __typename?: 'UpdateByIdProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateByIdStateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdStatePayload = {
  __typename?: 'UpdateByIdStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<State>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdTenantInput = {
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateByIdTenantPayload = {
  __typename?: 'UpdateByIdTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tenant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UpdateByIdUserSettingsInput>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdUserPayload = {
  __typename?: 'UpdateByIdUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateByIdUserSettingsInput = {
  calendar?: InputMaybe<UpdateByIdUserSettingsCalendarInput>;
};

export type UpdateByIdVendorInput = {
  address?: InputMaybe<UpdateByIdAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateByIdVendorPayload = {
  __typename?: 'UpdateByIdVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Vendor>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateByIdWaitlistInput = {
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateByIdWaitlistPayload = {
  __typename?: 'UpdateByIdWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Waitlist>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateInvoiceInput = {
  description: Scalars['String']['input'];
  id: Scalars['MongoID']['input'];
  invoiceNumber: Scalars['String']['input'];
  line_items?: InputMaybe<Array<InputMaybe<InvoiceUpdateLineItemInput>>>;
};

export type UpdateManyAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type UpdateManyAddressPayload = {
  __typename?: 'UpdateManyAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyCancellationReasonPayload = {
  __typename?: 'UpdateManyCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyChatMessageInput = {
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyChatMessagePayload = {
  __typename?: 'UpdateManyChatMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyChatRoomPayload = {
  __typename?: 'UpdateManyChatRoomPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type UpdateManyCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<UpdateManyCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyCutsheetPayload = {
  __typename?: 'UpdateManyCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type UpdateManyDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type UpdateManyDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<UpdateManyDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyIntegrationPayload = {
  __typename?: 'UpdateManyIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateManyInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateManyInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateManyInvoiceLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateManyInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<UpdateManyInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyInvoiceLineItemPayload = {
  __typename?: 'UpdateManyInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyInvoicePayload = {
  __typename?: 'UpdateManyInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type UpdateManyModuleInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyModulePayload = {
  __typename?: 'UpdateManyModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyNotePayload = {
  __typename?: 'UpdateManyNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<UpdateManyNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<EnumNotificationSettingTrigger>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyNotificationSettingPayload = {
  __typename?: 'UpdateManyNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type UpdateManyPrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyPrimalCutBlockerInput = {
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<UpdateManyPrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyPrimalCutBlockerPayload = {
  __typename?: 'UpdateManyPrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalCutPayload = {
  __typename?: 'UpdateManyPrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalCutTypePayload = {
  __typename?: 'UpdateManyPrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalGroupPayload = {
  __typename?: 'UpdateManyPrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyPrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyPrimalPayload = {
  __typename?: 'UpdateManyPrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type UpdateManyProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorCapabilityPayload = {
  __typename?: 'UpdateManyProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyProcessorCapabilitySpecificationPayload = {
  __typename?: 'UpdateManyProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type UpdateManyProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorNotificationPayload = {
  __typename?: 'UpdateManyProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type UpdateManyProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<UpdateManyProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<UpdateManyProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<UpdateManyProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<UpdateManyProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<UpdateManyProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type UpdateManyProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSchedulingInvoicesPricingInput>>>;
};

export type UpdateManyProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type UpdateManyProcessorSchedulingNotificationHistoryErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyProcessorSchedulingNotificationHistoryInput = {
  errorMessage?: InputMaybe<UpdateManyProcessorSchedulingNotificationHistoryErrorMessageInput>;
  notificationType?: InputMaybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorSchedulingPayload = {
  __typename?: 'UpdateManyProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type UpdateManyProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type UpdateManyProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateManyDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateManyDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateManyProcessorSettingsCustomCapacityPayload = {
  __typename?: 'UpdateManyProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type UpdateManyProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type UpdateManyProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type UpdateManyProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<UpdateManyProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<UpdateManyProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateManyProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type UpdateManyProcessorSettingsPayload = {
  __typename?: 'UpdateManyProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateManyStateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyStatePayload = {
  __typename?: 'UpdateManyStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyTenantInput = {
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManyTenantPayload = {
  __typename?: 'UpdateManyTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UpdateManyUserSettingsInput>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyUserPayload = {
  __typename?: 'UpdateManyUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateManyUserSettingsInput = {
  calendar?: InputMaybe<UpdateManyUserSettingsCalendarInput>;
};

export type UpdateManyVendorInput = {
  address?: InputMaybe<UpdateManyAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateManyVendorPayload = {
  __typename?: 'UpdateManyVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateManyWaitlistInput = {
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateManyWaitlistPayload = {
  __typename?: 'UpdateManyWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Affected documents number */
  numAffected?: Maybe<Scalars['Int']['output']>;
};

export type UpdateOneAddressInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  address_1?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumAddressType>;
};

export type UpdateOneAddressPayload = {
  __typename?: 'UpdateOneAddressPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Address>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCancellationReasonInput = {
  index?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneCancellationReasonPayload = {
  __typename?: 'UpdateOneCancellationReasonPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<CancellationReason>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneChatMessageInput = {
  chatRoom?: InputMaybe<Scalars['MongoID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  sender?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneChatMessagePayload = {
  __typename?: 'UpdateOneChatMessagePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChatMessage>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneChatRoomInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  lastMessage?: InputMaybe<Scalars['MongoID']['input']>;
  participants?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneChatRoomPayload = {
  __typename?: 'UpdateOneChatRoomPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ChatRoom>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumCutsheetExtrasType>;
};

export type UpdateOneCutsheetInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  animalType?: InputMaybe<EnumCutsheetAnimalType>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetExtrasInput>>>;
  groundMeatSize?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['JSON']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  roastSize?: InputMaybe<Scalars['String']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  steakThickness?: InputMaybe<Scalars['Float']['input']>;
  steaksPerPack?: InputMaybe<Scalars['Float']['input']>;
  trim?: InputMaybe<Array<InputMaybe<UpdateOneCutsheetTrimInput>>>;
  type?: InputMaybe<EnumCutsheetType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneCutsheetPayload = {
  __typename?: 'UpdateOneCutsheetPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Cutsheet>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneCutsheetTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isAllTrim?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Float']['input']>;
  trimSelection?: InputMaybe<EnumCutsheetTrimTrimSelection>;
};

export type UpdateOneDailyCapacityCapacitiesByTypeInput = {
  capacities?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput>>>;
  type?: InputMaybe<EnumDailyCapacityCapacitiesByTypeType>;
};

export type UpdateOneDailyCapacityInput = {
  capacitiesByType?: InputMaybe<Array<InputMaybe<UpdateOneDailyCapacityCapacitiesByTypeInput>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneIntegrationInput = {
  config?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  endpoint?: InputMaybe<Scalars['String']['input']>;
  isSyncing?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  lastSynced?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<EnumIntegrationName>;
  secret?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumIntegrationType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneIntegrationPayload = {
  __typename?: 'UpdateOneIntegrationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Integration>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneInvoiceDiscountsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  applied_amount?: InputMaybe<Scalars['Float']['input']>;
  coupon_code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumInvoiceDiscountsType>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneInvoiceExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneInvoiceInput = {
  amount_discounted?: InputMaybe<Scalars['Float']['input']>;
  amount_due?: InputMaybe<Scalars['Float']['input']>;
  amount_paid?: InputMaybe<Scalars['Float']['input']>;
  amount_refunded?: InputMaybe<Scalars['Float']['input']>;
  billing_month?: InputMaybe<Scalars['Float']['input']>;
  billing_year?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceDiscountsInput>>>;
  due_date?: InputMaybe<Scalars['Date']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateOneInvoiceExternal_LinksInput>;
  links?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceLinksInput>>>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EnumInvoiceStatus>;
  status_changes?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceStatus_ChangesInput>>>;
  type?: InputMaybe<EnumInvoiceType>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneInvoiceLineItemExternal_LinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  quickbooks?: InputMaybe<Scalars['JSON']['input']>;
  stripe?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneInvoiceLineItemInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_links?: InputMaybe<UpdateOneInvoiceLineItemExternal_LinksInput>;
  invoice?: InputMaybe<Scalars['MongoID']['input']>;
  links?: InputMaybe<Array<InputMaybe<UpdateOneInvoiceLineItemLinksInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneInvoiceLineItemLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLineItemLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneInvoiceLineItemPayload = {
  __typename?: 'UpdateOneInvoiceLineItemPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<InvoiceLineItem>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneInvoiceLinksInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<EnumInvoiceLinksEntityType>;
  parentEntityId?: InputMaybe<Scalars['MongoID']['input']>;
  subEntityId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneInvoicePayload = {
  __typename?: 'UpdateOneInvoicePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Invoice>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneInvoiceStatus_ChangesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  new_status?: InputMaybe<EnumInvoiceStatus_ChangesNew_Status>;
  previous_status?: InputMaybe<EnumInvoiceStatus_ChangesPrevious_Status>;
};

export type UpdateOneModuleInput = {
  href?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneModulePayload = {
  __typename?: 'UpdateOneModulePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Module>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneNoteInput = {
  attachmentUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  createdBy?: InputMaybe<Scalars['MongoID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneNotePayload = {
  __typename?: 'UpdateOneNotePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Note>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneNotificationSettingInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  emailMessage?: InputMaybe<Scalars['MongoID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSMS?: InputMaybe<Scalars['Boolean']['input']>;
  smsMessage?: InputMaybe<Scalars['MongoID']['input']>;
  timings?: InputMaybe<Array<InputMaybe<UpdateOneNotificationSettingTimingsInput>>>;
  trigger?: InputMaybe<EnumNotificationSettingTrigger>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneNotificationSettingPayload = {
  __typename?: 'UpdateOneNotificationSettingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<NotificationSetting>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneNotificationSettingTimingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  days?: InputMaybe<Scalars['Float']['input']>;
  relation?: InputMaybe<EnumNotificationSettingTimingsRelation>;
};

export type UpdateOnePrimalCutBlockerBlockedByInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOnePrimalCutBlockerInput = {
  animalSpecies?: InputMaybe<Scalars['String']['input']>;
  blockedBy?: InputMaybe<Array<InputMaybe<UpdateOnePrimalCutBlockerBlockedByInput>>>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primalCutId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOnePrimalCutBlockerPayload = {
  __typename?: 'UpdateOnePrimalCutBlockerPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutBlocker>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalCutInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutType?: InputMaybe<Scalars['MongoID']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  primal?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumPrimalCutType>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalCutPayload = {
  __typename?: 'UpdateOnePrimalCutPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCut>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalCutTypeInput = {
  animalSpecies?: InputMaybe<EnumPrimalCutTypeAnimalSpecies>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lid?: InputMaybe<EnumPrimalCutTypeLid>;
  name?: InputMaybe<Scalars['String']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalCutTypePayload = {
  __typename?: 'UpdateOnePrimalCutTypePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalCutType>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalGroupInput = {
  animalSpecies?: InputMaybe<EnumPrimalGroupAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumPrimalGroupInspectionLevel>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalGroupPayload = {
  __typename?: 'UpdateOnePrimalGroupPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<PrimalGroup>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOnePrimalInput = {
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  deletedAt?: InputMaybe<Scalars['Date']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['MongoID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOnePrimalPayload = {
  __typename?: 'UpdateOnePrimalPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Primal>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorCapabilityExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorCapabilityExtrasType>;
};

export type UpdateOneProcessorCapabilityInput = {
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  animalSpecies?: InputMaybe<EnumProcessorCapabilityAnimalSpecies>;
  animalType?: InputMaybe<Scalars['String']['input']>;
  canSelectMoreThanOneTrim?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilityExtrasInput>>>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorCapabilityInspectionLevel>;
  primalCuts?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  specificationSnapshots?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>>>;
  trim?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilityTrimInput>>>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
  trimSelection?: InputMaybe<EnumProcessorCapabilityTrimSelection>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorCapabilityPayload = {
  __typename?: 'UpdateOneProcessorCapabilityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapability>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorCapabilitySpecificationInput = {
  capability?: InputMaybe<Scalars['MongoID']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  specifications?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilitySpecificationSpecificationsInput>>>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneProcessorCapabilitySpecificationPayload = {
  __typename?: 'UpdateOneProcessorCapabilitySpecificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorCapabilitySpecification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorCapabilitySpecificationSpecificationsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fid?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  measurementUnit?: InputMaybe<EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<InputMaybe<UpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput>>>;
};

export type UpdateOneProcessorCapabilitySpecificationSpecificationsOptionsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorCapabilityTrimInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  minLbs?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorNotificationInput = {
  errorMessage?: InputMaybe<Scalars['JSON']['input']>;
  notificationType?: InputMaybe<Scalars['String']['input']>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EnumProcessorNotificationType>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorNotificationPayload = {
  __typename?: 'UpdateOneProcessorNotificationPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorNotification>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contactUser?: InputMaybe<Scalars['MongoID']['input']>;
  cutsheet?: InputMaybe<Scalars['MongoID']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  splitPart?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  cutDate?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  dateFirstEnteredHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  dateUpdatedHangingWeight?: InputMaybe<Scalars['Date']['input']>;
  grade?: InputMaybe<Scalars['String']['input']>;
  hangingWeight?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideA?: InputMaybe<Scalars['Float']['input']>;
  hangingWeightSideB?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<EnumProcessorSchedulingAnimalHeadsInspectionLevel>;
  invoice?: InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceInput>;
  invoice_line_item?: InputMaybe<Scalars['MongoID']['input']>;
  isHangingWeightPerSide?: InputMaybe<Scalars['Boolean']['input']>;
  isKillAndChill?: InputMaybe<Scalars['Boolean']['input']>;
  isOverThirtyMonths?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in format MM/DD/YYYY. */
  killDate?: InputMaybe<Scalars['Date']['input']>;
  liveWeight?: InputMaybe<Scalars['Float']['input']>;
  producerIdentifier?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['String']['input']>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  tracking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalChargesInput>>>;
  additionalCost?: InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceAdditionalCostInput>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsInput>;
  trims?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput>>>;
};

export type UpdateOneProcessorSchedulingAnimalHeadsInvoiceTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingDepositCheckoutSessionInput = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  payment_intent?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingDepositInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  checkoutSession?: InputMaybe<UpdateOneProcessorSchedulingDepositCheckoutSessionInput>;
  price_external_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInput = {
  additionalPickupDetails?: InputMaybe<Scalars['String']['input']>;
  animalHeads?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsInput>>>;
  animalSpecies?: InputMaybe<EnumProcessorSchedulingAnimalSpecies>;
  animalType?: InputMaybe<EnumProcessorSchedulingAnimalType>;
  blockIndex?: InputMaybe<Scalars['Float']['input']>;
  blockTitle?: InputMaybe<Scalars['String']['input']>;
  butcherSlotPrice?: InputMaybe<Scalars['Float']['input']>;
  cancellationCustomText?: InputMaybe<Scalars['String']['input']>;
  cancellationReason?: InputMaybe<Scalars['MongoID']['input']>;
  cancelledAt?: InputMaybe<Scalars['String']['input']>;
  completedDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  cutsheetInformation?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingAnimalHeadsCutsheetInformationInput>>>;
  deposit?: InputMaybe<UpdateOneProcessorSchedulingDepositInput>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  dropoffDate?: InputMaybe<Scalars['Date']['input']>;
  headCount?: InputMaybe<Scalars['Float']['input']>;
  invoice?: InputMaybe<UpdateOneProcessorSchedulingInvoiceInput>;
  invoices?: InputMaybe<UpdateOneProcessorSchedulingInvoicesInput>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnBehalfOf?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  killedDate?: InputMaybe<Scalars['Date']['input']>;
  notificationHistory?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingNotificationHistoryInput>>>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  requestedBy?: InputMaybe<Scalars['MongoID']['input']>;
  scheduledDate?: InputMaybe<Scalars['Date']['input']>;
  source?: InputMaybe<EnumProcessorSchedulingSource>;
  status?: InputMaybe<EnumProcessorSchedulingStatus>;
  statusLastUpdated?: InputMaybe<Scalars['Date']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorSchedulingInvoiceAdditionalCostInput = {
  cost?: InputMaybe<Scalars['Float']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInvoiceInput = {
  additionalCost?: InputMaybe<UpdateOneProcessorSchedulingInvoiceAdditionalCostInput>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvoicePDF?: InputMaybe<Scalars['Boolean']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  invoice_external_id?: InputMaybe<Scalars['String']['input']>;
  invoice_status?: InputMaybe<Scalars['String']['input']>;
  isPayAtPickup?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendPaymentLink?: InputMaybe<Scalars['Boolean']['input']>;
  splits?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsInput>>>;
  userId?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput = {
  categories?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsCategoriesInput>>>;
  totalWeight?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  additionalCharges?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsAdditionalChargesInput>>>;
  animalHeadPublicId?: InputMaybe<Scalars['String']['input']>;
  extras?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsExtrasInput>>>;
  finishedWeights?: InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsFinishedWeightsInput>;
  splitType?: InputMaybe<Scalars['String']['input']>;
  trims?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput>>>;
};

export type UpdateOneProcessorSchedulingInvoicesContactsSplitsTrimsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSchedulingInvoicesInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesContactsInput>>>;
  pricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSchedulingInvoicesPricingInput>>>;
};

export type UpdateOneProcessorSchedulingInvoicesPricingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<EnumProcessorSchedulingInvoicesPricingType>;
};

export type UpdateOneProcessorSchedulingNotificationHistoryErrorMessageInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneProcessorSchedulingNotificationHistoryInput = {
  errorMessage?: InputMaybe<UpdateOneProcessorSchedulingNotificationHistoryErrorMessageInput>;
  notificationType?: InputMaybe<EnumProcessorSchedulingNotificationHistoryNotificationType>;
  sentOn?: InputMaybe<Scalars['Date']['input']>;
  sentTo?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorSchedulingPayload = {
  __typename?: 'UpdateOneProcessorSchedulingPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorScheduling>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput = {
  animal?: InputMaybe<Scalars['String']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies>;
};

export type UpdateOneProcessorSettingsAnimalSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsAutoSchedulingSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  cutDateDays?: InputMaybe<Scalars['Float']['input']>;
  harvestDateDays?: InputMaybe<Scalars['Float']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<EnumProcessorSettingsAutoSchedulingSettingsSpecies>;
};

export type UpdateOneProcessorSettingsCapacitySettingsDailyCapacityCapacityInput = {
  inspectionLevel?: InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>;
  species?: InputMaybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsCapacitySettingsInput = {
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateOneDailyCapacityInput>>>;
  dayOfWeek?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSettingsCarcassSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  currentNumber?: InputMaybe<Scalars['Float']['input']>;
  inspectionLevel?: InputMaybe<Scalars['String']['input']>;
  lastTakenNumber?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneProcessorSettingsCustomCapacityInput = {
  /** Map<K=EProcessingAnimals, Number> where key is in EProcessingAnimals and Number is the new capacity for the day */
  capacity?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<UpdateOneDailyCapacityInput>>>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  date?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  processorSettings?: InputMaybe<Scalars['MongoID']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateOneProcessorSettingsCustomCapacityPayload = {
  __typename?: 'UpdateOneProcessorSettingsCustomCapacityPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettingsCustomCapacity>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSettingsDocumentSettingsCarcassTagInput = {
  title?: InputMaybe<EnumProcessorSettingsDocumentSettingsCarcassTagTitle>;
};

export type UpdateOneProcessorSettingsDocumentSettingsCutsheetInput = {
  format?: InputMaybe<EnumProcessorSettingsDocumentSettingsCutsheetFormat>;
};

export type UpdateOneProcessorSettingsDocumentSettingsInput = {
  carcassTag?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCarcassTagInput>;
  cutsheet?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsCutsheetInput>;
};

export type UpdateOneProcessorSettingsInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsInput>>>;
  animals?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimals>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAutoSchedulingSettingsInput>>>;
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  capacityConfigurationType?: InputMaybe<EnumProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsCapacitySettingsInput>>>;
  carcassSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsCarcassSettingsInput>>>;
  commercialStartDate?: InputMaybe<Scalars['Date']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsAnimalSettingsButcherSlotPricingInput>>>;
  documentSettings?: InputMaybe<UpdateOneProcessorSettingsDocumentSettingsInput>;
  enabledAnimalSplits?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faq?: InputMaybe<Scalars['String']['input']>;
  invoicing?: InputMaybe<UpdateOneProcessorSettingsInvoicingInput>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsKillAndChillSettingsInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundDeadlineDays?: InputMaybe<Scalars['Float']['input']>;
  schedulingDeposit?: InputMaybe<Scalars['Float']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  validationErrors?: InputMaybe<Array<InputMaybe<UpdateOneProcessorSettingsValidationErrorsInput>>>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneProcessorSettingsInvoicingInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  defaultSplitRule?: InputMaybe<EnumProcessorSettingsInvoicingDefaultSplitRule>;
  showYieldOnInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  trackYields?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneProcessorSettingsKillAndChillSettingsInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pricePerHead?: InputMaybe<Scalars['Float']['input']>;
  species?: InputMaybe<EnumProcessorSettingsKillAndChillSettingsSpecies>;
};

export type UpdateOneProcessorSettingsPayload = {
  __typename?: 'UpdateOneProcessorSettingsPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<ProcessorSettings>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneProcessorSettingsValidationErrorsInput = {
  group?: InputMaybe<Scalars['String']['input']>;
  messages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  property?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateOneStateInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneStatePayload = {
  __typename?: 'UpdateOneStatePayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<State>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneTenantInput = {
  date_created?: InputMaybe<Scalars['Date']['input']>;
  domain?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  primary_color?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOneTenantPayload = {
  __typename?: 'UpdateOneTenantPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Tenant>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneUserInput = {
  access_token?: InputMaybe<Scalars['String']['input']>;
  active_vendor?: InputMaybe<Scalars['MongoID']['input']>;
  can_receive_sms?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  customer_id?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_login?: InputMaybe<Scalars['Float']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  picture_url?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnumUserRole>;
  settings?: InputMaybe<UpdateOneUserSettingsInput>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneUserPayload = {
  __typename?: 'UpdateOneUserPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<User>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneUserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOneUserSettingsInput = {
  calendar?: InputMaybe<UpdateOneUserSettingsCalendarInput>;
};

export type UpdateOneVendorInput = {
  address?: InputMaybe<UpdateOneAddressInput>;
  annualHangingWeightThroughput?: InputMaybe<Scalars['Float']['input']>;
  date_created?: InputMaybe<Scalars['Date']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  external_ids?: InputMaybe<Scalars['JSON']['input']>;
  free_shipping_amount?: InputMaybe<Scalars['Float']['input']>;
  pickup_days?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  prefers_dropoff?: InputMaybe<Scalars['Boolean']['input']>;
  shop_name?: InputMaybe<Scalars['String']['input']>;
  shop_slug?: InputMaybe<Scalars['String']['input']>;
  shop_url?: InputMaybe<Scalars['String']['input']>;
  stripe_config?: InputMaybe<Scalars['JSON']['input']>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<Scalars['MongoID']['input']>;
  zone?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOneVendorPayload = {
  __typename?: 'UpdateOneVendorPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Vendor>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateOneWaitlistInput = {
  animal?: InputMaybe<EnumWaitlistAnimal>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  unsubscribeToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Date']['input']>;
  vendor?: InputMaybe<Scalars['MongoID']['input']>;
};

export type UpdateOneWaitlistPayload = {
  __typename?: 'UpdateOneWaitlistPayload';
  /** Error that may occur during operation. If you request this field in GraphQL query, you will receive typed error in payload; otherwise error will be provided in root `errors` field of GraphQL response. */
  error?: Maybe<ErrorInterface>;
  /** Updated document */
  record?: Maybe<Waitlist>;
  /** Document ID */
  recordId?: Maybe<Scalars['MongoID']['output']>;
};

export type UpdateProcessorSettingsWithCustomCapacity = {
  __typename?: 'UpdateProcessorSettingsWithCustomCapacity';
  customCapacities?: Maybe<Array<Maybe<ProcessorSettingsCustomCapacity>>>;
  processorSettings?: Maybe<ProcessorSettings>;
};

export type UpdateProcessorSettingsWithCustomCapacityInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  animalSettings?: InputMaybe<Array<InputMaybe<UpsertProcessorSettingsAnimalSettings>>>;
  autoCarcassNumberSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoCarcassNumberSettingsInput>>>;
  autoSchedulingSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsAutoSchedulingInput>>>;
  capacityConfigurationType?: InputMaybe<ProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsInput>>>;
  customCapacities?: InputMaybe<Array<InputMaybe<UpsertProcessorSettingsCustomCapacityInput>>>;
  documentSettings?: InputMaybe<DocumentSettingsInput>;
  invoicing?: InputMaybe<CreateProcessorSettingsInvoicingInput>;
  isProcessorNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWaitlistFunctionalityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  killAndChillSettings?: InputMaybe<Array<InputMaybe<ProcessorSettingsKillAndChillInput>>>;
  processorNotificationEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  processorSettingsId: Scalars['MongoID']['input'];
  refundDeadlineDays: Scalars['Int']['input'];
  schedulingDeposit: Scalars['Float']['input'];
  vendor: Scalars['MongoID']['input'];
};

export type UpsertProcessorSettingsAnimalSettings = {
  butcherSlotPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsPricingInput>>>;
  customCutsheetPricing?: InputMaybe<Array<InputMaybe<ProcessorSettingsAnimalSettingsPricingInput>>>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumProcessorSettingsAnimalSettingsInspectionLevels>>>;
  isEnabled: Scalars['Boolean']['input'];
  species: EnumProcessorSettingsAnimalSettingsSpecies;
  splitTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  weightedAnimalUnit?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertProcessorSettingsCustomCapacityInput = {
  _id?: InputMaybe<Scalars['MongoID']['input']>;
  dailyCapacities?: InputMaybe<Array<InputMaybe<ProcessorSettingsCapacitySettingsDailyCapacityBlockInput>>>;
  date: Scalars['String']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type User = {
  __typename?: 'User';
  _id: Scalars['MongoID']['output'];
  access_token?: Maybe<Scalars['String']['output']>;
  active_vendor?: Maybe<Vendor>;
  can_receive_sms?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  first_name: Scalars['String']['output'];
  last_login?: Maybe<Scalars['Float']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  picture_url?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  role?: Maybe<EnumUserRole>;
  settings?: Maybe<UserSettings>;
  tenant?: Maybe<Tenant>;
};

/** List of items with pagination. */
export type UserPagination = {
  __typename?: 'UserPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<User>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  calendar?: Maybe<UserSettingsCalendar>;
};

export type UserSettingsByUserId = {
  __typename?: 'UserSettingsByUserId';
  settings?: Maybe<UserSettings>;
};

export type UserSettingsCalendar = {
  __typename?: 'UserSettingsCalendar';
  calendarView?: Maybe<Scalars['String']['output']>;
  dateConfiguration?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  showAllEvents?: Maybe<Scalars['Boolean']['output']>;
};

export type UserSettingsCalendarInput = {
  calendarView?: InputMaybe<Scalars['String']['input']>;
  dateConfiguration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllEvents?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSettingsInput = {
  calendar?: InputMaybe<UserSettingsCalendarInput>;
};

export type ValidationError = ErrorInterface & {
  __typename?: 'ValidationError';
  /** List of validator errors */
  errors?: Maybe<Array<ValidatorError>>;
  /** Combined error message from all validators */
  message?: Maybe<Scalars['String']['output']>;
};

export type ValidatorError = {
  __typename?: 'ValidatorError';
  /** Input record idx in array which occurs the validation error. This `idx` is useful for createMany operation. For singular operations it always be 0. For *Many operations `idx` represents record index in array received from user. */
  idx: Scalars['Int']['output'];
  /** Validation error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Source of the validation error from the model path */
  path?: Maybe<Scalars['String']['output']>;
  /** Field value which occurs the validation error */
  value?: Maybe<Scalars['JSON']['output']>;
};

export type Vendor = {
  __typename?: 'Vendor';
  _id: Scalars['MongoID']['output'];
  address: Address;
  annualHangingWeightThroughput?: Maybe<Scalars['Float']['output']>;
  date_created: Scalars['Date']['output'];
  enabled: Scalars['Boolean']['output'];
  external_id?: Maybe<Scalars['String']['output']>;
  external_ids?: Maybe<Scalars['JSON']['output']>;
  free_shipping_amount?: Maybe<Scalars['Float']['output']>;
  integrations: Array<Integration>;
  pickup_days?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  prefers_dropoff?: Maybe<Scalars['Boolean']['output']>;
  processorSettings?: Maybe<ProcessorSettings>;
  products: Array<Product>;
  shop_name: Scalars['String']['output'];
  shop_slug?: Maybe<Scalars['String']['output']>;
  shop_url?: Maybe<Scalars['String']['output']>;
  stripe_config?: Maybe<Scalars['JSON']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  tenant?: Maybe<Tenant>;
  zone?: Maybe<Scalars['Float']['output']>;
};


export type VendorIntegrationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyIntegrationInput>;
};


export type VendorProcessorSettingsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindOneProcessorSettingsInput>;
};


export type VendorProductsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SortFindManyProductInput>;
};

/** List of items with pagination. */
export type VendorPagination = {
  __typename?: 'VendorPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Vendor>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type VoidInvoiceInput = {
  id: Scalars['MongoID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Waitlist = {
  __typename?: 'Waitlist';
  _id: Scalars['MongoID']['output'];
  animal: EnumWaitlistAnimal;
  company?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  endDate?: Maybe<Scalars['Date']['output']>;
  firstName: Scalars['String']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  sendWaitlistEmail?: Maybe<Scalars['Boolean']['output']>;
  sendWaitlistSMS?: Maybe<Scalars['Boolean']['output']>;
  /** Special formatted date with no timezone should be in the format MM/DD/YYYY. */
  startDate?: Maybe<Scalars['Date']['output']>;
  unsubscribeToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  vendor: Scalars['MongoID']['output'];
};

/** List of items with pagination. */
export type WaitlistPagination = {
  __typename?: 'WaitlistPagination';
  /** Total object count. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of objects. */
  items?: Maybe<Array<Waitlist>>;
  /** Information to aid in pagination. */
  pageInfo: PaginationInfo;
};

export type WeightedAnimalComplexAnimalCapacitySchema = {
  __typename?: 'WeightedAnimalComplexAnimalCapacitySchema';
  species?: Maybe<EnumProcessorSettingsAnimalSettingsSpecies>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type ProcessingPartnersOne = {
  __typename?: 'processingPartnersOne';
  _id?: Maybe<Scalars['MongoID']['output']>;
  about?: Maybe<Scalars['String']['output']>;
  animalSettings?: Maybe<Array<Maybe<ProcessorSettingsAnimalSettings>>>;
  capacityConfigurationType?: Maybe<ProcessorSettingsCapacityConfigurationType>;
  capacitySettings?: Maybe<Array<Maybe<ProcessorSettingsCapacitySettings>>>;
  customCapacities?: Maybe<Array<Maybe<ProcessorSettingsCustomCapacity>>>;
  enabledAnimals?: Maybe<Array<Maybe<EnumProcessorSettingsAnimalSettingsSpecies>>>;
  faq?: Maybe<Scalars['String']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWaitlistFunctionalityDisabled?: Maybe<Scalars['Boolean']['output']>;
  killAndChillSettings?: Maybe<Array<Maybe<ProcessorSettingsKillAndChillSettings>>>;
  refundDeadlineDays: Scalars['Int']['output'];
  schedulingDeposit?: Maybe<Scalars['Float']['output']>;
  vendor?: Maybe<ProcessingPartnerVendor>;
};

export type AddressFragmentFragment = { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any };

export type CapabilitySpecificationFragment = { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null };

export type ChatMessageFragmentFragment = { __typename?: 'ChatMessage', _id: any, content: string, createdAt?: any | null, updatedAt?: any | null, chatRoom?: { __typename?: 'ChatRoom', _id: any, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null } | null, sender?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null } | null };

export type ChatRoomFragmentFragment = { __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name: string, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content: string, sender?: { __typename?: 'User', _id: any } | null } | null };

export type CutsheetFragmentFragment = { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null };

export type ExtrasFragmentFragment = { __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null };

export type InvoiceFragmentLineItemFragment = { __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number };

export type InvoiceFragmentFragment = { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null };

export type NoteFragmentFragment = { __typename?: 'Note', _id: any, note: string, type: EnumNoteType, attachmentUrl?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', first_name: string, last_name?: string | null } | null };

export type NotificationSettingFragmentFragment = { __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: EnumNotificationSettingTrigger, sendEmail?: boolean | null, sendSMS?: boolean | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation } | null> | null, emailMessage?: { __typename?: 'NotificationMessage', content: string, type: EnumNotificationMessageType } | null, smsMessage?: { __typename?: 'NotificationMessage', content: string, type: EnumNotificationMessageType } | null };

export type PrimalCutBlockerFragmentFragment = { __typename?: 'PrimalCutBlocker', _id: any, vendor: any, animalSpecies: string, inspectionLevel: string, name: string, primalCutId: any, type?: string | null, blockedBy?: Array<{ __typename?: 'PrimalCutBlockerBlockedBy', name: string, primalCutId: any, _id?: any | null } | null> | null };

export type PrimalCutFragmentFragment = { __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null };

export type ProcessorCapabilityFragmentFragment = { __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, cuts: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, order: number }> }> };

export type ContactUserFragment = { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null };

export type CutsheetInformationFragment = { __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null };

export type AnimalHeadFragment = { __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null };

export type ProcessorSchedulingFragmentFragment = { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any } | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null };

export type ProcessorSchedulingCalendarFragmentFragment = { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null } | null> | null };

export type ProcessorSchedulingSlimFragmentFragment = { __typename?: 'ProcessorScheduling', _id: any, dropoffDate?: any | null, status: EnumProcessorSchedulingStatus, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, blockIndex?: number | null, blockTitle?: string | null, vendor?: { __typename?: 'Vendor', _id: any } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null } | null> | null };

export type DailyCapacityFragmentFragment = { __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null };

export type DailyCapacityBlockFragmentFragment = { __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null };

export type ProcessorSettingsFragmentFragment = { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null }>, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }> } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null };

export type ProcessorSettingsCustomCapacityFragmentFragment = { __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null };

export type ParentProductFragment = { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null };

export type ProductFragmentFragment = { __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null };

export type TenantFragmentFragment = { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> };

export type TrimFragmentFragment = { __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection };

export type UserFragmentFragment = { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, picture_url?: string | null, role?: EnumUserRole | null, enabled: boolean, _id: any, active_vendor?: { __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, zone?: number | null, stripe_config?: any | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, isSyncing?: boolean | null, lastSynced?: any | null, _id: any }> } | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null };

export type VendorFragmentFragment = { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null }>, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }> };

export type WaitlistFragmentFragment = { __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null };

export type IntegrationCreateOneMutationVariables = Exact<{
  record: CreateOneIntegrationInput;
}>;


export type IntegrationCreateOneMutation = { __typename?: 'Mutation', integrationCreateOne?: { __typename?: 'CreateOneIntegrationPayload', recordId?: any | null, record?: { __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, endpoint?: string | null, key?: string | null, _id: any } | null, error?: { __typename?: 'MongoError', message?: string | null } | { __typename?: 'RuntimeError', message?: string | null } | { __typename?: 'ValidationError', message?: string | null } | null } | null };

export type IntegrationUpdateConfigMutationVariables = Exact<{
  integrationId: Scalars['MongoID']['input'];
  config: Scalars['JSON']['input'];
}>;


export type IntegrationUpdateConfigMutation = { __typename?: 'Mutation', integrationUpdateById?: { __typename?: 'UpdateByIdIntegrationPayload', recordId?: any | null } | null };

export type ProcessorSettingsUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSettingsInput;
}>;


export type ProcessorSettingsUpdateByIdMutation = { __typename?: 'Mutation', processorSettingsUpdateById?: { __typename?: 'UpdateByIdProcessorSettingsPayload', recordId?: any | null } | null };

export type TenantCreateMutationVariables = Exact<{
  newTenant: CreateOneTenantInput;
}>;


export type TenantCreateMutation = { __typename?: 'Mutation', tenantCreate?: { __typename?: 'Tenant', external_id?: string | null, name: string, date_created: any, domain?: string | null, enabled: boolean, _id: any } | null };

export type TenantModulesEditMutationVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
  moduleIds: Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>;
}>;


export type TenantModulesEditMutation = { __typename?: 'Mutation', tenantModulesEdit?: { __typename?: 'Tenant', external_id?: string | null, name: string, enabled: boolean, _id: any } | null };

export type TenantPictureUrlEditMutationVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
  picture_url?: InputMaybe<Scalars['String']['input']>;
}>;


export type TenantPictureUrlEditMutation = { __typename?: 'Mutation', tenantPictureUrlEdit?: { __typename?: 'Tenant', external_id?: string | null, name: string, enabled: boolean, _id: any, picture_url?: string | null } | null };

export type TenantSubscriptionEditMutationVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
  subscription: Scalars['String']['input'];
}>;


export type TenantSubscriptionEditMutation = { __typename?: 'Mutation', tenantSubscriptionEdit?: { __typename?: 'Tenant', external_id?: string | null, external_ids?: any | null, name: string, email: string, date_created: any, picture_url?: string | null, primary_color?: string | null, domain?: string | null, enabled: boolean, _id: any } | null };

export type UserActivateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type UserActivateMutation = { __typename?: 'Mutation', userActivate?: { __typename?: 'User', external_id?: string | null, enabled: boolean, first_name: string, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, last_login?: number | null, _id: any } | null };

export type UserCreateMutationVariables = Exact<{
  newUser: CreateOneUserInput;
}>;


export type UserCreateMutation = { __typename?: 'Mutation', userCreate?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, access_token?: string | null, refresh_token?: string | null, last_login?: number | null, _id: any } | null };

export type UserDeactivateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type UserDeactivateMutation = { __typename?: 'Mutation', userDeactivate?: { __typename?: 'User', external_id?: string | null, enabled: boolean, first_name: string, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, last_login?: number | null, _id: any } | null };

export type VendorCreateMutationVariables = Exact<{
  newVendor: CreateOneVendorInput;
}>;


export type VendorCreateMutation = { __typename?: 'Mutation', vendorCreate?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, tagline?: string | null, enabled: boolean, annualHangingWeightThroughput?: number | null, _id: any } | null };

export type VendorUpdateByIdMutationVariables = Exact<{
  record: UpdateByIdVendorInput;
  _id: Scalars['MongoID']['input'];
}>;


export type VendorUpdateByIdMutation = { __typename?: 'Mutation', vendorUpdateById?: { __typename?: 'UpdateByIdVendorPayload', record?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null }>, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }> } | null } | null };

export type ChatRoomCreateOneMutationVariables = Exact<{
  record: CreateOneChatRoomInput;
}>;


export type ChatRoomCreateOneMutation = { __typename?: 'Mutation', chatRoomCreateOne?: { __typename?: 'CreateOneChatRoomPayload', recordId?: any | null, record?: { __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name: string, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content: string, sender?: { __typename?: 'User', _id: any } | null } | null } | null } | null };

export type CreateProcessorSchedulingMutationVariables = Exact<{
  newSchedule: CreateProcessorSchedulingInput;
}>;


export type CreateProcessorSchedulingMutation = { __typename?: 'Mutation', processorSchedulingCreate?: { __typename?: 'CreateProcessorScheduleResponse', scheduling: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any } | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null }, checkoutSession?: { __typename?: 'CheckoutSessionResponse', clientSecret: string } | null } | null };

export type CutsheetCreateOneMutationVariables = Exact<{
  record: CreateOneCutsheetInput;
}>;


export type CutsheetCreateOneMutation = { __typename?: 'Mutation', cutsheetCreateOne?: { __typename?: 'CreateOneCutsheetPayload', recordId?: any | null, record?: { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null } | null };

export type CutsheetSoftDeleteMutationVariables = Exact<{
  cutsheetId: Scalars['MongoID']['input'];
}>;


export type CutsheetSoftDeleteMutation = { __typename?: 'Mutation', cutsheetSoftDelete?: { __typename?: 'Cutsheet', _id: any } | null };

export type CutsheetUpsertMutationVariables = Exact<{
  cutsheetId?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumCutsheetType>;
  animalSpecies?: InputMaybe<EnumCutsheetAnimalSpecies>;
  inspectionLevels?: InputMaybe<Array<InputMaybe<EnumCutsheetInspectionLevels>> | InputMaybe<EnumCutsheetInspectionLevels>>;
  primalCuts?: InputMaybe<Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input']>;
  splitTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  name: Scalars['String']['input'];
  pricePerPound?: InputMaybe<Scalars['Float']['input']>;
  activeSpecification?: InputMaybe<Scalars['MongoID']['input']>;
  selectedSpecifications?: InputMaybe<Scalars['JSON']['input']>;
  extras?: InputMaybe<Array<CutsheetExtrasTypeInput> | CutsheetExtrasTypeInput>;
  trim?: InputMaybe<Array<CutsheetTrimTypeInput> | CutsheetTrimTypeInput>;
}>;


export type CutsheetUpsertMutation = { __typename?: 'Mutation', cutsheetUpsert?: { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null };

export type IntegrationInitMutationVariables = Exact<{
  integrationName: EnumIntegrationName;
  shop?: InputMaybe<Scalars['String']['input']>;
}>;


export type IntegrationInitMutation = { __typename?: 'Mutation', integrationInit?: { __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, endpoint?: string | null, key?: string | null, _id: any } | null };

export type InvoiceFinalizeAndSendMutationVariables = Exact<{
  input?: InputMaybe<VoidInvoiceInput>;
}>;


export type InvoiceFinalizeAndSendMutation = { __typename?: 'Mutation', invoiceFinalizeAndSend?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type GenerateInvoicePdfMutationVariables = Exact<{
  invoiceId: Scalars['MongoID']['input'];
}>;


export type GenerateInvoicePdfMutation = { __typename?: 'Mutation', generateInvoicePdf?: { __typename?: 'GenerateInvoicePdfResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type InvoiceMarkAsPaidMutationVariables = Exact<{
  input?: InputMaybe<MarkAsPaidInput>;
}>;


export type InvoiceMarkAsPaidMutation = { __typename?: 'Mutation', invoiceMarkAsPaid?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type InvoiceRefundMutationVariables = Exact<{
  input?: InputMaybe<RefundInvoiceInput>;
}>;


export type InvoiceRefundMutation = { __typename?: 'Mutation', invoiceRefund?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type InvoiceUpdateMutationVariables = Exact<{
  input?: InputMaybe<UpdateInvoiceInput>;
}>;


export type InvoiceUpdateMutation = { __typename?: 'Mutation', invoiceUpdate?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type InvoiceVoidMutationVariables = Exact<{
  input?: InputMaybe<VoidInvoiceInput>;
}>;


export type InvoiceVoidMutation = { __typename?: 'Mutation', invoiceVoid?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type NoteUpsertMutationVariables = Exact<{
  noteId?: InputMaybe<Scalars['MongoID']['input']>;
  note: Scalars['String']['input'];
  processorScheduling?: InputMaybe<Scalars['MongoID']['input']>;
  type?: InputMaybe<EnumNoteType>;
  attachment?: InputMaybe<Scalars['Upload']['input']>;
}>;


export type NoteUpsertMutation = { __typename?: 'Mutation', noteUpsert?: { __typename?: 'Note', _id: any } | null };

export type NotificationSettingsUpdateMutationVariables = Exact<{
  notificationSettingId: Scalars['MongoID']['input'];
  settings: NotificationSettingsInput;
}>;


export type NotificationSettingsUpdateMutation = { __typename?: 'Mutation', notificationSettingsUpdate?: { __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: EnumNotificationSettingTrigger, sendEmail?: boolean | null, sendSMS?: boolean | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation } | null> | null, emailMessage?: { __typename?: 'NotificationMessage', content: string, type: EnumNotificationMessageType } | null, smsMessage?: { __typename?: 'NotificationMessage', content: string, type: EnumNotificationMessageType } | null } | null };

export type PrimalCreateOneMutationVariables = Exact<{
  record: CreateOnePrimalInput;
}>;


export type PrimalCreateOneMutation = { __typename?: 'Mutation', primalCreateOne?: { __typename?: 'CreateOnePrimalPayload', recordId?: any | null } | null };

export type PrimalCutBlockerUpsertMutationVariables = Exact<{
  animalSpecies: Scalars['String']['input'];
  inspectionLevel: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primalCutId: Scalars['MongoID']['input'];
  blockedBy: Array<BlockedByInput> | BlockedByInput;
}>;


export type PrimalCutBlockerUpsertMutation = { __typename?: 'Mutation', primalCutBlockerUpsert?: { __typename?: 'PrimalCutBlocker', _id: any, vendor: any, animalSpecies: string, inspectionLevel: string, name: string, primalCutId: any, type?: string | null, blockedBy?: Array<{ __typename?: 'PrimalCutBlockerBlockedBy', name: string, primalCutId: any, _id?: any | null } | null> | null } | null };

export type PrimalCutCreateOneMutationVariables = Exact<{
  record: CreateOnePrimalCutInput;
}>;


export type PrimalCutCreateOneMutation = { __typename?: 'Mutation', primalCutCreateOne?: { __typename?: 'CreateOnePrimalCutPayload', recordId?: any | null, record?: { __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null } | null };

export type PrimalCutSoftDeleteMutationVariables = Exact<{
  primalCutId: Scalars['MongoID']['input'];
}>;


export type PrimalCutSoftDeleteMutation = { __typename?: 'Mutation', primalCutSoftDelete?: { __typename?: 'PrimalCut', _id: any, primal?: { __typename?: 'Primal', _id: any, group?: { __typename?: 'PrimalGroup', _id: any } | null } | null } | null };

export type PrimalCutTypeCreateOneMutationVariables = Exact<{
  record: CreateOnePrimalCutTypeInput;
}>;


export type PrimalCutTypeCreateOneMutation = { __typename?: 'Mutation', primalCutTypeCreateOne?: { __typename?: 'CreateOnePrimalCutTypePayload', recordId?: any | null } | null };

export type PrimalCutUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalCutInput;
}>;


export type PrimalCutUpdateByIdMutation = { __typename?: 'Mutation', primalCutUpdateById?: { __typename?: 'UpdateByIdPrimalCutPayload', recordId?: any | null, record?: { __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null } | null } | null };

export type PrimalGroupSoftDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PrimalGroupSoftDeleteByIdMutation = { __typename?: 'Mutation', primalGroupUpdateById?: { __typename?: 'UpdateByIdPrimalGroupPayload', record?: { __typename?: 'PrimalGroup', _id: any, isDeleted?: boolean | null, deletedAt?: any | null } | null } | null };

export type PrimalSoftDeleteByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type PrimalSoftDeleteByIdMutation = { __typename?: 'Mutation', primalUpdateById?: { __typename?: 'UpdateByIdPrimalPayload', record?: { __typename?: 'Primal', _id: any, isDeleted?: boolean | null, deletedAt?: any | null } | null } | null };

export type PrimalUpdateByIdMutationVariables = Exact<{
  _id: Scalars['MongoID']['input'];
  record: UpdateByIdPrimalInput;
}>;


export type PrimalUpdateByIdMutation = { __typename?: 'Mutation', primalUpdateById?: { __typename?: 'UpdateByIdPrimalPayload', recordId?: any | null } | null };

export type ProcessorCapabilityUpsertMutationVariables = Exact<{
  animalSpecies: EnumProcessorCapabilityAnimalSpecies;
  inspectionLevel: EnumProcessorCapabilityInspectionLevel;
  primalCuts: Array<Scalars['MongoID']['input']> | Scalars['MongoID']['input'];
  canSelectMoreThanOneTrim: Scalars['Boolean']['input'];
  trimSelection: EnumProcessorCapabilityTrimSelection;
  extras?: InputMaybe<Array<ProcessorCapabilityExtrasModelInput> | ProcessorCapabilityExtrasModelInput>;
  trim?: InputMaybe<Array<ProcessorCapabilityTrimModelInput> | ProcessorCapabilityTrimModelInput>;
  specifications?: InputMaybe<Array<ProcessorCapabilitySpecificationSpecificationsInput> | ProcessorCapabilitySpecificationSpecificationsInput>;
  primalGroups?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>> | InputMaybe<Scalars['JSON']['input']>>;
  newCutBlockers?: InputMaybe<Scalars['JSON']['input']>;
  wizardWelcomeTitle?: InputMaybe<Scalars['String']['input']>;
  wizardWelcomeContent?: InputMaybe<Scalars['String']['input']>;
  extrasDescription?: InputMaybe<Scalars['String']['input']>;
  trimDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProcessorCapabilityUpsertMutation = { __typename?: 'Mutation', processorCapabilityUpsert?: { __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, cuts: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, order: number }> }> } | null };

export type ProcessorExportCsvMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  type: ProcessorExportTypeEnum;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorExportCsvMutation = { __typename?: 'Mutation', processorExportCsv?: { __typename?: 'ProcessorExportCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorExportCsvByVendorIdMutationVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorExportCsvByVendorIdMutation = { __typename?: 'Mutation', processorExportCsvByVendorId?: { __typename?: 'ProcessorExportCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  updatedAnimalHeads?: InputMaybe<Array<InputMaybe<AnimalHeadUpdatesInput>> | InputMaybe<AnimalHeadUpdatesInput>>;
}>;


export type ProcessorSchedulingAnimalHeadBulkUpdateMutation = { __typename?: 'Mutation', processorSchedulingAnimalHeadBulkUpdate?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null, warnings?: Array<{ __typename?: 'ProcessorSchedulingPartialUpdateWarning', message?: string | null } | null> | null } | null };

export type ProcessorSchedulingAnimalHeadDeleteMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  animalHeadId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingAnimalHeadDeleteMutation = { __typename?: 'Mutation', processorSchedulingAnimalHeadDelete?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  animalHeadId: Scalars['MongoID']['input'];
  record: ProcessorSchedulingPartialUpdateAnimalHeadInput;
}>;


export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingAnimalHeadPartialUpdateById?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null, warnings?: Array<{ __typename?: 'ProcessorSchedulingPartialUpdateWarning', message?: string | null } | null> | null } | null };

export type ProcessorSchedulingCutsheetReminderMutationVariables = Exact<{
  schedulingId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingCutsheetReminderMutation = { __typename?: 'Mutation', processorSchedulingCutsheetReminder?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any } | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null } | null };

export type ProcessorSchedulingDragAndDropUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  eventType: Scalars['String']['input'];
  eventDate: Scalars['String']['input'];
}>;


export type ProcessorSchedulingDragAndDropUpdateMutation = { __typename?: 'Mutation', processorSchedulingDragAndDropUpdate?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingGenerateBillingStatementMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingGenerateBillingStatementMutation = { __typename?: 'Mutation', processorSchedulingGenerateBillingStatement?: { __typename?: 'GenerateBillingStatementResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateCarcassTagsMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  animalHeadIds?: InputMaybe<Array<InputMaybe<Scalars['MongoID']['input']>> | InputMaybe<Scalars['MongoID']['input']>>;
}>;


export type ProcessorSchedulingGenerateCarcassTagsMutation = { __typename?: 'Mutation', processorSchedulingGenerateCarcassTags?: { __typename?: 'GenerateCarcassTagsResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateCsvByVendorIdMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorSchedulingGenerateCsvByVendorIdMutation = { __typename?: 'Mutation', processorSchedulingGenerateCsvByVendorId?: { __typename?: 'GenerateCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorSchedulingGenerateCutsheetRequestMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  cutsheetRequestId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingGenerateCutsheetRequestMutation = { __typename?: 'Mutation', processorSchedulingGenerateCutsheetRequest?: { __typename?: 'GenerateCutsheetResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingGenerateHangingWeightCsvMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type ProcessorSchedulingGenerateHangingWeightCsvMutation = { __typename?: 'Mutation', processorSchedulingGenerateHangingWeightCsv?: { __typename?: 'GenerateHangingWeightCsvResponse', file: string, filename: string, errors: Array<string | null> } | null };

export type ProcessorSchedulingGenerateKillSheetMutationVariables = Exact<{
  date: Scalars['Date']['input'];
  vendorId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingGenerateKillSheetMutation = { __typename?: 'Mutation', processorSchedulingGenerateKillSheet?: { __typename?: 'GenerateKillSheetResponse', file?: string | null, filename?: string | null, errors?: Array<string | null> | null, fileUrl?: string | null } | null };

export type ProcessorSchedulingNotificationSendMutationVariables = Exact<{
  type?: InputMaybe<Scalars['NotificationTypeInput']['input']>;
  notificationRequest?: InputMaybe<NotificationRequestInput>;
}>;


export type ProcessorSchedulingNotificationSendMutation = { __typename?: 'Mutation', processorSchedulingNotificationSend?: { __typename?: 'ProcessorScheduling', _id: any } | null };

export type ProcessorSchedulingPartialUpdateByIdMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: ProcessorSchedulingPartialUpdateInput;
}>;


export type ProcessorSchedulingPartialUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingPartialUpdateById?: { __typename?: 'ProcessorSchedulingPartialUpdateResponse', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null, warnings?: Array<{ __typename?: 'ProcessorSchedulingPartialUpdateWarning', message?: string | null } | null> | null } | null };

export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: Array<InputMaybe<CutsheetPartialUpdateInput>> | InputMaybe<CutsheetPartialUpdateInput>;
}>;


export type ProcessorSchedulingCutsheetInformationPartialUpdateMutation = { __typename?: 'Mutation', processorSchedulingUpdateCutsheets?: { __typename?: 'UpdateByIdProcessorSchedulingPayload', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', _id: any } | null } | null };

export type ProcessorSchedulingSplitTypeUpdateByIdMutationVariables = Exact<{
  processorSchedulingId: Scalars['MongoID']['input'];
  record: ProcessorSchedulingSplitTypeUpdateInput;
}>;


export type ProcessorSchedulingSplitTypeUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingSplitTypeUpdateById?: { __typename?: 'ProcessorSchedulingSplitTypeUpdateResponse', recordId?: any | null } | null };

export type ProcessorSchedulingUpdateByIdMutationVariables = Exact<{
  id: Scalars['MongoID']['input'];
  record: UpdateByIdProcessorSchedulingInput;
}>;


export type ProcessorSchedulingUpdateByIdMutation = { __typename?: 'Mutation', processorSchedulingUpdate?: { __typename?: 'UpdateByIdProcessorSchedulingPayload', recordId?: any | null, record?: { __typename?: 'ProcessorScheduling', status: EnumProcessorSchedulingStatus } | null } | null };

export type ProcessorSettingsCreateMutationVariables = Exact<{
  newProcessorSettings: CreateProcessorSettingsWithCustomCapacityInput;
}>;


export type ProcessorSettingsCreateMutation = { __typename?: 'Mutation', processorSettingsCreate?: { __typename?: 'CreateProcessorSettingsWithCustomCapacity', processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null }>, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }> } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null } | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type ProcessorSettingsUpdateMutationVariables = Exact<{
  updateProcessorSettings: UpdateProcessorSettingsWithCustomCapacityInput;
}>;


export type ProcessorSettingsUpdateMutation = { __typename?: 'Mutation', processorSettingsUpdate?: { __typename?: 'UpdateProcessorSettingsWithCustomCapacity', processorSettings?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null }>, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }> } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null } | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null } | null };

export type SendMessageMutationVariables = Exact<{
  chatRoomId: Scalars['MongoID']['input'];
  message: Scalars['String']['input'];
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type SendMessageMutation = { __typename?: 'Mutation', sendMessage?: { __typename?: 'ChatMessage', _id: any, content: string, createdAt?: any | null, updatedAt?: any | null, chatRoom?: { __typename?: 'ChatRoom', _id: any, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null } | null, sender?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null } | null } | null };

export type StripeAccountCreateMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type StripeAccountCreateMutation = { __typename?: 'Mutation', stripeAccountCreate?: { __typename?: 'Vendor', _id: any, stripe_config?: any | null } | null };

export type StripeSessionCreateMutationVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type StripeSessionCreateMutation = { __typename?: 'Mutation', stripeSessionCreate?: { __typename?: 'Vendor', _id: any, stripe_config?: any | null } | null };

export type UserSettingsUpdateMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  settings: UserSettingsInput;
}>;


export type UserSettingsUpdateMutation = { __typename?: 'Mutation', userSettingsUpdate?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, picture_url?: string | null, role?: EnumUserRole | null, enabled: boolean, _id: any, active_vendor?: { __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, zone?: number | null, stripe_config?: any | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, isSyncing?: boolean | null, lastSynced?: any | null, _id: any }> } | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null } | null };

export type UserUpdateActiveVendorMutationVariables = Exact<{
  userId: Scalars['MongoID']['input'];
  active_vendor: Scalars['MongoID']['input'];
}>;


export type UserUpdateActiveVendorMutation = { __typename?: 'Mutation', userUpdateById?: { __typename?: 'UpdateByIdUserPayload', recordId?: any | null } | null };

export type WaitlistAddMutationVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  sendWaitlistEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendWaitlistSMS?: InputMaybe<Scalars['Boolean']['input']>;
  animal: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type WaitlistAddMutation = { __typename?: 'Mutation', waitlistAdd?: { __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null } | null };

export type WaitlistDeleteMutationVariables = Exact<{
  customerId: Scalars['MongoID']['input'];
}>;


export type WaitlistDeleteMutation = { __typename?: 'Mutation', waitlistDelete?: { __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null } | null };

export type WaitlistUnsubscribeMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type WaitlistUnsubscribeMutation = { __typename?: 'Mutation', waitlistUnsubscribe?: { __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null } | null };

export type ViewProcessingPartnerQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewProcessingPartnerQuery = { __typename?: 'Query', processingPartnersOne?: { __typename?: 'processingPartnersOne', _id?: any | null, about?: string | null, isEnabled?: boolean | null, enabledAnimals?: Array<EnumProcessorSettingsAnimalSettingsSpecies | null> | null, capacityConfigurationType?: ProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays: number, isWaitlistFunctionalityDisabled?: boolean | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, price: number } | null> | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, price: number } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, vendor?: { __typename?: 'ProcessingPartnerVendor', _id?: any | null, shop_name?: string | null, address?: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null, _id?: any | null } | null } | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null } | null };

export type ViewProcessorAdminQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneProcessorSettingsInput>;
}>;


export type ViewProcessorAdminQuery = { __typename?: 'Query', processorSettingsOne?: { __typename?: 'ProcessorSettings', _id: any, capacityConfigurationType?: EnumProcessorSettingsCapacityConfigurationType | null, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, about?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, isProcessorNotificationsEnabled?: boolean | null, processorNotificationEmailAddresses?: Array<string | null> | null, animals?: Array<EnumProcessorSettingsAnimals | null> | null, customCapacities: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dateStr?: string | null, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null }>, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', _id?: any | null, isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', price: number, inspectionLevel?: string | null } | null> | null } | null> | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, carcassSettings?: Array<{ __typename?: 'ProcessorSettingsCarcassSettings', species: string, inspectionLevel: string, year: number, currentNumber: number, lastTakenNumber: number } | null> | null, vendor?: { __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, pickup_days?: Array<number | null> | null, enabled: boolean, free_shipping_amount?: number | null, prefers_dropoff?: boolean | null, tagline?: string | null, _id: any, zone?: number | null, stripe_config?: any | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, products: Array<{ __typename?: 'Product', external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, enabled: boolean, description?: string | null, short_description?: string | null, stock_status?: EnumProductStock_Status | null, stock_quantity?: number | null, _id: any, integration?: { __typename?: 'Integration', name: EnumIntegrationName } | null, parent?: { __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null, children?: Array<{ __typename?: 'ParentProduct', _id: any, vendor: any, external_id?: number | null, slug?: string | null, name?: string | null, permalink?: string | null, price?: number | null, weight?: number | null, description?: string | null, short_description?: string | null, stock_status?: EnumParentProductStock_Status | null, stock_quantity?: number | null } | null> | null }>, integrations: Array<{ __typename?: 'Integration', _id: any, name: EnumIntegrationName, type: EnumIntegrationType }> } | null, validationErrors?: Array<{ __typename?: 'ProcessorSettingsValidationErrors', type: string, value?: any | null, property?: string | null, messages?: Array<string | null> | null, group?: string | null } | null> | null, autoSchedulingSettings?: Array<{ __typename?: 'ProcessorSettingsAutoSchedulingSettings', species: EnumProcessorSettingsAutoSchedulingSettingsSpecies, isEnabled: boolean, cutDateDays: number, harvestDateDays: number } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null, invoicing?: { __typename?: 'ProcessorSettingsInvoicing', trackYields?: boolean | null, showYieldOnInvoice?: boolean | null, defaultSplitRule?: EnumProcessorSettingsInvoicingDefaultSplitRule | null } | null, documentSettings?: { __typename?: 'ProcessorSettingsDocumentSettings', cutsheet?: { __typename?: 'ProcessorSettingsDocumentSettingsCutsheet', format: EnumProcessorSettingsDocumentSettingsCutsheetFormat } | null, carcassTag?: { __typename?: 'ProcessorSettingsDocumentSettingsCarcassTag', title?: EnumProcessorSettingsDocumentSettingsCarcassTagTitle | null } | null } | null } | null, processorCapabilityMany: Array<{ __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, cuts: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, order: number }> }> }> };

export type ViewSchedulingCreateQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['MongoID']['input']>;
  vendorId: Scalars['MongoID']['input'];
  animalSpeciesCutsheet: EnumCutsheetAnimalSpecies;
  animalSpeciesProcessorCapability: EnumProcessorCapabilityAnimalSpecies;
  statuses?: InputMaybe<Array<EnumProcessorSchedulingStatus> | EnumProcessorSchedulingStatus>;
}>;


export type ViewSchedulingCreateQuery = { __typename?: 'Query', cutsheetMany: Array<{ __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }>, processorCapabilityOne?: { __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, cuts: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, order: number }> }> } | null, processingPartnersOne?: { __typename?: 'processingPartnersOne', _id?: any | null, capacityConfigurationType?: ProcessorSettingsCapacityConfigurationType | null, schedulingDeposit?: number | null, refundDeadlineDays: number, faq?: string | null, isWaitlistFunctionalityDisabled?: boolean | null, vendor?: { __typename?: 'ProcessingPartnerVendor', shop_name?: string | null, _id?: any | null, address?: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null, _id?: any | null } | null } | null, capacitySettings?: Array<{ __typename?: 'ProcessorSettingsCapacitySettings', isEnabled: boolean, dayOfWeek: string, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, customCapacities?: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', _id: any, isDeleted: boolean, date: any, dailyCapacities?: Array<{ __typename?: 'DailyCapacity', title?: string | null, capacitiesByType?: Array<{ __typename?: 'DailyCapacityCapacitiesByType', type: EnumDailyCapacityCapacitiesByTypeType, capacities?: Array<{ __typename?: 'SpeciesComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, value?: number | null } | { __typename?: 'SpeciesInspectionComplexAnimalCapacitySchema', species?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel: EnumSpeciesInspectionComplexAnimalCapacitySchemaInspectionLevel, value?: number | null } | { __typename?: 'WeightedAnimalComplexAnimalCapacitySchema', value?: number | null } | null> | null } | null> | null } | null> | null } | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', isEnabled: boolean, species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null, weightedAnimalUnit?: number | null, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, price: number } | null> | null } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null } | null, processorSchedulingMany: Array<{ __typename?: 'ProcessorScheduling', _id: any, dropoffDate?: any | null, status: EnumProcessorSchedulingStatus, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, blockIndex?: number | null, blockTitle?: string | null, vendor?: { __typename?: 'Vendor', _id: any } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null } | null> | null }> };

export type ViewSchedulingEditQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  userId: Scalars['MongoID']['input'];
  isDeleted: Scalars['Boolean']['input'];
}>;


export type ViewSchedulingEditQuery = { __typename?: 'Query', findProcessorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, isDeleted?: boolean | null, status: EnumProcessorSchedulingStatus, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, isKillAndChill?: boolean | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null, enabled: boolean } | null } | null> | null } | null> | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, email?: string | null, phone?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendorCutsheets: Array<{ __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }>, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, schedulingDeposit: number, refundDeadlineDays?: number | null, faq?: string | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', isEnabled: boolean, pricePerHead: number, species: EnumProcessorSettingsKillAndChillSettingsSpecies } | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', isEnabled: boolean, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, species: EnumProcessorSettingsAnimalSettingsSpecies, butcherSlotPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, species?: EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies | null, price: number } | null> | null, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', inspectionLevel?: string | null, species?: EnumProcessorSettingsAnimalSettingsButcherSlotPricingSpecies | null, price: number } | null> | null } | null> | null, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null, _id: any } | null } | null, customCapacities: Array<{ __typename?: 'ProcessorSettingsCustomCapacity', date: any, capacity?: any | null, isDeleted: boolean, _id: any }>, customCutsheetPricing?: Array<{ __typename?: 'ProcessorSettingsAnimalSettingsButcherSlotPricing', animal?: string | null, price: number } | null> | null } | null, processorCapabilities: Array<{ __typename?: 'ProcessorCapability', _id: any, vendor: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, canSelectMoreThanOneTrim?: boolean | null, trimSelection: EnumProcessorCapabilityTrimSelection, primalCuts?: Array<any | null> | null, wizardWelcomeTitle?: string | null, wizardWelcomeContent?: string | null, extrasDescription?: string | null, trimDescription?: string | null, cuts: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, description?: string | null, order: number, _id: any, group?: { __typename?: 'PrimalGroup', animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDefault?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, extras?: Array<{ __typename?: 'ProcessorCapabilityExtras', name: string, pricePerPound?: number | null, minLbs?: number | null, isActive: boolean, _id?: any | null, type: EnumProcessorCapabilityExtrasType, fee?: number | null, description?: string | null } | null> | null, trim?: Array<{ __typename?: 'ProcessorCapabilityTrim', name: string, pricePerPound: number, minLbs?: number | null, isActive: boolean, _id?: any | null, description?: string | null } | null> | null, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, primalGroups: Array<{ __typename?: 'PrimalGroup', _id: any, name: string, order: number, primals: Array<{ __typename?: 'Primal', _id: any, name: string, description?: string | null, order: number }> }> }> } | null, cutsheetMany: Array<{ __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }> };

export type ActiveVendorListQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveVendorListQuery = { __typename?: 'Query', activeVendorList?: Array<{ __typename?: 'Vendor', _id: any, shop_name: string, enabled: boolean } | null> | null };

export type ModuleManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyModuleInput>;
}>;


export type ModuleManyQuery = { __typename?: 'Query', moduleMany: Array<{ __typename?: 'Module', name: string, label: string, order: number, _id: any }> };

export type TenantByIdQueryVariables = Exact<{
  tenantId: Scalars['MongoID']['input'];
}>;


export type TenantByIdQuery = { __typename?: 'Query', tenantById?: { __typename?: 'Tenant', _id: any, date_created: any, domain?: string | null, email: string, enabled: boolean, external_id?: string | null, external_ids?: any | null, name: string, picture_url?: string | null, primary_color?: string | null, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, users: Array<{ __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, picture_url?: string | null, role?: EnumUserRole | null, last_login?: number | null, enabled: boolean, _id: any }>, vendors: Array<{ __typename?: 'Vendor', external_id?: string | null, date_created: any, shop_name: string, shop_slug?: string | null, shop_url?: string | null, tagline?: string | null, prefers_dropoff?: boolean | null, pickup_days?: Array<number | null> | null, free_shipping_amount?: number | null, enabled: boolean, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', config?: any | null, name: EnumIntegrationName, type: EnumIntegrationType, endpoint?: string | null, key?: string | null, _id: any }>, processorSettings?: { __typename?: 'ProcessorSettings', isEnabled?: boolean | null, commercialStartDate?: any | null, _id: any } | null }> } | null };

export type TenantPaginationQueryVariables = Exact<{
  sort: SortFindManyTenantInput;
  filter: FilterFindManyTenantInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type TenantPaginationQuery = { __typename?: 'Query', tenantPagination?: { __typename?: 'TenantPagination', count?: number | null, items?: Array<{ __typename?: 'Tenant', external_id?: string | null, name: string, date_created: any, domain?: string | null, enabled: boolean, _id: any, users: Array<{ __typename?: 'User', first_name: string, last_name?: string | null, role?: EnumUserRole | null, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, shop_name: string, shop_slug?: string | null, enabled: boolean, _id: any }>, modules: Array<{ __typename?: 'Module', name: string, label: string, order: number, _id: any }> }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type CancellationReasonManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyCancellationReasonInput>;
  sort?: InputMaybe<SortFindManyCancellationReasonInput>;
}>;


export type CancellationReasonManyQuery = { __typename?: 'Query', cancellationReasonMany: Array<{ __typename?: 'CancellationReason', reason: string, index?: number | null, isEnabled: boolean, _id: any }> };

export type CutsheetPaginationQueryVariables = Exact<{
  sort: SortFindManyCutsheetInput;
  filter: FilterFindManyCutsheetInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type CutsheetPaginationQuery = { __typename?: 'Query', cutsheetPagination?: { __typename?: 'CutsheetPagination', count?: number | null, items?: Array<{ __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type IntegrationOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneIntegrationInput>;
}>;


export type IntegrationOneQuery = { __typename?: 'Query', integrationOne?: { __typename?: 'Integration', _id: any, name: EnumIntegrationName, config?: any | null } | null };

export type InvoiceByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type InvoiceByIdQuery = { __typename?: 'Query', invoiceById?: { __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null };

export type SearchInvoicesQueryVariables = Exact<{
  type: Scalars['String']['input'];
  sort: SortFindManyInvoiceInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SearchInvoicesQuery = { __typename?: 'Query', searchInvoices?: { __typename?: 'InvoicePagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null }> | null } | null };

export type MessagesByChatRoomQueryVariables = Exact<{
  chatRoomId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type MessagesByChatRoomQuery = { __typename?: 'Query', messagesByChatRoom?: { __typename?: 'ChatMessagePagination', count?: number | null, items?: Array<{ __typename?: 'ChatMessage', _id: any, content: string, createdAt?: any | null, updatedAt?: any | null, chatRoom?: { __typename?: 'ChatRoom', _id: any, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null } | null, sender?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type MyChatRoomsQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type MyChatRoomsQuery = { __typename?: 'Query', myChatRooms?: { __typename?: 'ChatRoomPagination', count?: number | null, items?: Array<{ __typename?: 'ChatRoom', _id: any, createdAt?: any | null, updatedAt?: any | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string, picture_url?: string | null } | null } | null, participants: Array<{ __typename?: 'User', _id: any, first_name: string, last_name?: string | null, company?: string | null, role?: EnumUserRole | null, picture_url?: string | null }>, createdBy?: { __typename?: 'User', _id: any } | null, lastMessage?: { __typename?: 'ChatMessage', content: string, sender?: { __typename?: 'User', _id: any } | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type NotePaginationQueryVariables = Exact<{
  sort: SortFindManyNoteInput;
  filter: FilterFindManyNoteInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotePaginationQuery = { __typename?: 'Query', notePagination?: { __typename?: 'NotePagination', count?: number | null, items?: Array<{ __typename?: 'Note', _id: any, note: string, type: EnumNoteType, attachmentUrl?: string | null, createdAt?: any | null, updatedAt?: any | null, createdBy?: { __typename?: 'User', first_name: string, last_name?: string | null } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type NotificationSettingsByVendorIdQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type NotificationSettingsByVendorIdQuery = { __typename?: 'Query', findNotificationSettingsByVendorId?: { __typename?: 'NotificationSettingPagination', count?: number | null, items?: Array<{ __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: EnumNotificationSettingTrigger, sendEmail?: boolean | null, sendSMS?: boolean | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation } | null> | null, emailMessage?: { __typename?: 'NotificationMessage', content: string, type: EnumNotificationMessageType } | null, smsMessage?: { __typename?: 'NotificationMessage', content: string, type: EnumNotificationMessageType } | null }> | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null } } | null };

export type NotificationSettingsOneQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindOneNotificationSettingInput>;
}>;


export type NotificationSettingsOneQuery = { __typename?: 'Query', notificationSettingsOne?: { __typename?: 'NotificationSetting', _id: any, name: string, enabled?: boolean | null, trigger: EnumNotificationSettingTrigger, sendEmail?: boolean | null, sendSMS?: boolean | null, timings?: Array<{ __typename?: 'NotificationSettingTimings', days: number, relation: EnumNotificationSettingTimingsRelation } | null> | null, emailMessage?: { __typename?: 'NotificationMessage', content: string, type: EnumNotificationMessageType } | null, smsMessage?: { __typename?: 'NotificationMessage', content: string, type: EnumNotificationMessageType } | null } | null };

export type PrimalCutBlockerManyQueryVariables = Exact<{
  filter: FilterFindManyPrimalCutBlockerInput;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PrimalCutBlockerManyQuery = { __typename?: 'Query', primalCutBlockerMany: Array<{ __typename?: 'PrimalCutBlocker', _id: any, vendor: any, animalSpecies: string, inspectionLevel: string, name: string, primalCutId: any, type?: string | null, blockedBy?: Array<{ __typename?: 'PrimalCutBlockerBlockedBy', name: string, primalCutId: any, _id?: any | null } | null> | null }> };

export type PrimalCutManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPrimalCutInput>;
}>;


export type PrimalCutManyQuery = { __typename?: 'Query', primalCutMany: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, isDeleted?: boolean | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null, primal?: { __typename?: 'Primal', name: string, order: number, _id: any, group?: { __typename?: 'PrimalGroup', processorSettings?: any | null, isDefault?: boolean | null, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, _id: any } | null } | null }> };

export type PrimalCutTypeManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPrimalCutTypeInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PrimalCutTypeManyQuery = { __typename?: 'Query', primalCutTypeMany: Array<{ __typename?: 'PrimalCutType', _id: any, name: string, isDeleted?: boolean | null, animalSpecies?: EnumPrimalCutTypeAnimalSpecies | null, processorSettings?: any | null }> };

export type PrimalGroupManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyPrimalGroupInput>;
  sort?: InputMaybe<SortFindManyPrimalGroupInput>;
}>;


export type PrimalGroupManyQuery = { __typename?: 'Query', primalGroupMany: Array<{ __typename?: 'PrimalGroup', processorSettings?: any | null, isDefault?: boolean | null, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null, name: string, order: number, isDeleted?: boolean | null, _id: any, primals: Array<{ __typename?: 'Primal', isDeleted?: boolean | null, order: number, name: string, description?: string | null, _id: any, cuts: Array<{ __typename?: 'PrimalCut', isDeleted?: boolean | null, name: string, description?: string | null, order: number, _id: any, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }> }> }> };

export type ProcessingPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type ProcessingPartnersQuery = { __typename?: 'Query', processingPartners?: Array<{ __typename?: 'ProcessingPartners', _id?: any | null, isEnabled?: boolean | null, enabledAnimals?: Array<EnumProcessorSettingsAnimalSettingsSpecies | null> | null, slug?: string | null, vendor?: { __typename?: 'ProcessingPartnerVendor', _id?: any | null, shop_name?: string | null, address?: { __typename?: 'Address', city: string, state: string } | null, tenant?: { __typename?: 'ProcessingPartnerTenant', name?: string | null, picture_url?: string | null } | null } | null } | null> | null };

export type ProcessorCustomerByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
}>;


export type ProcessorCustomerByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, enabled: boolean, company?: string | null, _id: any } | null };

export type ProcessorCustomersPaginationQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyUserInput;
  vendorId: Scalars['MongoID']['input'];
}>;


export type ProcessorCustomersPaginationQuery = { __typename?: 'Query', getProcessorCustomers?: { __typename?: 'UserPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, company?: string | null, _id: any }> | null } | null };

export type ProcessorNotificationPaginationQueryVariables = Exact<{
  sort: SortFindManyProcessorNotificationInput;
  filter: FilterFindManyProcessorNotificationInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type ProcessorNotificationPaginationQuery = { __typename?: 'Query', processorNotificationPagination?: { __typename?: 'ProcessorNotificationPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorNotification', _id: any, vendor: any, notificationType: string, type: EnumProcessorNotificationType, sentTo: string, sentOn: any, errorMessage?: any | null }> | null } | null };

export type ProcessorSchedulingByIdQueryVariables = Exact<{
  id: Scalars['MongoID']['input'];
  includeCutsheetInformation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProcessorSchedulingByIdQuery = { __typename?: 'Query', processorSchedulingById?: { __typename?: 'ProcessorScheduling', dropoffDate?: any | null, dropoffDateStr?: string | null, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, _id: any, vendor?: { __typename?: 'Vendor', shop_name: string, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, city: string, state: string, email?: string | null, phone?: string | null, _id: any } } | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, splitType?: string | null, producerIdentifier?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, tracking?: string | null, publicId: string, isKillAndChill?: boolean | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, _id?: any | null, cutsheet?: { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null, company?: string | null } | null } | null> | null } | null> | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null } | null };

export type ProcessorSchedulingCalendarQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
}>;


export type ProcessorSchedulingCalendarQuery = { __typename?: 'Query', getProcessorSchedulingCalendar?: Array<{ __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null } | null> | null } | null> | null };

export type ProcessorSchedulingFilteredQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  searchByContact?: InputMaybe<Scalars['String']['input']>;
  sort: SortFindManyProcessorSchedulingInput;
  statusFilter?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  vendorId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingFilteredQuery = { __typename?: 'Query', getFilteredProcessorScheduling?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, firstKillDate?: any | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingManyQueryVariables = Exact<{
  filter?: InputMaybe<FilterFindManyProcessorSchedulingInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProcessorSchedulingManyQuery = { __typename?: 'Query', processorSchedulingMany: Array<{ __typename?: 'ProcessorScheduling', dropoffDate?: any | null, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, _id: any, blockIndex?: number | null, blockTitle?: string | null, vendor?: { __typename?: 'Vendor', _id: any } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, cutsheet?: { __typename?: 'Cutsheet', _id: any } | null } | null> | null } | null> | null }> };

export type ProcessorSchedulingPaginationQueryVariables = Exact<{
  sort: SortFindManyProcessorSchedulingInput;
  filter: FilterFindManyProcessorSchedulingInput;
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
}>;


export type ProcessorSchedulingPaginationQuery = { __typename?: 'Query', processorSchedulingPagination?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, vendor?: { __typename?: 'Vendor', shop_name: string } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, isKillAndChill?: boolean | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingWithMissingCutsheetsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId?: InputMaybe<Scalars['MongoID']['input']>;
  customerId?: InputMaybe<Scalars['MongoID']['input']>;
}>;


export type ProcessorSchedulingWithMissingCutsheetsQuery = { __typename?: 'Query', findProcessorSchedulingsWithMissingCutsheets?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, firstKillDate?: any | null, vendor?: { __typename?: 'Vendor', shop_name: string } | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type ProcessorSchedulingWithMissingHangingWeightsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  perPage: Scalars['Int']['input'];
  sort: SortFindManyProcessorSchedulingInput;
  vendorId: Scalars['MongoID']['input'];
}>;


export type ProcessorSchedulingWithMissingHangingWeightsQuery = { __typename?: 'Query', findProcessorSchedulingsWithMissingHangingWeights?: { __typename?: 'ProcessorSchedulingPagination', count?: number | null, pageInfo: { __typename?: 'PaginationInfo', currentPage: number, perPage: number, pageCount?: number | null, itemCount?: number | null, hasNextPage?: boolean | null, hasPreviousPage?: boolean | null }, items?: Array<{ __typename?: 'ProcessorScheduling', _id: any, animalSpecies: EnumProcessorSchedulingAnimalSpecies, dropoffDate?: any | null, headCount: number, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, firstKillDate?: any | null, vendor?: { __typename?: 'Vendor', shop_name: string } | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, company?: string | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, splitType?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, hangingWeight?: number | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, butcherSlotPrice?: number | null, tracking?: string | null, killDate?: any | null, liveWeight?: number | null, sex?: string | null, cutDate?: any | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', _id: any, name: string, type: EnumCutsheetType, pricePerPound?: number | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null } | null } | null> | null } | null> | null }> | null } | null };

export type StateManyQueryVariables = Exact<{ [key: string]: never; }>;


export type StateManyQuery = { __typename?: 'Query', stateMany: Array<{ __typename?: 'State', name: string, code: string, _id: any }> };

export type UserSettingsByUserIdQueryVariables = Exact<{
  userId: Scalars['MongoID']['input'];
}>;


export type UserSettingsByUserIdQuery = { __typename?: 'Query', userSettingsByUserId?: { __typename?: 'UserSettingsByUserId', settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null } | null };

export type UserTenantVendorQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTenantVendorQuery = { __typename?: 'Query', userTenantVendor?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, picture_url?: string | null, role?: EnumUserRole | null, enabled: boolean, _id: any, active_vendor?: { __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, zone?: number | null, stripe_config?: any | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any }, integrations: Array<{ __typename?: 'Integration', name: EnumIntegrationName, type: EnumIntegrationType, isSyncing?: boolean | null, lastSynced?: any | null, _id: any }> } | null, tenant?: { __typename?: 'Tenant', name: string, date_created: any, enabled: boolean, domain?: string | null, _id: any, modules: Array<{ __typename?: 'Module', name: string, label: string, href: string, order: number, _id: any }>, vendors: Array<{ __typename?: 'Vendor', date_created: any, external_id?: string | null, prefers_dropoff?: boolean | null, shop_name: string, shop_slug?: string | null, tagline?: string | null, _id: any, address: { __typename?: 'Address', first_name?: string | null, last_name?: string | null, company?: string | null, address_1: string, address_2?: string | null, city: string, state: string, postcode: string, country: string, email?: string | null, phone?: string | null, type: EnumAddressType, _id: any } }> } | null, settings?: { __typename?: 'UserSettings', calendar?: { __typename?: 'UserSettingsCalendar', dateConfiguration?: Array<string | null> | null, calendarView?: string | null, showAllEvents?: boolean | null } | null } | null } | null };

export type VendorListQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type VendorListQuery = { __typename?: 'Query', vendorList?: Array<{ __typename?: 'Vendor', _id: any, shop_name: string, tenant?: { __typename?: 'Tenant', name: string } | null } | null> | null };

export type ProcessingJobByIdQueryVariables = Exact<{
  jobId: Scalars['MongoID']['input'];
  includeNotificationHistory: Scalars['Boolean']['input'];
  includeProcessorSettings: Scalars['Boolean']['input'];
}>;


export type ProcessingJobByIdQuery = { __typename?: 'Query', findProcessorSchedulingById?: { __typename?: 'ProcessorScheduling', _id: any, jobId: string, status: EnumProcessorSchedulingStatus, statusLastUpdated?: any | null, isDeleted?: boolean | null, dropoffDate?: any | null, dropoffDateStr?: string | null, animalSpecies: EnumProcessorSchedulingAnimalSpecies, headCount: number, refundDeadlineDays?: number | null, blockIndex?: number | null, blockTitle?: string | null, notificationHistory?: Array<{ __typename?: 'ProcessorSchedulingNotificationHistory', notificationType?: EnumProcessorSchedulingNotificationHistoryNotificationType | null, type?: string | null, sentTo?: string | null, sentOn?: any | null, user?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, email?: string | null, phone?: string | null } | null, errorMessage?: { __typename?: 'ProcessorSchedulingNotificationHistoryErrorMessage', message?: string | null, code?: string | null } | null } | null> | null, processorSettings?: { __typename?: 'ProcessorSettings', _id: any, enabledAnimalSplits?: Array<string | null> | null, animalSettings?: Array<{ __typename?: 'ProcessorSettingsAnimalSettings', species: EnumProcessorSettingsAnimalSettingsSpecies, inspectionLevels?: Array<EnumProcessorSettingsAnimalSettingsInspectionLevels | null> | null, splitTypes?: Array<string | null> | null } | null> | null, killAndChillSettings?: Array<{ __typename?: 'ProcessorSettingsKillAndChillSettings', species: EnumProcessorSettingsKillAndChillSettingsSpecies, isEnabled: boolean, pricePerHead: number } | null> | null } | null, deposit?: { __typename?: 'ProcessorSchedulingDeposit', amount?: number | null, checkoutSession?: { __typename?: 'ProcessorSchedulingDepositCheckoutSession', status?: string | null, payment_status?: string | null } | null } | null, requestedBy?: { __typename?: 'User', _id: any, first_name: string, last_name?: string | null, phone?: string | null, email?: string | null, role?: EnumUserRole | null, company?: string | null } | null, vendor?: { __typename?: 'Vendor', _id: any, shop_name: string, address: { __typename?: 'Address', email?: string | null, phone?: string | null } } | null, animalHeads?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeads', _id?: any | null, publicId: string, producerIdentifier?: string | null, tracking?: string | null, splitType?: string | null, isHangingWeightPerSide?: boolean | null, hangingWeightSideA?: number | null, hangingWeightSideB?: number | null, hangingWeight?: number | null, liveWeight?: number | null, grade?: string | null, yield?: string | null, killDate?: any | null, killDateStr?: string | null, cutDate?: any | null, cutDateStr?: string | null, isOverThirtyMonths?: boolean | null, isKillAndChill?: boolean | null, sex?: string | null, inspectionLevel?: EnumProcessorSchedulingAnimalHeadsInspectionLevel | null, butcherSlotPrice?: number | null, cutsheetInformation?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsCutsheetInformation', _id?: any | null, splitPart?: string | null, quantity?: number | null, notes?: string | null, locked?: boolean | null, cutsheet?: { __typename?: 'Cutsheet', vendor?: any | null, user?: any | null, type: EnumCutsheetType, animalSpecies: EnumCutsheetAnimalSpecies, inspectionLevels?: Array<EnumCutsheetInspectionLevels | null> | null, name: string, pricePerPound?: number | null, steakThickness?: number | null, steaksPerPack?: number | null, groundMeatSize?: number | null, roastSize?: string | null, isDeleted?: boolean | null, _id: any, splitTypes?: Array<string | null> | null, selectedSpecifications?: any | null, notes?: any | null, primalCuts: Array<{ __typename?: 'PrimalCut', name: string, order: number, _id: any, primal?: { __typename?: 'Primal', name: string, order: number, isDeleted?: boolean | null, _id: any, group?: { __typename?: 'PrimalGroup', animalType?: string | null, name: string, order: number, isDeleted?: boolean | null, _id: any } | null } | null, cutType?: { __typename?: 'PrimalCutType', name: string, _id: any } | null }>, activeSpecification?: { __typename?: 'ProcessorCapabilitySpecification', _id: any, capability?: { __typename?: 'ProcessorCapability', _id: any, animalSpecies?: EnumProcessorSettingsAnimalSettingsSpecies | null, inspectionLevel?: EnumProcessorSettingsAnimalSettingsInspectionLevels | null } | null, specifications?: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecifications', _id?: any | null, name: string, description?: string | null, measurementUnit?: EnumProcessorCapabilitySpecificationSpecificationsMeasurementUnit | null, isVisible: boolean, isRequired: boolean, options: Array<{ __typename?: 'ProcessorCapabilitySpecificationSpecificationsOptions', _id?: any | null, name: string, isVisible: boolean, isDefault: boolean, description?: string | null } | null> } | null> | null } | null, extras?: Array<{ __typename?: 'CutsheetExtras', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, type: EnumCutsheetExtrasType, fee?: number | null } | null> | null, trim?: Array<{ __typename?: 'CutsheetTrim', _id?: any | null, isActive: boolean, minLbs?: number | null, name: string, pricePerPound?: number | null, quantity?: number | null, rank?: number | null, trimSelection: EnumCutsheetTrimTrimSelection } | null> | null } | null, contactUser?: { __typename?: 'User', _id: any, email?: string | null, first_name: string, last_name?: string | null, phone?: string | null, enabled: boolean, role?: EnumUserRole | null, company?: string | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoice', additionalCost?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null, additionalCharges?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceAdditionalCharges', description?: string | null, amount?: number | null } | null> | null, extras?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceExtras', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, trims?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceTrims', description?: string | null, quantity?: number | null, unitPrice?: number | null } | null> | null, finishedWeights?: { __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeights', type?: string | null, totalWeight?: number | null, categories?: Array<{ __typename?: 'ProcessorSchedulingAnimalHeadsInvoiceFinishedWeightsCategories', name?: string | null, weight?: number | null } | null> | null } | null } | null } | null> | null, invoice?: { __typename?: 'ProcessorSchedulingInvoice', invoice_status?: string | null, additionalCost?: { __typename?: 'ProcessorSchedulingInvoiceAdditionalCost', cost?: number | null, reason?: string | null } | null } | null, linkedInvoices?: Array<{ __typename?: 'Invoice', external_id?: string | null, description: string, billing_month?: number | null, billing_year?: number | null, date_created: any, amount_due: number, amount_paid: number, amount_refunded?: number | null, amount_discounted?: number | null, due_date: any, number?: string | null, status: EnumInvoiceStatus, _id: any, type: EnumInvoiceType, vendor?: { __typename?: 'Vendor', shop_name: string, _id: any } | null, user?: { __typename?: 'User', first_name: string, last_name?: string | null, email?: string | null, phone?: string | null, _id: any } | null, line_items: Array<{ __typename?: 'InvoiceLineItem', _id: any, external_id?: string | null, description: string, quantity: number, amount: number }>, status_changes?: Array<{ __typename?: 'InvoiceStatus_changes', date: any, previous_status: EnumInvoiceStatus_ChangesPrevious_Status, new_status: EnumInvoiceStatus_ChangesNew_Status } | null> | null, external_links?: { __typename?: 'InvoiceExternal_links', stripe?: any | null, quickbooks?: any | null } | null, links?: Array<{ __typename?: 'InvoiceLinks', entityType: EnumInvoiceLinksEntityType, parentEntityId: any, subEntityId?: any | null, entity?: any | null, description: string } | null> | null } | null> | null } | null };

export type WaitlistByVendorIdQueryVariables = Exact<{
  vendorId: Scalars['MongoID']['input'];
}>;


export type WaitlistByVendorIdQuery = { __typename?: 'Query', waitlistByVendorId?: Array<{ __typename?: 'Waitlist', _id: any, vendor: any, firstName: string, lastName: string, email?: string | null, phone?: string | null, company?: string | null, createdAt?: any | null, updatedAt?: any | null, sendWaitlistEmail?: boolean | null, sendWaitlistSMS?: boolean | null, animal: EnumWaitlistAnimal, startDate?: any | null, endDate?: any | null } | null> | null };

export const ChatMessageFragmentFragmentDoc = gql`
    fragment ChatMessageFragment on ChatMessage {
  _id
  chatRoom {
    _id
    vendor {
      _id
      shop_name
      tenant {
        name
        picture_url
      }
    }
  }
  content
  sender {
    _id
    first_name
    last_name
    company
    role
    picture_url
  }
  createdAt
  updatedAt
}
    `;
export const ChatRoomFragmentFragmentDoc = gql`
    fragment ChatRoomFragment on ChatRoom {
  _id
  vendor {
    _id
    shop_name
    tenant {
      name
      picture_url
    }
  }
  participants {
    _id
    first_name
    last_name
    company
    role
    picture_url
  }
  createdAt
  createdBy {
    _id
  }
  updatedAt
  lastMessage {
    content
    sender {
      _id
    }
  }
}
    `;
export const NoteFragmentFragmentDoc = gql`
    fragment NoteFragment on Note {
  _id
  note
  type
  attachmentUrl
  createdBy {
    first_name
    last_name
  }
  createdAt
  updatedAt
}
    `;
export const NotificationSettingFragmentFragmentDoc = gql`
    fragment NotificationSettingFragment on NotificationSetting {
  _id
  name
  enabled
  trigger
  timings {
    days
    relation
  }
  sendEmail
  sendSMS
  emailMessage {
    content
    type
  }
  smsMessage {
    content
    type
  }
}
    `;
export const PrimalCutBlockerFragmentFragmentDoc = gql`
    fragment PrimalCutBlockerFragment on PrimalCutBlocker {
  _id
  vendor
  animalSpecies
  inspectionLevel
  name
  primalCutId
  type
  blockedBy {
    name
    primalCutId
    _id
  }
}
    `;
export const CapabilitySpecificationFragmentDoc = gql`
    fragment CapabilitySpecification on ProcessorCapabilitySpecification {
  _id
  capability {
    _id
    animalSpecies
    inspectionLevel
  }
  specifications {
    _id
    name
    description
    options {
      _id
      name
      isVisible
      isDefault
      description
    }
    measurementUnit
    isVisible
    isRequired
  }
}
    `;
export const ProcessorCapabilityFragmentFragmentDoc = gql`
    fragment ProcessorCapabilityFragment on ProcessorCapability {
  _id
  vendor
  animalSpecies
  inspectionLevel
  canSelectMoreThanOneTrim
  trimSelection
  primalCuts
  cuts {
    primal {
      name
      description
      group {
        animalSpecies
        inspectionLevel
        name
        order
        isDefault
        _id
      }
      order
      _id
    }
    isDeleted
    name
    description
    cutType {
      name
      _id
    }
    order
    _id
  }
  extras {
    name
    pricePerPound
    minLbs
    isActive
    _id
    type
    fee
    description
  }
  trim {
    name
    pricePerPound
    minLbs
    isActive
    _id
    description
  }
  activeSpecification {
    ...CapabilitySpecification
  }
  primalGroups {
    _id
    name
    order
    primals {
      _id
      name
      description
      order
    }
  }
  wizardWelcomeTitle
  wizardWelcomeContent
  extrasDescription
  trimDescription
}
    ${CapabilitySpecificationFragmentDoc}`;
export const PrimalCutFragmentFragmentDoc = gql`
    fragment PrimalCutFragment on PrimalCut {
  primal {
    group {
      animalType
      name
      order
      isDeleted
      _id
    }
    name
    order
    isDeleted
    _id
  }
  name
  cutType {
    name
    _id
  }
  order
  _id
}
    `;
export const ExtrasFragmentFragmentDoc = gql`
    fragment ExtrasFragment on CutsheetExtras {
  _id
  isActive
  minLbs
  name
  pricePerPound
  quantity
  type
  fee
}
    `;
export const TrimFragmentFragmentDoc = gql`
    fragment TrimFragment on CutsheetTrim {
  _id
  isActive
  minLbs
  name
  pricePerPound
  quantity
  rank
  trimSelection
}
    `;
export const CutsheetFragmentFragmentDoc = gql`
    fragment CutsheetFragment on Cutsheet {
  vendor
  user
  type
  animalSpecies
  inspectionLevels
  primalCuts {
    ...PrimalCutFragment
  }
  name
  pricePerPound
  steakThickness
  steaksPerPack
  groundMeatSize
  roastSize
  isDeleted
  _id
  splitTypes
  activeSpecification {
    _id
    ...CapabilitySpecification
  }
  selectedSpecifications
  extras {
    ...ExtrasFragment
  }
  trim {
    ...TrimFragment
  }
  notes
}
    ${PrimalCutFragmentFragmentDoc}
${CapabilitySpecificationFragmentDoc}
${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;
export const ContactUserFragmentDoc = gql`
    fragment ContactUser on User {
  _id
  email
  first_name
  last_name
  phone
  enabled
  role
  company
}
    `;
export const CutsheetInformationFragmentDoc = gql`
    fragment CutsheetInformation on ProcessorSchedulingAnimalHeadsCutsheetInformation {
  _id
  cutsheet {
    ...CutsheetFragment
  }
  splitPart
  quantity
  notes
  locked
  contactUser {
    ...ContactUser
  }
}
    ${CutsheetFragmentFragmentDoc}
${ContactUserFragmentDoc}`;
export const AnimalHeadFragmentDoc = gql`
    fragment AnimalHead on ProcessorSchedulingAnimalHeads {
  _id
  publicId
  producerIdentifier
  tracking
  splitType
  isHangingWeightPerSide
  hangingWeightSideA
  hangingWeightSideB
  hangingWeight
  liveWeight
  grade
  yield
  killDate
  killDateStr
  cutDate
  cutDateStr
  cutsheetInformation {
    ...CutsheetInformation
  }
  isOverThirtyMonths
  isKillAndChill
  sex
  inspectionLevel
  butcherSlotPrice
  invoice {
    additionalCost {
      cost
      reason
    }
    additionalCharges {
      description
      amount
    }
    extras {
      description
      quantity
      unitPrice
    }
    trims {
      description
      quantity
      unitPrice
    }
    finishedWeights {
      type
      totalWeight
      categories {
        name
        weight
      }
    }
  }
}
    ${CutsheetInformationFragmentDoc}`;
export const InvoiceFragmentLineItemFragmentDoc = gql`
    fragment InvoiceFragmentLineItem on InvoiceLineItem {
  _id
  external_id
  description
  quantity
  amount
}
    `;
export const InvoiceFragmentFragmentDoc = gql`
    fragment InvoiceFragment on Invoice {
  vendor {
    shop_name
    _id
  }
  user {
    first_name
    last_name
    email
    phone
    _id
  }
  external_id
  description
  billing_month
  billing_year
  date_created
  amount_due
  amount_paid
  amount_refunded
  amount_discounted
  line_items {
    ...InvoiceFragmentLineItem
  }
  status_changes {
    date
    previous_status
    new_status
  }
  external_links {
    stripe
    quickbooks
  }
  links {
    entityType
    parentEntityId
    subEntityId
    entity
    description
  }
  due_date
  number
  status
  status_changes {
    date
    previous_status
    new_status
  }
  _id
  type
}
    ${InvoiceFragmentLineItemFragmentDoc}`;
export const ProcessorSchedulingFragmentFragmentDoc = gql`
    fragment ProcessorSchedulingFragment on ProcessorScheduling {
  _id
  jobId
  status
  statusLastUpdated
  isDeleted
  dropoffDate
  dropoffDateStr
  animalSpecies
  headCount
  refundDeadlineDays
  blockIndex
  blockTitle
  deposit {
    amount
    checkoutSession {
      status
      payment_status
    }
  }
  requestedBy {
    _id
    first_name
    last_name
    phone
    email
    role
    company
  }
  vendor {
    _id
    shop_name
    address {
      email
      phone
    }
  }
  animalHeads {
    ...AnimalHead
  }
  processorSettings {
    _id
  }
  invoice {
    invoice_status
    additionalCost {
      cost
      reason
    }
  }
  linkedInvoices {
    ...InvoiceFragment
  }
}
    ${AnimalHeadFragmentDoc}
${InvoiceFragmentFragmentDoc}`;
export const ProcessorSchedulingCalendarFragmentFragmentDoc = gql`
    fragment ProcessorSchedulingCalendarFragment on ProcessorScheduling {
  _id
  jobId
  status
  statusLastUpdated
  isDeleted
  dropoffDate
  dropoffDateStr
  animalSpecies
  headCount
  refundDeadlineDays
  blockIndex
  blockTitle
  deposit {
    amount
    checkoutSession {
      status
      payment_status
    }
  }
  requestedBy {
    _id
    first_name
    last_name
    phone
    email
    role
    company
  }
  vendor {
    _id
    shop_name
    address {
      email
      phone
    }
  }
  animalHeads {
    _id
    publicId
    producerIdentifier
    tracking
    splitType
    isHangingWeightPerSide
    hangingWeightSideA
    hangingWeightSideB
    hangingWeight
    liveWeight
    grade
    yield
    killDate
    killDateStr
    cutDate
    cutDateStr
    isOverThirtyMonths
    isKillAndChill
    sex
    inspectionLevel
    butcherSlotPrice
  }
}
    `;
export const ProcessorSchedulingSlimFragmentFragmentDoc = gql`
    fragment ProcessorSchedulingSlimFragment on ProcessorScheduling {
  _id
  vendor {
    _id
  }
  dropoffDate
  status
  animalSpecies
  headCount
  blockIndex
  blockTitle
  animalHeads {
    _id
    inspectionLevel
  }
}
    `;
export const DailyCapacityFragmentFragmentDoc = gql`
    fragment DailyCapacityFragment on DailyCapacityCapacitiesByType {
  type
  capacities {
    ... on SpeciesComplexAnimalCapacitySchema {
      species
      value
    }
    ... on SpeciesInspectionComplexAnimalCapacitySchema {
      species
      inspectionLevel
      value
    }
    ... on WeightedAnimalComplexAnimalCapacitySchema {
      value
    }
  }
}
    `;
export const DailyCapacityBlockFragmentFragmentDoc = gql`
    fragment DailyCapacityBlockFragment on DailyCapacity {
  title
  capacitiesByType {
    ...DailyCapacityFragment
  }
}
    ${DailyCapacityFragmentFragmentDoc}`;
export const AddressFragmentFragmentDoc = gql`
    fragment AddressFragment on Address {
  first_name
  last_name
  company
  address_1
  address_2
  city
  state
  postcode
  country
  email
  phone
  type
  _id
}
    `;
export const TenantFragmentFragmentDoc = gql`
    fragment TenantFragment on Tenant {
  name
  date_created
  enabled
  domain
  modules {
    name
    label
    href
    order
    _id
  }
  vendors {
    date_created
    external_id
    prefers_dropoff
    shop_name
    shop_slug
    tagline
    address {
      ...AddressFragment
    }
    _id
  }
  _id
}
    ${AddressFragmentFragmentDoc}`;
export const ParentProductFragmentDoc = gql`
    fragment ParentProduct on ParentProduct {
  _id
  vendor
  external_id
  slug
  name
  permalink
  price
  weight
  description
  short_description
  stock_status
  stock_quantity
}
    `;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  external_id
  slug
  name
  permalink
  price
  weight
  enabled
  description
  short_description
  stock_status
  stock_quantity
  _id
  integration {
    name
  }
  parent {
    ...ParentProduct
  }
  children {
    ...ParentProduct
  }
}
    ${ParentProductFragmentDoc}`;
export const VendorFragmentFragmentDoc = gql`
    fragment VendorFragment on Vendor {
  external_id
  date_created
  shop_name
  shop_slug
  pickup_days
  enabled
  free_shipping_amount
  prefers_dropoff
  tagline
  _id
  tenant {
    ...TenantFragment
  }
  address {
    ...AddressFragment
  }
  products(sort: _ID_ASC) {
    ...ProductFragment
  }
  integrations {
    _id
    name
    type
  }
  zone
  stripe_config
}
    ${TenantFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${ProductFragmentFragmentDoc}`;
export const ProcessorSettingsFragmentFragmentDoc = gql`
    fragment ProcessorSettingsFragment on ProcessorSettings {
  _id
  animalSettings {
    _id
    isEnabled
    species
    inspectionLevels
    splitTypes
    weightedAnimalUnit
    customCutsheetPricing {
      price
      inspectionLevel
    }
    butcherSlotPricing {
      price
      inspectionLevel
    }
  }
  capacityConfigurationType
  capacitySettings {
    isEnabled
    dayOfWeek
    dailyCapacities {
      ...DailyCapacityBlockFragment
    }
  }
  carcassSettings {
    species
    inspectionLevel
    year
    currentNumber
    lastTakenNumber
  }
  schedulingDeposit
  refundDeadlineDays
  vendor {
    ...VendorFragment
  }
  faq
  validationErrors {
    type
    value
    property
    messages
    group
  }
  about
  autoSchedulingSettings {
    species
    isEnabled
    cutDateDays
    harvestDateDays
  }
  killAndChillSettings {
    species
    isEnabled
    pricePerHead
  }
  isWaitlistFunctionalityDisabled
  isProcessorNotificationsEnabled
  processorNotificationEmailAddresses
  animals
  invoicing {
    trackYields
    showYieldOnInvoice
    defaultSplitRule
  }
  documentSettings {
    cutsheet {
      format
    }
    carcassTag {
      title
    }
  }
}
    ${DailyCapacityBlockFragmentFragmentDoc}
${VendorFragmentFragmentDoc}`;
export const ProcessorSettingsCustomCapacityFragmentFragmentDoc = gql`
    fragment ProcessorSettingsCustomCapacityFragment on ProcessorSettingsCustomCapacity {
  _id
  isDeleted
  date
  dailyCapacities {
    ...DailyCapacityBlockFragment
  }
  dateStr
}
    ${DailyCapacityBlockFragmentFragmentDoc}`;
export const UserFragmentFragmentDoc = gql`
    fragment UserFragment on User {
  first_name
  last_name
  email
  phone
  picture_url
  role
  enabled
  active_vendor {
    date_created
    external_id
    prefers_dropoff
    shop_name
    shop_slug
    tagline
    address {
      ...AddressFragment
    }
    integrations {
      name
      type
      isSyncing
      lastSynced
      _id
    }
    zone
    stripe_config
    _id
  }
  tenant {
    ...TenantFragment
  }
  settings {
    calendar {
      dateConfiguration
      calendarView
      showAllEvents
    }
  }
  _id
}
    ${AddressFragmentFragmentDoc}
${TenantFragmentFragmentDoc}`;
export const WaitlistFragmentFragmentDoc = gql`
    fragment WaitlistFragment on Waitlist {
  _id
  vendor
  firstName
  lastName
  email
  phone
  company
  createdAt
  updatedAt
  sendWaitlistEmail
  sendWaitlistSMS
  animal
  startDate
  endDate
}
    `;
export const IntegrationCreateOneDocument = gql`
    mutation IntegrationCreateOne($record: CreateOneIntegrationInput!) {
  integrationCreateOne(record: $record) {
    recordId
    record {
      name
      type
      endpoint
      key
      _id
    }
    error {
      message
    }
  }
}
    `;
export type IntegrationCreateOneMutationFn = Apollo.MutationFunction<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>;

/**
 * __useIntegrationCreateOneMutation__
 *
 * To run a mutation, you first call `useIntegrationCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationCreateOneMutation, { data, loading, error }] = useIntegrationCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useIntegrationCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>(IntegrationCreateOneDocument, options);
      }
export type IntegrationCreateOneMutationHookResult = ReturnType<typeof useIntegrationCreateOneMutation>;
export type IntegrationCreateOneMutationResult = Apollo.MutationResult<IntegrationCreateOneMutation>;
export type IntegrationCreateOneMutationOptions = Apollo.BaseMutationOptions<IntegrationCreateOneMutation, IntegrationCreateOneMutationVariables>;
export const IntegrationUpdateConfigDocument = gql`
    mutation IntegrationUpdateConfig($integrationId: MongoID!, $config: JSON!) {
  integrationUpdateById(_id: $integrationId, record: {config: $config}) {
    recordId
  }
}
    `;
export type IntegrationUpdateConfigMutationFn = Apollo.MutationFunction<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>;

/**
 * __useIntegrationUpdateConfigMutation__
 *
 * To run a mutation, you first call `useIntegrationUpdateConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationUpdateConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationUpdateConfigMutation, { data, loading, error }] = useIntegrationUpdateConfigMutation({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useIntegrationUpdateConfigMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>(IntegrationUpdateConfigDocument, options);
      }
export type IntegrationUpdateConfigMutationHookResult = ReturnType<typeof useIntegrationUpdateConfigMutation>;
export type IntegrationUpdateConfigMutationResult = Apollo.MutationResult<IntegrationUpdateConfigMutation>;
export type IntegrationUpdateConfigMutationOptions = Apollo.BaseMutationOptions<IntegrationUpdateConfigMutation, IntegrationUpdateConfigMutationVariables>;
export const ProcessorSettingsUpdateByIdDocument = gql`
    mutation ProcessorSettingsUpdateById($id: MongoID!, $record: UpdateByIdProcessorSettingsInput!) {
  processorSettingsUpdateById(_id: $id, record: $record) {
    recordId
  }
}
    `;
export type ProcessorSettingsUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>;

/**
 * __useProcessorSettingsUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsUpdateByIdMutation, { data, loading, error }] = useProcessorSettingsUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSettingsUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>(ProcessorSettingsUpdateByIdDocument, options);
      }
export type ProcessorSettingsUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSettingsUpdateByIdMutation>;
export type ProcessorSettingsUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSettingsUpdateByIdMutation>;
export type ProcessorSettingsUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsUpdateByIdMutation, ProcessorSettingsUpdateByIdMutationVariables>;
export const TenantCreateDocument = gql`
    mutation TenantCreate($newTenant: CreateOneTenantInput!) {
  tenantCreate(newTenant: $newTenant) {
    external_id
    name
    date_created
    domain
    enabled
    _id
  }
}
    `;
export type TenantCreateMutationFn = Apollo.MutationFunction<TenantCreateMutation, TenantCreateMutationVariables>;

/**
 * __useTenantCreateMutation__
 *
 * To run a mutation, you first call `useTenantCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantCreateMutation, { data, loading, error }] = useTenantCreateMutation({
 *   variables: {
 *      newTenant: // value for 'newTenant'
 *   },
 * });
 */
export function useTenantCreateMutation(baseOptions?: Apollo.MutationHookOptions<TenantCreateMutation, TenantCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantCreateMutation, TenantCreateMutationVariables>(TenantCreateDocument, options);
      }
export type TenantCreateMutationHookResult = ReturnType<typeof useTenantCreateMutation>;
export type TenantCreateMutationResult = Apollo.MutationResult<TenantCreateMutation>;
export type TenantCreateMutationOptions = Apollo.BaseMutationOptions<TenantCreateMutation, TenantCreateMutationVariables>;
export const TenantModulesEditDocument = gql`
    mutation TenantModulesEdit($tenantId: MongoID!, $moduleIds: [MongoID]!) {
  tenantModulesEdit(tenantId: $tenantId, moduleIds: $moduleIds) {
    external_id
    name
    enabled
    _id
  }
}
    `;
export type TenantModulesEditMutationFn = Apollo.MutationFunction<TenantModulesEditMutation, TenantModulesEditMutationVariables>;

/**
 * __useTenantModulesEditMutation__
 *
 * To run a mutation, you first call `useTenantModulesEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantModulesEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantModulesEditMutation, { data, loading, error }] = useTenantModulesEditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      moduleIds: // value for 'moduleIds'
 *   },
 * });
 */
export function useTenantModulesEditMutation(baseOptions?: Apollo.MutationHookOptions<TenantModulesEditMutation, TenantModulesEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantModulesEditMutation, TenantModulesEditMutationVariables>(TenantModulesEditDocument, options);
      }
export type TenantModulesEditMutationHookResult = ReturnType<typeof useTenantModulesEditMutation>;
export type TenantModulesEditMutationResult = Apollo.MutationResult<TenantModulesEditMutation>;
export type TenantModulesEditMutationOptions = Apollo.BaseMutationOptions<TenantModulesEditMutation, TenantModulesEditMutationVariables>;
export const TenantPictureUrlEditDocument = gql`
    mutation TenantPictureUrlEdit($tenantId: MongoID!, $picture_url: String) {
  tenantPictureUrlEdit(tenantId: $tenantId, picture_url: $picture_url) {
    external_id
    name
    enabled
    _id
    picture_url
  }
}
    `;
export type TenantPictureUrlEditMutationFn = Apollo.MutationFunction<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>;

/**
 * __useTenantPictureUrlEditMutation__
 *
 * To run a mutation, you first call `useTenantPictureUrlEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantPictureUrlEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantPictureUrlEditMutation, { data, loading, error }] = useTenantPictureUrlEditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      picture_url: // value for 'picture_url'
 *   },
 * });
 */
export function useTenantPictureUrlEditMutation(baseOptions?: Apollo.MutationHookOptions<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>(TenantPictureUrlEditDocument, options);
      }
export type TenantPictureUrlEditMutationHookResult = ReturnType<typeof useTenantPictureUrlEditMutation>;
export type TenantPictureUrlEditMutationResult = Apollo.MutationResult<TenantPictureUrlEditMutation>;
export type TenantPictureUrlEditMutationOptions = Apollo.BaseMutationOptions<TenantPictureUrlEditMutation, TenantPictureUrlEditMutationVariables>;
export const TenantSubscriptionEditDocument = gql`
    mutation TenantSubscriptionEdit($tenantId: MongoID!, $subscription: String!) {
  tenantSubscriptionEdit(tenantId: $tenantId, subscription: $subscription) {
    external_id
    external_ids
    name
    email
    date_created
    picture_url
    primary_color
    domain
    enabled
    _id
  }
}
    `;
export type TenantSubscriptionEditMutationFn = Apollo.MutationFunction<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>;

/**
 * __useTenantSubscriptionEditMutation__
 *
 * To run a mutation, you first call `useTenantSubscriptionEditMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTenantSubscriptionEditMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tenantSubscriptionEditMutation, { data, loading, error }] = useTenantSubscriptionEditMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useTenantSubscriptionEditMutation(baseOptions?: Apollo.MutationHookOptions<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>(TenantSubscriptionEditDocument, options);
      }
export type TenantSubscriptionEditMutationHookResult = ReturnType<typeof useTenantSubscriptionEditMutation>;
export type TenantSubscriptionEditMutationResult = Apollo.MutationResult<TenantSubscriptionEditMutation>;
export type TenantSubscriptionEditMutationOptions = Apollo.BaseMutationOptions<TenantSubscriptionEditMutation, TenantSubscriptionEditMutationVariables>;
export const UserActivateDocument = gql`
    mutation UserActivate($userId: MongoID!) {
  userActivate(userId: $userId) {
    external_id
    enabled
    first_name
    last_name
    email
    picture_url
    role
    last_login
    _id
  }
}
    `;
export type UserActivateMutationFn = Apollo.MutationFunction<UserActivateMutation, UserActivateMutationVariables>;

/**
 * __useUserActivateMutation__
 *
 * To run a mutation, you first call `useUserActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userActivateMutation, { data, loading, error }] = useUserActivateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserActivateMutation(baseOptions?: Apollo.MutationHookOptions<UserActivateMutation, UserActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserActivateMutation, UserActivateMutationVariables>(UserActivateDocument, options);
      }
export type UserActivateMutationHookResult = ReturnType<typeof useUserActivateMutation>;
export type UserActivateMutationResult = Apollo.MutationResult<UserActivateMutation>;
export type UserActivateMutationOptions = Apollo.BaseMutationOptions<UserActivateMutation, UserActivateMutationVariables>;
export const UserCreateDocument = gql`
    mutation UserCreate($newUser: CreateOneUserInput!) {
  userCreate(newUser: $newUser) {
    first_name
    last_name
    email
    picture_url
    role
    access_token
    refresh_token
    access_token
    refresh_token
    last_login
    _id
  }
}
    `;
export type UserCreateMutationFn = Apollo.MutationFunction<UserCreateMutation, UserCreateMutationVariables>;

/**
 * __useUserCreateMutation__
 *
 * To run a mutation, you first call `useUserCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCreateMutation, { data, loading, error }] = useUserCreateMutation({
 *   variables: {
 *      newUser: // value for 'newUser'
 *   },
 * });
 */
export function useUserCreateMutation(baseOptions?: Apollo.MutationHookOptions<UserCreateMutation, UserCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserCreateMutation, UserCreateMutationVariables>(UserCreateDocument, options);
      }
export type UserCreateMutationHookResult = ReturnType<typeof useUserCreateMutation>;
export type UserCreateMutationResult = Apollo.MutationResult<UserCreateMutation>;
export type UserCreateMutationOptions = Apollo.BaseMutationOptions<UserCreateMutation, UserCreateMutationVariables>;
export const UserDeactivateDocument = gql`
    mutation UserDeactivate($userId: MongoID!) {
  userDeactivate(userId: $userId) {
    external_id
    enabled
    first_name
    last_name
    email
    picture_url
    role
    last_login
    _id
  }
}
    `;
export type UserDeactivateMutationFn = Apollo.MutationFunction<UserDeactivateMutation, UserDeactivateMutationVariables>;

/**
 * __useUserDeactivateMutation__
 *
 * To run a mutation, you first call `useUserDeactivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeactivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeactivateMutation, { data, loading, error }] = useUserDeactivateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeactivateMutation(baseOptions?: Apollo.MutationHookOptions<UserDeactivateMutation, UserDeactivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserDeactivateMutation, UserDeactivateMutationVariables>(UserDeactivateDocument, options);
      }
export type UserDeactivateMutationHookResult = ReturnType<typeof useUserDeactivateMutation>;
export type UserDeactivateMutationResult = Apollo.MutationResult<UserDeactivateMutation>;
export type UserDeactivateMutationOptions = Apollo.BaseMutationOptions<UserDeactivateMutation, UserDeactivateMutationVariables>;
export const VendorCreateDocument = gql`
    mutation VendorCreate($newVendor: CreateOneVendorInput!) {
  vendorCreate(newVendor: $newVendor) {
    external_id
    date_created
    shop_name
    shop_slug
    tagline
    enabled
    annualHangingWeightThroughput
    _id
  }
}
    `;
export type VendorCreateMutationFn = Apollo.MutationFunction<VendorCreateMutation, VendorCreateMutationVariables>;

/**
 * __useVendorCreateMutation__
 *
 * To run a mutation, you first call `useVendorCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorCreateMutation, { data, loading, error }] = useVendorCreateMutation({
 *   variables: {
 *      newVendor: // value for 'newVendor'
 *   },
 * });
 */
export function useVendorCreateMutation(baseOptions?: Apollo.MutationHookOptions<VendorCreateMutation, VendorCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorCreateMutation, VendorCreateMutationVariables>(VendorCreateDocument, options);
      }
export type VendorCreateMutationHookResult = ReturnType<typeof useVendorCreateMutation>;
export type VendorCreateMutationResult = Apollo.MutationResult<VendorCreateMutation>;
export type VendorCreateMutationOptions = Apollo.BaseMutationOptions<VendorCreateMutation, VendorCreateMutationVariables>;
export const VendorUpdateByIdDocument = gql`
    mutation VendorUpdateById($record: UpdateByIdVendorInput!, $_id: MongoID!) {
  vendorUpdateById(record: $record, _id: $_id) {
    record {
      ...VendorFragment
    }
  }
}
    ${VendorFragmentFragmentDoc}`;
export type VendorUpdateByIdMutationFn = Apollo.MutationFunction<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>;

/**
 * __useVendorUpdateByIdMutation__
 *
 * To run a mutation, you first call `useVendorUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVendorUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vendorUpdateByIdMutation, { data, loading, error }] = useVendorUpdateByIdMutation({
 *   variables: {
 *      record: // value for 'record'
 *      _id: // value for '_id'
 *   },
 * });
 */
export function useVendorUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>(VendorUpdateByIdDocument, options);
      }
export type VendorUpdateByIdMutationHookResult = ReturnType<typeof useVendorUpdateByIdMutation>;
export type VendorUpdateByIdMutationResult = Apollo.MutationResult<VendorUpdateByIdMutation>;
export type VendorUpdateByIdMutationOptions = Apollo.BaseMutationOptions<VendorUpdateByIdMutation, VendorUpdateByIdMutationVariables>;
export const ChatRoomCreateOneDocument = gql`
    mutation ChatRoomCreateOne($record: CreateOneChatRoomInput!) {
  chatRoomCreateOne(record: $record) {
    recordId
    record {
      ...ChatRoomFragment
    }
  }
}
    ${ChatRoomFragmentFragmentDoc}`;
export type ChatRoomCreateOneMutationFn = Apollo.MutationFunction<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>;

/**
 * __useChatRoomCreateOneMutation__
 *
 * To run a mutation, you first call `useChatRoomCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChatRoomCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [chatRoomCreateOneMutation, { data, loading, error }] = useChatRoomCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useChatRoomCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>(ChatRoomCreateOneDocument, options);
      }
export type ChatRoomCreateOneMutationHookResult = ReturnType<typeof useChatRoomCreateOneMutation>;
export type ChatRoomCreateOneMutationResult = Apollo.MutationResult<ChatRoomCreateOneMutation>;
export type ChatRoomCreateOneMutationOptions = Apollo.BaseMutationOptions<ChatRoomCreateOneMutation, ChatRoomCreateOneMutationVariables>;
export const CreateProcessorSchedulingDocument = gql`
    mutation CreateProcessorScheduling($newSchedule: CreateProcessorSchedulingInput!) {
  processorSchedulingCreate(newSchedule: $newSchedule) {
    scheduling {
      ...ProcessorSchedulingFragment
    }
    checkoutSession {
      clientSecret
    }
  }
}
    ${ProcessorSchedulingFragmentFragmentDoc}`;
export type CreateProcessorSchedulingMutationFn = Apollo.MutationFunction<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>;

/**
 * __useCreateProcessorSchedulingMutation__
 *
 * To run a mutation, you first call `useCreateProcessorSchedulingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessorSchedulingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessorSchedulingMutation, { data, loading, error }] = useCreateProcessorSchedulingMutation({
 *   variables: {
 *      newSchedule: // value for 'newSchedule'
 *   },
 * });
 */
export function useCreateProcessorSchedulingMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>(CreateProcessorSchedulingDocument, options);
      }
export type CreateProcessorSchedulingMutationHookResult = ReturnType<typeof useCreateProcessorSchedulingMutation>;
export type CreateProcessorSchedulingMutationResult = Apollo.MutationResult<CreateProcessorSchedulingMutation>;
export type CreateProcessorSchedulingMutationOptions = Apollo.BaseMutationOptions<CreateProcessorSchedulingMutation, CreateProcessorSchedulingMutationVariables>;
export const CutsheetCreateOneDocument = gql`
    mutation CutsheetCreateOne($record: CreateOneCutsheetInput!) {
  cutsheetCreateOne(record: $record) {
    recordId
    record {
      ...CutsheetFragment
    }
  }
}
    ${CutsheetFragmentFragmentDoc}`;
export type CutsheetCreateOneMutationFn = Apollo.MutationFunction<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>;

/**
 * __useCutsheetCreateOneMutation__
 *
 * To run a mutation, you first call `useCutsheetCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetCreateOneMutation, { data, loading, error }] = useCutsheetCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function useCutsheetCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>(CutsheetCreateOneDocument, options);
      }
export type CutsheetCreateOneMutationHookResult = ReturnType<typeof useCutsheetCreateOneMutation>;
export type CutsheetCreateOneMutationResult = Apollo.MutationResult<CutsheetCreateOneMutation>;
export type CutsheetCreateOneMutationOptions = Apollo.BaseMutationOptions<CutsheetCreateOneMutation, CutsheetCreateOneMutationVariables>;
export const CutsheetSoftDeleteDocument = gql`
    mutation cutsheetSoftDelete($cutsheetId: MongoID!) {
  cutsheetSoftDelete(cutsheetId: $cutsheetId) {
    _id
  }
}
    `;
export type CutsheetSoftDeleteMutationFn = Apollo.MutationFunction<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>;

/**
 * __useCutsheetSoftDeleteMutation__
 *
 * To run a mutation, you first call `useCutsheetSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetSoftDeleteMutation, { data, loading, error }] = useCutsheetSoftDeleteMutation({
 *   variables: {
 *      cutsheetId: // value for 'cutsheetId'
 *   },
 * });
 */
export function useCutsheetSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>(CutsheetSoftDeleteDocument, options);
      }
export type CutsheetSoftDeleteMutationHookResult = ReturnType<typeof useCutsheetSoftDeleteMutation>;
export type CutsheetSoftDeleteMutationResult = Apollo.MutationResult<CutsheetSoftDeleteMutation>;
export type CutsheetSoftDeleteMutationOptions = Apollo.BaseMutationOptions<CutsheetSoftDeleteMutation, CutsheetSoftDeleteMutationVariables>;
export const CutsheetUpsertDocument = gql`
    mutation CutsheetUpsert($cutsheetId: MongoID, $type: EnumCutsheetType, $animalSpecies: EnumCutsheetAnimalSpecies, $inspectionLevels: [EnumCutsheetInspectionLevels], $primalCuts: [MongoID!], $splitTypes: [String!], $name: String!, $pricePerPound: Float, $activeSpecification: MongoID, $selectedSpecifications: JSON, $extras: [CutsheetExtrasTypeInput!], $trim: [CutsheetTrimTypeInput!]) {
  cutsheetUpsert(
    cutsheetId: $cutsheetId
    type: $type
    animalSpecies: $animalSpecies
    inspectionLevels: $inspectionLevels
    primalCuts: $primalCuts
    splitTypes: $splitTypes
    name: $name
    pricePerPound: $pricePerPound
    activeSpecification: $activeSpecification
    selectedSpecifications: $selectedSpecifications
    extras: $extras
    trim: $trim
  ) {
    ...CutsheetFragment
  }
}
    ${CutsheetFragmentFragmentDoc}`;
export type CutsheetUpsertMutationFn = Apollo.MutationFunction<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>;

/**
 * __useCutsheetUpsertMutation__
 *
 * To run a mutation, you first call `useCutsheetUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCutsheetUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cutsheetUpsertMutation, { data, loading, error }] = useCutsheetUpsertMutation({
 *   variables: {
 *      cutsheetId: // value for 'cutsheetId'
 *      type: // value for 'type'
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevels: // value for 'inspectionLevels'
 *      primalCuts: // value for 'primalCuts'
 *      splitTypes: // value for 'splitTypes'
 *      name: // value for 'name'
 *      pricePerPound: // value for 'pricePerPound'
 *      activeSpecification: // value for 'activeSpecification'
 *      selectedSpecifications: // value for 'selectedSpecifications'
 *      extras: // value for 'extras'
 *      trim: // value for 'trim'
 *   },
 * });
 */
export function useCutsheetUpsertMutation(baseOptions?: Apollo.MutationHookOptions<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>(CutsheetUpsertDocument, options);
      }
export type CutsheetUpsertMutationHookResult = ReturnType<typeof useCutsheetUpsertMutation>;
export type CutsheetUpsertMutationResult = Apollo.MutationResult<CutsheetUpsertMutation>;
export type CutsheetUpsertMutationOptions = Apollo.BaseMutationOptions<CutsheetUpsertMutation, CutsheetUpsertMutationVariables>;
export const IntegrationInitDocument = gql`
    mutation IntegrationInit($integrationName: EnumIntegrationName!, $shop: String) {
  integrationInit(integrationName: $integrationName, shop: $shop) {
    name
    type
    endpoint
    key
    _id
  }
}
    `;
export type IntegrationInitMutationFn = Apollo.MutationFunction<IntegrationInitMutation, IntegrationInitMutationVariables>;

/**
 * __useIntegrationInitMutation__
 *
 * To run a mutation, you first call `useIntegrationInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationInitMutation, { data, loading, error }] = useIntegrationInitMutation({
 *   variables: {
 *      integrationName: // value for 'integrationName'
 *      shop: // value for 'shop'
 *   },
 * });
 */
export function useIntegrationInitMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationInitMutation, IntegrationInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationInitMutation, IntegrationInitMutationVariables>(IntegrationInitDocument, options);
      }
export type IntegrationInitMutationHookResult = ReturnType<typeof useIntegrationInitMutation>;
export type IntegrationInitMutationResult = Apollo.MutationResult<IntegrationInitMutation>;
export type IntegrationInitMutationOptions = Apollo.BaseMutationOptions<IntegrationInitMutation, IntegrationInitMutationVariables>;
export const InvoiceFinalizeAndSendDocument = gql`
    mutation InvoiceFinalizeAndSend($input: VoidInvoiceInput) {
  invoiceFinalizeAndSend(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceFinalizeAndSendMutationFn = Apollo.MutationFunction<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>;

/**
 * __useInvoiceFinalizeAndSendMutation__
 *
 * To run a mutation, you first call `useInvoiceFinalizeAndSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceFinalizeAndSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceFinalizeAndSendMutation, { data, loading, error }] = useInvoiceFinalizeAndSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceFinalizeAndSendMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>(InvoiceFinalizeAndSendDocument, options);
      }
export type InvoiceFinalizeAndSendMutationHookResult = ReturnType<typeof useInvoiceFinalizeAndSendMutation>;
export type InvoiceFinalizeAndSendMutationResult = Apollo.MutationResult<InvoiceFinalizeAndSendMutation>;
export type InvoiceFinalizeAndSendMutationOptions = Apollo.BaseMutationOptions<InvoiceFinalizeAndSendMutation, InvoiceFinalizeAndSendMutationVariables>;
export const GenerateInvoicePdfDocument = gql`
    mutation generateInvoicePdf($invoiceId: MongoID!) {
  generateInvoicePdf(invoiceId: $invoiceId) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type GenerateInvoicePdfMutationFn = Apollo.MutationFunction<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>;

/**
 * __useGenerateInvoicePdfMutation__
 *
 * To run a mutation, you first call `useGenerateInvoicePdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateInvoicePdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateInvoicePdfMutation, { data, loading, error }] = useGenerateInvoicePdfMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGenerateInvoicePdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>(GenerateInvoicePdfDocument, options);
      }
export type GenerateInvoicePdfMutationHookResult = ReturnType<typeof useGenerateInvoicePdfMutation>;
export type GenerateInvoicePdfMutationResult = Apollo.MutationResult<GenerateInvoicePdfMutation>;
export type GenerateInvoicePdfMutationOptions = Apollo.BaseMutationOptions<GenerateInvoicePdfMutation, GenerateInvoicePdfMutationVariables>;
export const InvoiceMarkAsPaidDocument = gql`
    mutation InvoiceMarkAsPaid($input: MarkAsPaidInput) {
  invoiceMarkAsPaid(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceMarkAsPaidMutationFn = Apollo.MutationFunction<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>;

/**
 * __useInvoiceMarkAsPaidMutation__
 *
 * To run a mutation, you first call `useInvoiceMarkAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceMarkAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceMarkAsPaidMutation, { data, loading, error }] = useInvoiceMarkAsPaidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceMarkAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>(InvoiceMarkAsPaidDocument, options);
      }
export type InvoiceMarkAsPaidMutationHookResult = ReturnType<typeof useInvoiceMarkAsPaidMutation>;
export type InvoiceMarkAsPaidMutationResult = Apollo.MutationResult<InvoiceMarkAsPaidMutation>;
export type InvoiceMarkAsPaidMutationOptions = Apollo.BaseMutationOptions<InvoiceMarkAsPaidMutation, InvoiceMarkAsPaidMutationVariables>;
export const InvoiceRefundDocument = gql`
    mutation InvoiceRefund($input: RefundInvoiceInput) {
  invoiceRefund(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceRefundMutationFn = Apollo.MutationFunction<InvoiceRefundMutation, InvoiceRefundMutationVariables>;

/**
 * __useInvoiceRefundMutation__
 *
 * To run a mutation, you first call `useInvoiceRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceRefundMutation, { data, loading, error }] = useInvoiceRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceRefundMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceRefundMutation, InvoiceRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceRefundMutation, InvoiceRefundMutationVariables>(InvoiceRefundDocument, options);
      }
export type InvoiceRefundMutationHookResult = ReturnType<typeof useInvoiceRefundMutation>;
export type InvoiceRefundMutationResult = Apollo.MutationResult<InvoiceRefundMutation>;
export type InvoiceRefundMutationOptions = Apollo.BaseMutationOptions<InvoiceRefundMutation, InvoiceRefundMutationVariables>;
export const InvoiceUpdateDocument = gql`
    mutation InvoiceUpdate($input: UpdateInvoiceInput) {
  invoiceUpdate(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceUpdateMutationFn = Apollo.MutationFunction<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>;

/**
 * __useInvoiceUpdateMutation__
 *
 * To run a mutation, you first call `useInvoiceUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceUpdateMutation, { data, loading, error }] = useInvoiceUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceUpdateMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>(InvoiceUpdateDocument, options);
      }
export type InvoiceUpdateMutationHookResult = ReturnType<typeof useInvoiceUpdateMutation>;
export type InvoiceUpdateMutationResult = Apollo.MutationResult<InvoiceUpdateMutation>;
export type InvoiceUpdateMutationOptions = Apollo.BaseMutationOptions<InvoiceUpdateMutation, InvoiceUpdateMutationVariables>;
export const InvoiceVoidDocument = gql`
    mutation InvoiceVoid($input: VoidInvoiceInput) {
  invoiceVoid(input: $input) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;
export type InvoiceVoidMutationFn = Apollo.MutationFunction<InvoiceVoidMutation, InvoiceVoidMutationVariables>;

/**
 * __useInvoiceVoidMutation__
 *
 * To run a mutation, you first call `useInvoiceVoidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceVoidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceVoidMutation, { data, loading, error }] = useInvoiceVoidMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInvoiceVoidMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceVoidMutation, InvoiceVoidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceVoidMutation, InvoiceVoidMutationVariables>(InvoiceVoidDocument, options);
      }
export type InvoiceVoidMutationHookResult = ReturnType<typeof useInvoiceVoidMutation>;
export type InvoiceVoidMutationResult = Apollo.MutationResult<InvoiceVoidMutation>;
export type InvoiceVoidMutationOptions = Apollo.BaseMutationOptions<InvoiceVoidMutation, InvoiceVoidMutationVariables>;
export const NoteUpsertDocument = gql`
    mutation NoteUpsert($noteId: MongoID, $note: String!, $processorScheduling: MongoID, $type: EnumNoteType, $attachment: Upload) {
  noteUpsert(
    noteId: $noteId
    note: $note
    processorScheduling: $processorScheduling
    type: $type
    attachment: $attachment
  ) {
    _id
  }
}
    `;
export type NoteUpsertMutationFn = Apollo.MutationFunction<NoteUpsertMutation, NoteUpsertMutationVariables>;

/**
 * __useNoteUpsertMutation__
 *
 * To run a mutation, you first call `useNoteUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoteUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noteUpsertMutation, { data, loading, error }] = useNoteUpsertMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      note: // value for 'note'
 *      processorScheduling: // value for 'processorScheduling'
 *      type: // value for 'type'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useNoteUpsertMutation(baseOptions?: Apollo.MutationHookOptions<NoteUpsertMutation, NoteUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoteUpsertMutation, NoteUpsertMutationVariables>(NoteUpsertDocument, options);
      }
export type NoteUpsertMutationHookResult = ReturnType<typeof useNoteUpsertMutation>;
export type NoteUpsertMutationResult = Apollo.MutationResult<NoteUpsertMutation>;
export type NoteUpsertMutationOptions = Apollo.BaseMutationOptions<NoteUpsertMutation, NoteUpsertMutationVariables>;
export const NotificationSettingsUpdateDocument = gql`
    mutation NotificationSettingsUpdate($notificationSettingId: MongoID!, $settings: NotificationSettingsInput!) {
  notificationSettingsUpdate(
    notificationSettingId: $notificationSettingId
    settings: $settings
  ) {
    ...NotificationSettingFragment
  }
}
    ${NotificationSettingFragmentFragmentDoc}`;
export type NotificationSettingsUpdateMutationFn = Apollo.MutationFunction<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>;

/**
 * __useNotificationSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useNotificationSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationSettingsUpdateMutation, { data, loading, error }] = useNotificationSettingsUpdateMutation({
 *   variables: {
 *      notificationSettingId: // value for 'notificationSettingId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useNotificationSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>(NotificationSettingsUpdateDocument, options);
      }
export type NotificationSettingsUpdateMutationHookResult = ReturnType<typeof useNotificationSettingsUpdateMutation>;
export type NotificationSettingsUpdateMutationResult = Apollo.MutationResult<NotificationSettingsUpdateMutation>;
export type NotificationSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<NotificationSettingsUpdateMutation, NotificationSettingsUpdateMutationVariables>;
export const PrimalCreateOneDocument = gql`
    mutation PrimalCreateOne($record: CreateOnePrimalInput!) {
  primalCreateOne(record: $record) {
    recordId
  }
}
    `;
export type PrimalCreateOneMutationFn = Apollo.MutationFunction<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>;

/**
 * __usePrimalCreateOneMutation__
 *
 * To run a mutation, you first call `usePrimalCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCreateOneMutation, { data, loading, error }] = usePrimalCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>(PrimalCreateOneDocument, options);
      }
export type PrimalCreateOneMutationHookResult = ReturnType<typeof usePrimalCreateOneMutation>;
export type PrimalCreateOneMutationResult = Apollo.MutationResult<PrimalCreateOneMutation>;
export type PrimalCreateOneMutationOptions = Apollo.BaseMutationOptions<PrimalCreateOneMutation, PrimalCreateOneMutationVariables>;
export const PrimalCutBlockerUpsertDocument = gql`
    mutation PrimalCutBlockerUpsert($animalSpecies: String!, $inspectionLevel: String!, $name: String!, $primalCutId: MongoID!, $blockedBy: [BlockedByInput!]!) {
  primalCutBlockerUpsert(
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    name: $name
    primalCutId: $primalCutId
    blockedBy: $blockedBy
  ) {
    ...PrimalCutBlockerFragment
  }
}
    ${PrimalCutBlockerFragmentFragmentDoc}`;
export type PrimalCutBlockerUpsertMutationFn = Apollo.MutationFunction<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>;

/**
 * __usePrimalCutBlockerUpsertMutation__
 *
 * To run a mutation, you first call `usePrimalCutBlockerUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutBlockerUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutBlockerUpsertMutation, { data, loading, error }] = usePrimalCutBlockerUpsertMutation({
 *   variables: {
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      name: // value for 'name'
 *      primalCutId: // value for 'primalCutId'
 *      blockedBy: // value for 'blockedBy'
 *   },
 * });
 */
export function usePrimalCutBlockerUpsertMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>(PrimalCutBlockerUpsertDocument, options);
      }
export type PrimalCutBlockerUpsertMutationHookResult = ReturnType<typeof usePrimalCutBlockerUpsertMutation>;
export type PrimalCutBlockerUpsertMutationResult = Apollo.MutationResult<PrimalCutBlockerUpsertMutation>;
export type PrimalCutBlockerUpsertMutationOptions = Apollo.BaseMutationOptions<PrimalCutBlockerUpsertMutation, PrimalCutBlockerUpsertMutationVariables>;
export const PrimalCutCreateOneDocument = gql`
    mutation PrimalCutCreateOne($record: CreateOnePrimalCutInput!) {
  primalCutCreateOne(record: $record) {
    recordId
    record {
      ...PrimalCutFragment
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}`;
export type PrimalCutCreateOneMutationFn = Apollo.MutationFunction<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>;

/**
 * __usePrimalCutCreateOneMutation__
 *
 * To run a mutation, you first call `usePrimalCutCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutCreateOneMutation, { data, loading, error }] = usePrimalCutCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCutCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>(PrimalCutCreateOneDocument, options);
      }
export type PrimalCutCreateOneMutationHookResult = ReturnType<typeof usePrimalCutCreateOneMutation>;
export type PrimalCutCreateOneMutationResult = Apollo.MutationResult<PrimalCutCreateOneMutation>;
export type PrimalCutCreateOneMutationOptions = Apollo.BaseMutationOptions<PrimalCutCreateOneMutation, PrimalCutCreateOneMutationVariables>;
export const PrimalCutSoftDeleteDocument = gql`
    mutation PrimalCutSoftDelete($primalCutId: MongoID!) {
  primalCutSoftDelete(primalCutId: $primalCutId) {
    _id
    primal {
      _id
      group {
        _id
      }
    }
  }
}
    `;
export type PrimalCutSoftDeleteMutationFn = Apollo.MutationFunction<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>;

/**
 * __usePrimalCutSoftDeleteMutation__
 *
 * To run a mutation, you first call `usePrimalCutSoftDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutSoftDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutSoftDeleteMutation, { data, loading, error }] = usePrimalCutSoftDeleteMutation({
 *   variables: {
 *      primalCutId: // value for 'primalCutId'
 *   },
 * });
 */
export function usePrimalCutSoftDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>(PrimalCutSoftDeleteDocument, options);
      }
export type PrimalCutSoftDeleteMutationHookResult = ReturnType<typeof usePrimalCutSoftDeleteMutation>;
export type PrimalCutSoftDeleteMutationResult = Apollo.MutationResult<PrimalCutSoftDeleteMutation>;
export type PrimalCutSoftDeleteMutationOptions = Apollo.BaseMutationOptions<PrimalCutSoftDeleteMutation, PrimalCutSoftDeleteMutationVariables>;
export const PrimalCutTypeCreateOneDocument = gql`
    mutation PrimalCutTypeCreateOne($record: CreateOnePrimalCutTypeInput!) {
  primalCutTypeCreateOne(record: $record) {
    recordId
  }
}
    `;
export type PrimalCutTypeCreateOneMutationFn = Apollo.MutationFunction<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>;

/**
 * __usePrimalCutTypeCreateOneMutation__
 *
 * To run a mutation, you first call `usePrimalCutTypeCreateOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutTypeCreateOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutTypeCreateOneMutation, { data, loading, error }] = usePrimalCutTypeCreateOneMutation({
 *   variables: {
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCutTypeCreateOneMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>(PrimalCutTypeCreateOneDocument, options);
      }
export type PrimalCutTypeCreateOneMutationHookResult = ReturnType<typeof usePrimalCutTypeCreateOneMutation>;
export type PrimalCutTypeCreateOneMutationResult = Apollo.MutationResult<PrimalCutTypeCreateOneMutation>;
export type PrimalCutTypeCreateOneMutationOptions = Apollo.BaseMutationOptions<PrimalCutTypeCreateOneMutation, PrimalCutTypeCreateOneMutationVariables>;
export const PrimalCutUpdateByIdDocument = gql`
    mutation PrimalCutUpdateById($_id: MongoID!, $record: UpdateByIdPrimalCutInput!) {
  primalCutUpdateById(_id: $_id, record: $record) {
    recordId
    record {
      ...PrimalCutFragment
    }
  }
}
    ${PrimalCutFragmentFragmentDoc}`;
export type PrimalCutUpdateByIdMutationFn = Apollo.MutationFunction<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>;

/**
 * __usePrimalCutUpdateByIdMutation__
 *
 * To run a mutation, you first call `usePrimalCutUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalCutUpdateByIdMutation, { data, loading, error }] = usePrimalCutUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalCutUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>(PrimalCutUpdateByIdDocument, options);
      }
export type PrimalCutUpdateByIdMutationHookResult = ReturnType<typeof usePrimalCutUpdateByIdMutation>;
export type PrimalCutUpdateByIdMutationResult = Apollo.MutationResult<PrimalCutUpdateByIdMutation>;
export type PrimalCutUpdateByIdMutationOptions = Apollo.BaseMutationOptions<PrimalCutUpdateByIdMutation, PrimalCutUpdateByIdMutationVariables>;
export const PrimalGroupSoftDeleteByIdDocument = gql`
    mutation PrimalGroupSoftDeleteById($id: MongoID!) {
  primalGroupUpdateById(_id: $id, record: {isDeleted: true}) {
    record {
      _id
      isDeleted
      deletedAt
    }
  }
}
    `;
export type PrimalGroupSoftDeleteByIdMutationFn = Apollo.MutationFunction<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>;

/**
 * __usePrimalGroupSoftDeleteByIdMutation__
 *
 * To run a mutation, you first call `usePrimalGroupSoftDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalGroupSoftDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalGroupSoftDeleteByIdMutation, { data, loading, error }] = usePrimalGroupSoftDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrimalGroupSoftDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>(PrimalGroupSoftDeleteByIdDocument, options);
      }
export type PrimalGroupSoftDeleteByIdMutationHookResult = ReturnType<typeof usePrimalGroupSoftDeleteByIdMutation>;
export type PrimalGroupSoftDeleteByIdMutationResult = Apollo.MutationResult<PrimalGroupSoftDeleteByIdMutation>;
export type PrimalGroupSoftDeleteByIdMutationOptions = Apollo.BaseMutationOptions<PrimalGroupSoftDeleteByIdMutation, PrimalGroupSoftDeleteByIdMutationVariables>;
export const PrimalSoftDeleteByIdDocument = gql`
    mutation PrimalSoftDeleteById($id: MongoID!) {
  primalUpdateById(_id: $id, record: {isDeleted: true}) {
    record {
      _id
      isDeleted
      deletedAt
    }
  }
}
    `;
export type PrimalSoftDeleteByIdMutationFn = Apollo.MutationFunction<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>;

/**
 * __usePrimalSoftDeleteByIdMutation__
 *
 * To run a mutation, you first call `usePrimalSoftDeleteByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalSoftDeleteByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalSoftDeleteByIdMutation, { data, loading, error }] = usePrimalSoftDeleteByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePrimalSoftDeleteByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>(PrimalSoftDeleteByIdDocument, options);
      }
export type PrimalSoftDeleteByIdMutationHookResult = ReturnType<typeof usePrimalSoftDeleteByIdMutation>;
export type PrimalSoftDeleteByIdMutationResult = Apollo.MutationResult<PrimalSoftDeleteByIdMutation>;
export type PrimalSoftDeleteByIdMutationOptions = Apollo.BaseMutationOptions<PrimalSoftDeleteByIdMutation, PrimalSoftDeleteByIdMutationVariables>;
export const PrimalUpdateByIdDocument = gql`
    mutation PrimalUpdateById($_id: MongoID!, $record: UpdateByIdPrimalInput!) {
  primalUpdateById(_id: $_id, record: $record) {
    recordId
  }
}
    `;
export type PrimalUpdateByIdMutationFn = Apollo.MutationFunction<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>;

/**
 * __usePrimalUpdateByIdMutation__
 *
 * To run a mutation, you first call `usePrimalUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrimalUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [primalUpdateByIdMutation, { data, loading, error }] = usePrimalUpdateByIdMutation({
 *   variables: {
 *      _id: // value for '_id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function usePrimalUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>(PrimalUpdateByIdDocument, options);
      }
export type PrimalUpdateByIdMutationHookResult = ReturnType<typeof usePrimalUpdateByIdMutation>;
export type PrimalUpdateByIdMutationResult = Apollo.MutationResult<PrimalUpdateByIdMutation>;
export type PrimalUpdateByIdMutationOptions = Apollo.BaseMutationOptions<PrimalUpdateByIdMutation, PrimalUpdateByIdMutationVariables>;
export const ProcessorCapabilityUpsertDocument = gql`
    mutation ProcessorCapabilityUpsert($animalSpecies: EnumProcessorCapabilityAnimalSpecies!, $inspectionLevel: EnumProcessorCapabilityInspectionLevel!, $primalCuts: [MongoID!]!, $canSelectMoreThanOneTrim: Boolean!, $trimSelection: EnumProcessorCapabilityTrimSelection!, $extras: [ProcessorCapabilityExtrasModelInput!], $trim: [ProcessorCapabilityTrimModelInput!], $specifications: [ProcessorCapabilitySpecificationSpecificationsInput!], $primalGroups: [JSON], $newCutBlockers: JSON, $wizardWelcomeTitle: String, $wizardWelcomeContent: String, $extrasDescription: String, $trimDescription: String) {
  processorCapabilityUpsert(
    animalSpecies: $animalSpecies
    inspectionLevel: $inspectionLevel
    primalCuts: $primalCuts
    extras: $extras
    trim: $trim
    canSelectMoreThanOneTrim: $canSelectMoreThanOneTrim
    trimSelection: $trimSelection
    specifications: $specifications
    primalGroups: $primalGroups
    newCutBlockers: $newCutBlockers
    wizardWelcomeTitle: $wizardWelcomeTitle
    wizardWelcomeContent: $wizardWelcomeContent
    extrasDescription: $extrasDescription
    trimDescription: $trimDescription
  ) {
    ...ProcessorCapabilityFragment
  }
}
    ${ProcessorCapabilityFragmentFragmentDoc}`;
export type ProcessorCapabilityUpsertMutationFn = Apollo.MutationFunction<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>;

/**
 * __useProcessorCapabilityUpsertMutation__
 *
 * To run a mutation, you first call `useProcessorCapabilityUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorCapabilityUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorCapabilityUpsertMutation, { data, loading, error }] = useProcessorCapabilityUpsertMutation({
 *   variables: {
 *      animalSpecies: // value for 'animalSpecies'
 *      inspectionLevel: // value for 'inspectionLevel'
 *      primalCuts: // value for 'primalCuts'
 *      canSelectMoreThanOneTrim: // value for 'canSelectMoreThanOneTrim'
 *      trimSelection: // value for 'trimSelection'
 *      extras: // value for 'extras'
 *      trim: // value for 'trim'
 *      specifications: // value for 'specifications'
 *      primalGroups: // value for 'primalGroups'
 *      newCutBlockers: // value for 'newCutBlockers'
 *      wizardWelcomeTitle: // value for 'wizardWelcomeTitle'
 *      wizardWelcomeContent: // value for 'wizardWelcomeContent'
 *      extrasDescription: // value for 'extrasDescription'
 *      trimDescription: // value for 'trimDescription'
 *   },
 * });
 */
export function useProcessorCapabilityUpsertMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>(ProcessorCapabilityUpsertDocument, options);
      }
export type ProcessorCapabilityUpsertMutationHookResult = ReturnType<typeof useProcessorCapabilityUpsertMutation>;
export type ProcessorCapabilityUpsertMutationResult = Apollo.MutationResult<ProcessorCapabilityUpsertMutation>;
export type ProcessorCapabilityUpsertMutationOptions = Apollo.BaseMutationOptions<ProcessorCapabilityUpsertMutation, ProcessorCapabilityUpsertMutationVariables>;
export const ProcessorExportCsvDocument = gql`
    mutation ProcessorExportCsv($vendorId: MongoID!, $type: ProcessorExportTypeEnum!, $startDate: String!, $endDate: String!) {
  processorExportCsv(
    vendorId: $vendorId
    type: $type
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorExportCsvMutationFn = Apollo.MutationFunction<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>;

/**
 * __useProcessorExportCsvMutation__
 *
 * To run a mutation, you first call `useProcessorExportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorExportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorExportCsvMutation, { data, loading, error }] = useProcessorExportCsvMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      type: // value for 'type'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorExportCsvMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>(ProcessorExportCsvDocument, options);
      }
export type ProcessorExportCsvMutationHookResult = ReturnType<typeof useProcessorExportCsvMutation>;
export type ProcessorExportCsvMutationResult = Apollo.MutationResult<ProcessorExportCsvMutation>;
export type ProcessorExportCsvMutationOptions = Apollo.BaseMutationOptions<ProcessorExportCsvMutation, ProcessorExportCsvMutationVariables>;
export const ProcessorExportCsvByVendorIdDocument = gql`
    mutation ProcessorExportCsvByVendorId($vendorId: MongoID!, $startDate: String!, $endDate: String!) {
  processorExportCsvByVendorId(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorExportCsvByVendorIdMutationFn = Apollo.MutationFunction<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>;

/**
 * __useProcessorExportCsvByVendorIdMutation__
 *
 * To run a mutation, you first call `useProcessorExportCsvByVendorIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorExportCsvByVendorIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorExportCsvByVendorIdMutation, { data, loading, error }] = useProcessorExportCsvByVendorIdMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorExportCsvByVendorIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>(ProcessorExportCsvByVendorIdDocument, options);
      }
export type ProcessorExportCsvByVendorIdMutationHookResult = ReturnType<typeof useProcessorExportCsvByVendorIdMutation>;
export type ProcessorExportCsvByVendorIdMutationResult = Apollo.MutationResult<ProcessorExportCsvByVendorIdMutation>;
export type ProcessorExportCsvByVendorIdMutationOptions = Apollo.BaseMutationOptions<ProcessorExportCsvByVendorIdMutation, ProcessorExportCsvByVendorIdMutationVariables>;
export const ProcessorSchedulingAnimalHeadBulkUpdateDocument = gql`
    mutation ProcessorSchedulingAnimalHeadBulkUpdate($processorSchedulingId: MongoID!, $updatedAnimalHeads: [AnimalHeadUpdatesInput]) {
  processorSchedulingAnimalHeadBulkUpdate(
    processorSchedulingId: $processorSchedulingId
    updatedAnimalHeads: $updatedAnimalHeads
  ) {
    recordId
    record {
      _id
    }
    warnings {
      message
    }
  }
}
    `;
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>;

/**
 * __useProcessorSchedulingAnimalHeadBulkUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingAnimalHeadBulkUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingAnimalHeadBulkUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingAnimalHeadBulkUpdateMutation, { data, loading, error }] = useProcessorSchedulingAnimalHeadBulkUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      updatedAnimalHeads: // value for 'updatedAnimalHeads'
 *   },
 * });
 */
export function useProcessorSchedulingAnimalHeadBulkUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>(ProcessorSchedulingAnimalHeadBulkUpdateDocument, options);
      }
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingAnimalHeadBulkUpdateMutation>;
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingAnimalHeadBulkUpdateMutation>;
export type ProcessorSchedulingAnimalHeadBulkUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingAnimalHeadBulkUpdateMutation, ProcessorSchedulingAnimalHeadBulkUpdateMutationVariables>;
export const ProcessorSchedulingAnimalHeadDeleteDocument = gql`
    mutation ProcessorSchedulingAnimalHeadDelete($processorSchedulingId: MongoID!, $animalHeadId: MongoID!) {
  processorSchedulingAnimalHeadDelete(
    processorSchedulingId: $processorSchedulingId
    animalHeadId: $animalHeadId
  ) {
    _id
  }
}
    `;
export type ProcessorSchedulingAnimalHeadDeleteMutationFn = Apollo.MutationFunction<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>;

/**
 * __useProcessorSchedulingAnimalHeadDeleteMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingAnimalHeadDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingAnimalHeadDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingAnimalHeadDeleteMutation, { data, loading, error }] = useProcessorSchedulingAnimalHeadDeleteMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      animalHeadId: // value for 'animalHeadId'
 *   },
 * });
 */
export function useProcessorSchedulingAnimalHeadDeleteMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>(ProcessorSchedulingAnimalHeadDeleteDocument, options);
      }
export type ProcessorSchedulingAnimalHeadDeleteMutationHookResult = ReturnType<typeof useProcessorSchedulingAnimalHeadDeleteMutation>;
export type ProcessorSchedulingAnimalHeadDeleteMutationResult = Apollo.MutationResult<ProcessorSchedulingAnimalHeadDeleteMutation>;
export type ProcessorSchedulingAnimalHeadDeleteMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingAnimalHeadDeleteMutation, ProcessorSchedulingAnimalHeadDeleteMutationVariables>;
export const ProcessorSchedulingAnimalHeadPartialUpdateByIdDocument = gql`
    mutation ProcessorSchedulingAnimalHeadPartialUpdateById($processorSchedulingId: MongoID!, $animalHeadId: MongoID!, $record: ProcessorSchedulingPartialUpdateAnimalHeadInput!) {
  processorSchedulingAnimalHeadPartialUpdateById(
    processorSchedulingId: $processorSchedulingId
    animalHeadId: $animalHeadId
    record: $record
  ) {
    recordId
    record {
      _id
    }
    warnings {
      message
    }
  }
}
    `;
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingAnimalHeadPartialUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      animalHeadId: // value for 'animalHeadId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>(ProcessorSchedulingAnimalHeadPartialUpdateByIdDocument, options);
      }
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingAnimalHeadPartialUpdateByIdMutation>;
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation>;
export type ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingAnimalHeadPartialUpdateByIdMutation, ProcessorSchedulingAnimalHeadPartialUpdateByIdMutationVariables>;
export const ProcessorSchedulingCutsheetReminderDocument = gql`
    mutation processorSchedulingCutsheetReminder($schedulingId: MongoID!) {
  processorSchedulingCutsheetReminder(schedulingId: $schedulingId) {
    ...ProcessorSchedulingFragment
  }
}
    ${ProcessorSchedulingFragmentFragmentDoc}`;
export type ProcessorSchedulingCutsheetReminderMutationFn = Apollo.MutationFunction<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>;

/**
 * __useProcessorSchedulingCutsheetReminderMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingCutsheetReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCutsheetReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingCutsheetReminderMutation, { data, loading, error }] = useProcessorSchedulingCutsheetReminderMutation({
 *   variables: {
 *      schedulingId: // value for 'schedulingId'
 *   },
 * });
 */
export function useProcessorSchedulingCutsheetReminderMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>(ProcessorSchedulingCutsheetReminderDocument, options);
      }
export type ProcessorSchedulingCutsheetReminderMutationHookResult = ReturnType<typeof useProcessorSchedulingCutsheetReminderMutation>;
export type ProcessorSchedulingCutsheetReminderMutationResult = Apollo.MutationResult<ProcessorSchedulingCutsheetReminderMutation>;
export type ProcessorSchedulingCutsheetReminderMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingCutsheetReminderMutation, ProcessorSchedulingCutsheetReminderMutationVariables>;
export const ProcessorSchedulingDragAndDropUpdateDocument = gql`
    mutation processorSchedulingDragAndDropUpdate($processorSchedulingId: MongoID!, $eventType: String!, $eventDate: String!) {
  processorSchedulingDragAndDropUpdate(
    processorSchedulingId: $processorSchedulingId
    eventType: $eventType
    eventDate: $eventDate
  ) {
    _id
  }
}
    `;
export type ProcessorSchedulingDragAndDropUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>;

/**
 * __useProcessorSchedulingDragAndDropUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingDragAndDropUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingDragAndDropUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingDragAndDropUpdateMutation, { data, loading, error }] = useProcessorSchedulingDragAndDropUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      eventType: // value for 'eventType'
 *      eventDate: // value for 'eventDate'
 *   },
 * });
 */
export function useProcessorSchedulingDragAndDropUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>(ProcessorSchedulingDragAndDropUpdateDocument, options);
      }
export type ProcessorSchedulingDragAndDropUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingDragAndDropUpdateMutation>;
export type ProcessorSchedulingDragAndDropUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingDragAndDropUpdateMutation>;
export type ProcessorSchedulingDragAndDropUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingDragAndDropUpdateMutation, ProcessorSchedulingDragAndDropUpdateMutationVariables>;
export const ProcessorSchedulingGenerateBillingStatementDocument = gql`
    mutation ProcessorSchedulingGenerateBillingStatement($processorSchedulingId: MongoID!) {
  processorSchedulingGenerateBillingStatement(
    processorSchedulingId: $processorSchedulingId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateBillingStatementMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>;

/**
 * __useProcessorSchedulingGenerateBillingStatementMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateBillingStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateBillingStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateBillingStatementMutation, { data, loading, error }] = useProcessorSchedulingGenerateBillingStatementMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateBillingStatementMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>(ProcessorSchedulingGenerateBillingStatementDocument, options);
      }
export type ProcessorSchedulingGenerateBillingStatementMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateBillingStatementMutation>;
export type ProcessorSchedulingGenerateBillingStatementMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateBillingStatementMutation>;
export type ProcessorSchedulingGenerateBillingStatementMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateBillingStatementMutation, ProcessorSchedulingGenerateBillingStatementMutationVariables>;
export const ProcessorSchedulingGenerateCarcassTagsDocument = gql`
    mutation ProcessorSchedulingGenerateCarcassTags($processorSchedulingId: MongoID!, $animalHeadIds: [MongoID]) {
  processorSchedulingGenerateCarcassTags(
    processorSchedulingId: $processorSchedulingId
    animalHeadIds: $animalHeadIds
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateCarcassTagsMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>;

/**
 * __useProcessorSchedulingGenerateCarcassTagsMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateCarcassTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateCarcassTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateCarcassTagsMutation, { data, loading, error }] = useProcessorSchedulingGenerateCarcassTagsMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      animalHeadIds: // value for 'animalHeadIds'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateCarcassTagsMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>(ProcessorSchedulingGenerateCarcassTagsDocument, options);
      }
export type ProcessorSchedulingGenerateCarcassTagsMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateCarcassTagsMutation>;
export type ProcessorSchedulingGenerateCarcassTagsMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateCarcassTagsMutation>;
export type ProcessorSchedulingGenerateCarcassTagsMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateCarcassTagsMutation, ProcessorSchedulingGenerateCarcassTagsMutationVariables>;
export const ProcessorSchedulingGenerateCsvByVendorIdDocument = gql`
    mutation ProcessorSchedulingGenerateCsvByVendorId($vendorId: MongoID, $startDate: String!, $endDate: String!) {
  processorSchedulingGenerateCsvByVendorId(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorSchedulingGenerateCsvByVendorIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>;

/**
 * __useProcessorSchedulingGenerateCsvByVendorIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateCsvByVendorIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateCsvByVendorIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateCsvByVendorIdMutation, { data, loading, error }] = useProcessorSchedulingGenerateCsvByVendorIdMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateCsvByVendorIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>(ProcessorSchedulingGenerateCsvByVendorIdDocument, options);
      }
export type ProcessorSchedulingGenerateCsvByVendorIdMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateCsvByVendorIdMutation>;
export type ProcessorSchedulingGenerateCsvByVendorIdMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateCsvByVendorIdMutation>;
export type ProcessorSchedulingGenerateCsvByVendorIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateCsvByVendorIdMutation, ProcessorSchedulingGenerateCsvByVendorIdMutationVariables>;
export const ProcessorSchedulingGenerateCutsheetRequestDocument = gql`
    mutation ProcessorSchedulingGenerateCutsheetRequest($processorSchedulingId: MongoID!, $cutsheetRequestId: MongoID!) {
  processorSchedulingGenerateCutsheetRequest(
    processorSchedulingId: $processorSchedulingId
    cutsheetRequestId: $cutsheetRequestId
  ) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateCutsheetRequestMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>;

/**
 * __useProcessorSchedulingGenerateCutsheetRequestMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateCutsheetRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateCutsheetRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateCutsheetRequestMutation, { data, loading, error }] = useProcessorSchedulingGenerateCutsheetRequestMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      cutsheetRequestId: // value for 'cutsheetRequestId'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateCutsheetRequestMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>(ProcessorSchedulingGenerateCutsheetRequestDocument, options);
      }
export type ProcessorSchedulingGenerateCutsheetRequestMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateCutsheetRequestMutation>;
export type ProcessorSchedulingGenerateCutsheetRequestMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateCutsheetRequestMutation>;
export type ProcessorSchedulingGenerateCutsheetRequestMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateCutsheetRequestMutation, ProcessorSchedulingGenerateCutsheetRequestMutationVariables>;
export const ProcessorSchedulingGenerateHangingWeightCsvDocument = gql`
    mutation ProcessorSchedulingGenerateHangingWeightCsv($vendorId: MongoID, $startDate: String!, $endDate: String!) {
  processorSchedulingGenerateHangingWeightCsv(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
  ) {
    file
    filename
    errors
  }
}
    `;
export type ProcessorSchedulingGenerateHangingWeightCsvMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>;

/**
 * __useProcessorSchedulingGenerateHangingWeightCsvMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateHangingWeightCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateHangingWeightCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateHangingWeightCsvMutation, { data, loading, error }] = useProcessorSchedulingGenerateHangingWeightCsvMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateHangingWeightCsvMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>(ProcessorSchedulingGenerateHangingWeightCsvDocument, options);
      }
export type ProcessorSchedulingGenerateHangingWeightCsvMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateHangingWeightCsvMutation>;
export type ProcessorSchedulingGenerateHangingWeightCsvMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateHangingWeightCsvMutation>;
export type ProcessorSchedulingGenerateHangingWeightCsvMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateHangingWeightCsvMutation, ProcessorSchedulingGenerateHangingWeightCsvMutationVariables>;
export const ProcessorSchedulingGenerateKillSheetDocument = gql`
    mutation ProcessorSchedulingGenerateKillSheet($date: Date!, $vendorId: MongoID!) {
  processorSchedulingGenerateKillSheet(date: $date, vendorId: $vendorId) {
    file
    filename
    errors
    fileUrl
  }
}
    `;
export type ProcessorSchedulingGenerateKillSheetMutationFn = Apollo.MutationFunction<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>;

/**
 * __useProcessorSchedulingGenerateKillSheetMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingGenerateKillSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingGenerateKillSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingGenerateKillSheetMutation, { data, loading, error }] = useProcessorSchedulingGenerateKillSheetMutation({
 *   variables: {
 *      date: // value for 'date'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProcessorSchedulingGenerateKillSheetMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>(ProcessorSchedulingGenerateKillSheetDocument, options);
      }
export type ProcessorSchedulingGenerateKillSheetMutationHookResult = ReturnType<typeof useProcessorSchedulingGenerateKillSheetMutation>;
export type ProcessorSchedulingGenerateKillSheetMutationResult = Apollo.MutationResult<ProcessorSchedulingGenerateKillSheetMutation>;
export type ProcessorSchedulingGenerateKillSheetMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingGenerateKillSheetMutation, ProcessorSchedulingGenerateKillSheetMutationVariables>;
export const ProcessorSchedulingNotificationSendDocument = gql`
    mutation ProcessorSchedulingNotificationSend($type: NotificationTypeInput, $notificationRequest: NotificationRequestInput) {
  processorSchedulingNotificationSend(type: $type, request: $notificationRequest) {
    _id
  }
}
    `;
export type ProcessorSchedulingNotificationSendMutationFn = Apollo.MutationFunction<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>;

/**
 * __useProcessorSchedulingNotificationSendMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingNotificationSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingNotificationSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingNotificationSendMutation, { data, loading, error }] = useProcessorSchedulingNotificationSendMutation({
 *   variables: {
 *      type: // value for 'type'
 *      notificationRequest: // value for 'notificationRequest'
 *   },
 * });
 */
export function useProcessorSchedulingNotificationSendMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>(ProcessorSchedulingNotificationSendDocument, options);
      }
export type ProcessorSchedulingNotificationSendMutationHookResult = ReturnType<typeof useProcessorSchedulingNotificationSendMutation>;
export type ProcessorSchedulingNotificationSendMutationResult = Apollo.MutationResult<ProcessorSchedulingNotificationSendMutation>;
export type ProcessorSchedulingNotificationSendMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingNotificationSendMutation, ProcessorSchedulingNotificationSendMutationVariables>;
export const ProcessorSchedulingPartialUpdateByIdDocument = gql`
    mutation ProcessorSchedulingPartialUpdateById($processorSchedulingId: MongoID!, $record: ProcessorSchedulingPartialUpdateInput!) {
  processorSchedulingPartialUpdateById(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
    record {
      _id
    }
    warnings {
      message
    }
  }
}
    `;
export type ProcessorSchedulingPartialUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingPartialUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingPartialUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingPartialUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingPartialUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingPartialUpdateByIdMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingPartialUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>(ProcessorSchedulingPartialUpdateByIdDocument, options);
      }
export type ProcessorSchedulingPartialUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingPartialUpdateByIdMutation>;
export type ProcessorSchedulingPartialUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingPartialUpdateByIdMutation>;
export type ProcessorSchedulingPartialUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingPartialUpdateByIdMutation, ProcessorSchedulingPartialUpdateByIdMutationVariables>;
export const ProcessorSchedulingCutsheetInformationPartialUpdateDocument = gql`
    mutation ProcessorSchedulingCutsheetInformationPartialUpdate($processorSchedulingId: MongoID!, $record: [CutsheetPartialUpdateInput]!) {
  processorSchedulingUpdateCutsheets(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
    record {
      _id
    }
  }
}
    `;
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationFn = Apollo.MutationFunction<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>;

/**
 * __useProcessorSchedulingCutsheetInformationPartialUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingCutsheetInformationPartialUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCutsheetInformationPartialUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingCutsheetInformationPartialUpdateMutation, { data, loading, error }] = useProcessorSchedulingCutsheetInformationPartialUpdateMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingCutsheetInformationPartialUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>(ProcessorSchedulingCutsheetInformationPartialUpdateDocument, options);
      }
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationHookResult = ReturnType<typeof useProcessorSchedulingCutsheetInformationPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationResult = Apollo.MutationResult<ProcessorSchedulingCutsheetInformationPartialUpdateMutation>;
export type ProcessorSchedulingCutsheetInformationPartialUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingCutsheetInformationPartialUpdateMutation, ProcessorSchedulingCutsheetInformationPartialUpdateMutationVariables>;
export const ProcessorSchedulingSplitTypeUpdateByIdDocument = gql`
    mutation ProcessorSchedulingSplitTypeUpdateById($processorSchedulingId: MongoID!, $record: ProcessorSchedulingSplitTypeUpdateInput!) {
  processorSchedulingSplitTypeUpdateById(
    processorSchedulingId: $processorSchedulingId
    record: $record
  ) {
    recordId
  }
}
    `;
export type ProcessorSchedulingSplitTypeUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingSplitTypeUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingSplitTypeUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingSplitTypeUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingSplitTypeUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingSplitTypeUpdateByIdMutation({
 *   variables: {
 *      processorSchedulingId: // value for 'processorSchedulingId'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingSplitTypeUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>(ProcessorSchedulingSplitTypeUpdateByIdDocument, options);
      }
export type ProcessorSchedulingSplitTypeUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingSplitTypeUpdateByIdMutation>;
export type ProcessorSchedulingSplitTypeUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingSplitTypeUpdateByIdMutation>;
export type ProcessorSchedulingSplitTypeUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingSplitTypeUpdateByIdMutation, ProcessorSchedulingSplitTypeUpdateByIdMutationVariables>;
export const ProcessorSchedulingUpdateByIdDocument = gql`
    mutation ProcessorSchedulingUpdateById($id: MongoID!, $record: UpdateByIdProcessorSchedulingInput!) {
  processorSchedulingUpdate(_id: $id, record: $record) {
    recordId
    record {
      status
    }
  }
}
    `;
export type ProcessorSchedulingUpdateByIdMutationFn = Apollo.MutationFunction<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>;

/**
 * __useProcessorSchedulingUpdateByIdMutation__
 *
 * To run a mutation, you first call `useProcessorSchedulingUpdateByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingUpdateByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSchedulingUpdateByIdMutation, { data, loading, error }] = useProcessorSchedulingUpdateByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      record: // value for 'record'
 *   },
 * });
 */
export function useProcessorSchedulingUpdateByIdMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>(ProcessorSchedulingUpdateByIdDocument, options);
      }
export type ProcessorSchedulingUpdateByIdMutationHookResult = ReturnType<typeof useProcessorSchedulingUpdateByIdMutation>;
export type ProcessorSchedulingUpdateByIdMutationResult = Apollo.MutationResult<ProcessorSchedulingUpdateByIdMutation>;
export type ProcessorSchedulingUpdateByIdMutationOptions = Apollo.BaseMutationOptions<ProcessorSchedulingUpdateByIdMutation, ProcessorSchedulingUpdateByIdMutationVariables>;
export const ProcessorSettingsCreateDocument = gql`
    mutation ProcessorSettingsCreate($newProcessorSettings: CreateProcessorSettingsWithCustomCapacityInput!) {
  processorSettingsCreate(newProcessor: $newProcessorSettings) {
    processorSettings {
      ...ProcessorSettingsFragment
    }
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}`;
export type ProcessorSettingsCreateMutationFn = Apollo.MutationFunction<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>;

/**
 * __useProcessorSettingsCreateMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsCreateMutation, { data, loading, error }] = useProcessorSettingsCreateMutation({
 *   variables: {
 *      newProcessorSettings: // value for 'newProcessorSettings'
 *   },
 * });
 */
export function useProcessorSettingsCreateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>(ProcessorSettingsCreateDocument, options);
      }
export type ProcessorSettingsCreateMutationHookResult = ReturnType<typeof useProcessorSettingsCreateMutation>;
export type ProcessorSettingsCreateMutationResult = Apollo.MutationResult<ProcessorSettingsCreateMutation>;
export type ProcessorSettingsCreateMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsCreateMutation, ProcessorSettingsCreateMutationVariables>;
export const ProcessorSettingsUpdateDocument = gql`
    mutation ProcessorSettingsUpdate($updateProcessorSettings: UpdateProcessorSettingsWithCustomCapacityInput!) {
  processorSettingsUpdate(updateProcessor: $updateProcessorSettings) {
    processorSettings {
      ...ProcessorSettingsFragment
    }
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}`;
export type ProcessorSettingsUpdateMutationFn = Apollo.MutationFunction<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>;

/**
 * __useProcessorSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useProcessorSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessorSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processorSettingsUpdateMutation, { data, loading, error }] = useProcessorSettingsUpdateMutation({
 *   variables: {
 *      updateProcessorSettings: // value for 'updateProcessorSettings'
 *   },
 * });
 */
export function useProcessorSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>(ProcessorSettingsUpdateDocument, options);
      }
export type ProcessorSettingsUpdateMutationHookResult = ReturnType<typeof useProcessorSettingsUpdateMutation>;
export type ProcessorSettingsUpdateMutationResult = Apollo.MutationResult<ProcessorSettingsUpdateMutation>;
export type ProcessorSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<ProcessorSettingsUpdateMutation, ProcessorSettingsUpdateMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($chatRoomId: MongoID!, $message: String!, $customerId: MongoID) {
  sendMessage(chatRoomId: $chatRoomId, message: $message, customerId: $customerId) {
    ...ChatMessageFragment
  }
}
    ${ChatMessageFragmentFragmentDoc}`;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      message: // value for 'message'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const StripeAccountCreateDocument = gql`
    mutation StripeAccountCreate($vendorId: MongoID) {
  stripeAccountCreate(vendorId: $vendorId) {
    _id
    stripe_config
  }
}
    `;
export type StripeAccountCreateMutationFn = Apollo.MutationFunction<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>;

/**
 * __useStripeAccountCreateMutation__
 *
 * To run a mutation, you first call `useStripeAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeAccountCreateMutation, { data, loading, error }] = useStripeAccountCreateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useStripeAccountCreateMutation(baseOptions?: Apollo.MutationHookOptions<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>(StripeAccountCreateDocument, options);
      }
export type StripeAccountCreateMutationHookResult = ReturnType<typeof useStripeAccountCreateMutation>;
export type StripeAccountCreateMutationResult = Apollo.MutationResult<StripeAccountCreateMutation>;
export type StripeAccountCreateMutationOptions = Apollo.BaseMutationOptions<StripeAccountCreateMutation, StripeAccountCreateMutationVariables>;
export const StripeSessionCreateDocument = gql`
    mutation StripeSessionCreate($vendorId: MongoID) {
  stripeSessionCreate(vendorId: $vendorId) {
    _id
    stripe_config
  }
}
    `;
export type StripeSessionCreateMutationFn = Apollo.MutationFunction<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>;

/**
 * __useStripeSessionCreateMutation__
 *
 * To run a mutation, you first call `useStripeSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeSessionCreateMutation, { data, loading, error }] = useStripeSessionCreateMutation({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useStripeSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>(StripeSessionCreateDocument, options);
      }
export type StripeSessionCreateMutationHookResult = ReturnType<typeof useStripeSessionCreateMutation>;
export type StripeSessionCreateMutationResult = Apollo.MutationResult<StripeSessionCreateMutation>;
export type StripeSessionCreateMutationOptions = Apollo.BaseMutationOptions<StripeSessionCreateMutation, StripeSessionCreateMutationVariables>;
export const UserSettingsUpdateDocument = gql`
    mutation UserSettingsUpdate($userId: MongoID!, $settings: UserSettingsInput!) {
  userSettingsUpdate(userId: $userId, settings: $settings) {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;
export type UserSettingsUpdateMutationFn = Apollo.MutationFunction<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>;

/**
 * __useUserSettingsUpdateMutation__
 *
 * To run a mutation, you first call `useUserSettingsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSettingsUpdateMutation, { data, loading, error }] = useUserSettingsUpdateMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUserSettingsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>(UserSettingsUpdateDocument, options);
      }
export type UserSettingsUpdateMutationHookResult = ReturnType<typeof useUserSettingsUpdateMutation>;
export type UserSettingsUpdateMutationResult = Apollo.MutationResult<UserSettingsUpdateMutation>;
export type UserSettingsUpdateMutationOptions = Apollo.BaseMutationOptions<UserSettingsUpdateMutation, UserSettingsUpdateMutationVariables>;
export const UserUpdateActiveVendorDocument = gql`
    mutation UserUpdateActiveVendor($userId: MongoID!, $active_vendor: MongoID!) {
  userUpdateById(_id: $userId, record: {active_vendor: $active_vendor}) {
    recordId
  }
}
    `;
export type UserUpdateActiveVendorMutationFn = Apollo.MutationFunction<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>;

/**
 * __useUserUpdateActiveVendorMutation__
 *
 * To run a mutation, you first call `useUserUpdateActiveVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateActiveVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateActiveVendorMutation, { data, loading, error }] = useUserUpdateActiveVendorMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      active_vendor: // value for 'active_vendor'
 *   },
 * });
 */
export function useUserUpdateActiveVendorMutation(baseOptions?: Apollo.MutationHookOptions<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>(UserUpdateActiveVendorDocument, options);
      }
export type UserUpdateActiveVendorMutationHookResult = ReturnType<typeof useUserUpdateActiveVendorMutation>;
export type UserUpdateActiveVendorMutationResult = Apollo.MutationResult<UserUpdateActiveVendorMutation>;
export type UserUpdateActiveVendorMutationOptions = Apollo.BaseMutationOptions<UserUpdateActiveVendorMutation, UserUpdateActiveVendorMutationVariables>;
export const WaitlistAddDocument = gql`
    mutation WaitlistAdd($slug: String, $vendorId: MongoID, $firstName: String!, $lastName: String!, $email: String, $phone: String, $company: String, $sendWaitlistEmail: Boolean, $sendWaitlistSMS: Boolean, $animal: String!, $startDate: String!, $endDate: String!) {
  waitlistAdd(
    slug: $slug
    vendorId: $vendorId
    firstName: $firstName
    lastName: $lastName
    email: $email
    phone: $phone
    company: $company
    sendWaitlistEmail: $sendWaitlistEmail
    sendWaitlistSMS: $sendWaitlistSMS
    animal: $animal
    startDate: $startDate
    endDate: $endDate
  ) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistAddMutationFn = Apollo.MutationFunction<WaitlistAddMutation, WaitlistAddMutationVariables>;

/**
 * __useWaitlistAddMutation__
 *
 * To run a mutation, you first call `useWaitlistAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistAddMutation, { data, loading, error }] = useWaitlistAddMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      vendorId: // value for 'vendorId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      company: // value for 'company'
 *      sendWaitlistEmail: // value for 'sendWaitlistEmail'
 *      sendWaitlistSMS: // value for 'sendWaitlistSMS'
 *      animal: // value for 'animal'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useWaitlistAddMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistAddMutation, WaitlistAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistAddMutation, WaitlistAddMutationVariables>(WaitlistAddDocument, options);
      }
export type WaitlistAddMutationHookResult = ReturnType<typeof useWaitlistAddMutation>;
export type WaitlistAddMutationResult = Apollo.MutationResult<WaitlistAddMutation>;
export type WaitlistAddMutationOptions = Apollo.BaseMutationOptions<WaitlistAddMutation, WaitlistAddMutationVariables>;
export const WaitlistDeleteDocument = gql`
    mutation WaitlistDelete($customerId: MongoID!) {
  waitlistDelete(_id: $customerId) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistDeleteMutationFn = Apollo.MutationFunction<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>;

/**
 * __useWaitlistDeleteMutation__
 *
 * To run a mutation, you first call `useWaitlistDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistDeleteMutation, { data, loading, error }] = useWaitlistDeleteMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useWaitlistDeleteMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>(WaitlistDeleteDocument, options);
      }
export type WaitlistDeleteMutationHookResult = ReturnType<typeof useWaitlistDeleteMutation>;
export type WaitlistDeleteMutationResult = Apollo.MutationResult<WaitlistDeleteMutation>;
export type WaitlistDeleteMutationOptions = Apollo.BaseMutationOptions<WaitlistDeleteMutation, WaitlistDeleteMutationVariables>;
export const WaitlistUnsubscribeDocument = gql`
    mutation WaitlistUnsubscribe($token: String!) {
  waitlistUnsubscribe(token: $token) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;
export type WaitlistUnsubscribeMutationFn = Apollo.MutationFunction<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>;

/**
 * __useWaitlistUnsubscribeMutation__
 *
 * To run a mutation, you first call `useWaitlistUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitlistUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitlistUnsubscribeMutation, { data, loading, error }] = useWaitlistUnsubscribeMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useWaitlistUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>(WaitlistUnsubscribeDocument, options);
      }
export type WaitlistUnsubscribeMutationHookResult = ReturnType<typeof useWaitlistUnsubscribeMutation>;
export type WaitlistUnsubscribeMutationResult = Apollo.MutationResult<WaitlistUnsubscribeMutation>;
export type WaitlistUnsubscribeMutationOptions = Apollo.BaseMutationOptions<WaitlistUnsubscribeMutation, WaitlistUnsubscribeMutationVariables>;
export const ViewProcessingPartnerDocument = gql`
    query ViewProcessingPartner($vendorId: MongoID, $slug: String) {
  processingPartnersOne(vendorId: $vendorId, slug: $slug) {
    _id
    about
    isEnabled
    enabledAnimals
    animalSettings {
      isEnabled
      species
      inspectionLevels
      splitTypes
      weightedAnimalUnit
      butcherSlotPricing {
        inspectionLevel
        price
      }
      customCutsheetPricing {
        inspectionLevel
        price
      }
    }
    capacityConfigurationType
    capacitySettings {
      isEnabled
      dayOfWeek
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    vendor {
      _id
      shop_name
      address {
        ...AddressFragment
      }
      tenant {
        name
        picture_url
        _id
      }
    }
    customCapacities {
      _id
      isDeleted
      date
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    schedulingDeposit
    refundDeadlineDays
    isWaitlistFunctionalityDisabled
    killAndChillSettings {
      species
      isEnabled
      pricePerHead
    }
  }
}
    ${DailyCapacityBlockFragmentFragmentDoc}
${AddressFragmentFragmentDoc}`;

/**
 * __useViewProcessingPartnerQuery__
 *
 * To run a query within a React component, call `useViewProcessingPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProcessingPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProcessingPartnerQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useViewProcessingPartnerQuery(baseOptions?: Apollo.QueryHookOptions<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>(ViewProcessingPartnerDocument, options);
      }
export function useViewProcessingPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>(ViewProcessingPartnerDocument, options);
        }
export type ViewProcessingPartnerQueryHookResult = ReturnType<typeof useViewProcessingPartnerQuery>;
export type ViewProcessingPartnerLazyQueryHookResult = ReturnType<typeof useViewProcessingPartnerLazyQuery>;
export type ViewProcessingPartnerQueryResult = Apollo.QueryResult<ViewProcessingPartnerQuery, ViewProcessingPartnerQueryVariables>;
export const ViewProcessorAdminDocument = gql`
    query ViewProcessorAdmin($filter: FilterFindOneProcessorSettingsInput) {
  processorSettingsOne(filter: $filter) {
    ...ProcessorSettingsFragment
    customCapacities {
      ...ProcessorSettingsCustomCapacityFragment
    }
  }
  processorCapabilityMany {
    ...ProcessorCapabilityFragment
  }
}
    ${ProcessorSettingsFragmentFragmentDoc}
${ProcessorSettingsCustomCapacityFragmentFragmentDoc}
${ProcessorCapabilityFragmentFragmentDoc}`;

/**
 * __useViewProcessorAdminQuery__
 *
 * To run a query within a React component, call `useViewProcessorAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewProcessorAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewProcessorAdminQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useViewProcessorAdminQuery(baseOptions?: Apollo.QueryHookOptions<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>(ViewProcessorAdminDocument, options);
      }
export function useViewProcessorAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>(ViewProcessorAdminDocument, options);
        }
export type ViewProcessorAdminQueryHookResult = ReturnType<typeof useViewProcessorAdminQuery>;
export type ViewProcessorAdminLazyQueryHookResult = ReturnType<typeof useViewProcessorAdminLazyQuery>;
export type ViewProcessorAdminQueryResult = Apollo.QueryResult<ViewProcessorAdminQuery, ViewProcessorAdminQueryVariables>;
export const ViewSchedulingCreateDocument = gql`
    query ViewSchedulingCreate($userId: MongoID, $vendorId: MongoID!, $animalSpeciesCutsheet: EnumCutsheetAnimalSpecies!, $animalSpeciesProcessorCapability: EnumProcessorCapabilityAnimalSpecies!, $statuses: [EnumProcessorSchedulingStatus!]) {
  cutsheetMany(
    filter: {OR: [{user: $userId}, {vendor: $vendorId}], animalSpecies: $animalSpeciesCutsheet}
  ) {
    ...CutsheetFragment
  }
  processorCapabilityOne(
    filter: {vendor: $vendorId, animalSpecies: $animalSpeciesProcessorCapability}
  ) {
    ...ProcessorCapabilityFragment
  }
  processingPartnersOne(vendorId: $vendorId) {
    _id
    vendor {
      shop_name
      address {
        ...AddressFragment
      }
      tenant {
        name
        picture_url
        _id
      }
      _id
    }
    capacitySettings {
      isEnabled
      dayOfWeek
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    capacityConfigurationType
    customCapacities {
      _id
      isDeleted
      date
      dailyCapacities {
        ...DailyCapacityBlockFragment
      }
    }
    schedulingDeposit
    refundDeadlineDays
    faq
    animalSettings {
      isEnabled
      species
      inspectionLevels
      splitTypes
      weightedAnimalUnit
      butcherSlotPricing {
        inspectionLevel
        price
      }
    }
    isWaitlistFunctionalityDisabled
    killAndChillSettings {
      species
      isEnabled
      pricePerHead
    }
  }
  processorSchedulingMany(
    filter: {vendor: $vendorId, _operators: {status: {in: $statuses}}}
    skip: 0
    limit: 10000
  ) {
    ...ProcessorSchedulingSlimFragment
  }
}
    ${CutsheetFragmentFragmentDoc}
${ProcessorCapabilityFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${DailyCapacityBlockFragmentFragmentDoc}
${ProcessorSchedulingSlimFragmentFragmentDoc}`;

/**
 * __useViewSchedulingCreateQuery__
 *
 * To run a query within a React component, call `useViewSchedulingCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSchedulingCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSchedulingCreateQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      vendorId: // value for 'vendorId'
 *      animalSpeciesCutsheet: // value for 'animalSpeciesCutsheet'
 *      animalSpeciesProcessorCapability: // value for 'animalSpeciesProcessorCapability'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useViewSchedulingCreateQuery(baseOptions: Apollo.QueryHookOptions<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>(ViewSchedulingCreateDocument, options);
      }
export function useViewSchedulingCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>(ViewSchedulingCreateDocument, options);
        }
export type ViewSchedulingCreateQueryHookResult = ReturnType<typeof useViewSchedulingCreateQuery>;
export type ViewSchedulingCreateLazyQueryHookResult = ReturnType<typeof useViewSchedulingCreateLazyQuery>;
export type ViewSchedulingCreateQueryResult = Apollo.QueryResult<ViewSchedulingCreateQuery, ViewSchedulingCreateQueryVariables>;
export const ViewSchedulingEditDocument = gql`
    query ViewSchedulingEdit($jobId: MongoID!, $userId: MongoID!, $isDeleted: Boolean!) {
  findProcessorSchedulingById(_id: $jobId) {
    _id
    vendor {
      _id
      shop_name
      address {
        email
        phone
      }
    }
    animalHeads {
      _id
      producerIdentifier
      splitType
      inspectionLevel
      butcherSlotPrice
      cutsheetInformation {
        _id
        cutsheet {
          _id
          name
          type
          pricePerPound
        }
        splitPart
        quantity
        notes
        locked
        contactUser {
          _id
          email
          first_name
          last_name
          phone
          enabled
        }
      }
      isKillAndChill
    }
    requestedBy {
      _id
      first_name
      last_name
      email
      phone
    }
    isDeleted
    status
    dropoffDate
    dropoffDateStr
    animalSpecies
    headCount
    refundDeadlineDays
    deposit {
      amount
    }
    vendorCutsheets {
      ...CutsheetFragment
    }
    processorSettings {
      _id
      killAndChillSettings {
        isEnabled
        pricePerHead
        species
      }
      animalSettings {
        isEnabled
        inspectionLevels
        species
        butcherSlotPricing {
          inspectionLevel
          species
          price
        }
        customCutsheetPricing {
          inspectionLevel
          species
          price
        }
      }
      vendor {
        shop_name
        address {
          ...AddressFragment
        }
        tenant {
          name
          picture_url
          _id
        }
        _id
      }
      customCapacities {
        date
        capacity
        isDeleted
        _id
      }
      customCutsheetPricing {
        animal
        price
      }
      schedulingDeposit
      refundDeadlineDays
      faq
    }
    processorCapabilities {
      ...ProcessorCapabilityFragment
    }
  }
  cutsheetMany(filter: {user: $userId, isDeleted: $isDeleted}) {
    ...CutsheetFragment
  }
}
    ${CutsheetFragmentFragmentDoc}
${AddressFragmentFragmentDoc}
${ProcessorCapabilityFragmentFragmentDoc}`;

/**
 * __useViewSchedulingEditQuery__
 *
 * To run a query within a React component, call `useViewSchedulingEditQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewSchedulingEditQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewSchedulingEditQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      userId: // value for 'userId'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useViewSchedulingEditQuery(baseOptions: Apollo.QueryHookOptions<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>(ViewSchedulingEditDocument, options);
      }
export function useViewSchedulingEditLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>(ViewSchedulingEditDocument, options);
        }
export type ViewSchedulingEditQueryHookResult = ReturnType<typeof useViewSchedulingEditQuery>;
export type ViewSchedulingEditLazyQueryHookResult = ReturnType<typeof useViewSchedulingEditLazyQuery>;
export type ViewSchedulingEditQueryResult = Apollo.QueryResult<ViewSchedulingEditQuery, ViewSchedulingEditQueryVariables>;
export const ActiveVendorListDocument = gql`
    query ActiveVendorList {
  activeVendorList {
    _id
    shop_name
    enabled
  }
}
    `;

/**
 * __useActiveVendorListQuery__
 *
 * To run a query within a React component, call `useActiveVendorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveVendorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveVendorListQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveVendorListQuery(baseOptions?: Apollo.QueryHookOptions<ActiveVendorListQuery, ActiveVendorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveVendorListQuery, ActiveVendorListQueryVariables>(ActiveVendorListDocument, options);
      }
export function useActiveVendorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveVendorListQuery, ActiveVendorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveVendorListQuery, ActiveVendorListQueryVariables>(ActiveVendorListDocument, options);
        }
export type ActiveVendorListQueryHookResult = ReturnType<typeof useActiveVendorListQuery>;
export type ActiveVendorListLazyQueryHookResult = ReturnType<typeof useActiveVendorListLazyQuery>;
export type ActiveVendorListQueryResult = Apollo.QueryResult<ActiveVendorListQuery, ActiveVendorListQueryVariables>;
export const ModuleManyDocument = gql`
    query ModuleMany($filter: FilterFindManyModuleInput) {
  moduleMany(filter: $filter) {
    name
    label
    order
    _id
  }
}
    `;

/**
 * __useModuleManyQuery__
 *
 * To run a query within a React component, call `useModuleManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useModuleManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModuleManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useModuleManyQuery(baseOptions?: Apollo.QueryHookOptions<ModuleManyQuery, ModuleManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModuleManyQuery, ModuleManyQueryVariables>(ModuleManyDocument, options);
      }
export function useModuleManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModuleManyQuery, ModuleManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModuleManyQuery, ModuleManyQueryVariables>(ModuleManyDocument, options);
        }
export type ModuleManyQueryHookResult = ReturnType<typeof useModuleManyQuery>;
export type ModuleManyLazyQueryHookResult = ReturnType<typeof useModuleManyLazyQuery>;
export type ModuleManyQueryResult = Apollo.QueryResult<ModuleManyQuery, ModuleManyQueryVariables>;
export const TenantByIdDocument = gql`
    query TenantById($tenantId: MongoID!) {
  tenantById(_id: $tenantId) {
    _id
    date_created
    domain
    email
    enabled
    external_id
    external_ids
    name
    picture_url
    primary_color
    modules {
      name
      label
      href
      order
      _id
    }
    users {
      first_name
      last_name
      email
      picture_url
      role
      last_login
      enabled
      _id
    }
    vendors {
      external_id
      date_created
      shop_name
      shop_slug
      shop_url
      tagline
      prefers_dropoff
      pickup_days
      free_shipping_amount
      enabled
      address {
        ...AddressFragment
      }
      integrations {
        config
        name
        type
        endpoint
        key
        _id
      }
      processorSettings {
        isEnabled
        commercialStartDate
        _id
      }
      _id
    }
  }
}
    ${AddressFragmentFragmentDoc}`;

/**
 * __useTenantByIdQuery__
 *
 * To run a query within a React component, call `useTenantByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantByIdQuery({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useTenantByIdQuery(baseOptions: Apollo.QueryHookOptions<TenantByIdQuery, TenantByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantByIdQuery, TenantByIdQueryVariables>(TenantByIdDocument, options);
      }
export function useTenantByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantByIdQuery, TenantByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantByIdQuery, TenantByIdQueryVariables>(TenantByIdDocument, options);
        }
export type TenantByIdQueryHookResult = ReturnType<typeof useTenantByIdQuery>;
export type TenantByIdLazyQueryHookResult = ReturnType<typeof useTenantByIdLazyQuery>;
export type TenantByIdQueryResult = Apollo.QueryResult<TenantByIdQuery, TenantByIdQueryVariables>;
export const TenantPaginationDocument = gql`
    query TenantPagination($sort: SortFindManyTenantInput!, $filter: FilterFindManyTenantInput!, $page: Int!, $perPage: Int!) {
  tenantPagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      external_id
      name
      date_created
      domain
      enabled
      _id
      users {
        first_name
        last_name
        role
        _id
      }
      vendors {
        date_created
        shop_name
        shop_slug
        enabled
        _id
      }
      modules {
        name
        label
        order
        _id
      }
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    `;

/**
 * __useTenantPaginationQuery__
 *
 * To run a query within a React component, call `useTenantPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useTenantPaginationQuery(baseOptions: Apollo.QueryHookOptions<TenantPaginationQuery, TenantPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantPaginationQuery, TenantPaginationQueryVariables>(TenantPaginationDocument, options);
      }
export function useTenantPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantPaginationQuery, TenantPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantPaginationQuery, TenantPaginationQueryVariables>(TenantPaginationDocument, options);
        }
export type TenantPaginationQueryHookResult = ReturnType<typeof useTenantPaginationQuery>;
export type TenantPaginationLazyQueryHookResult = ReturnType<typeof useTenantPaginationLazyQuery>;
export type TenantPaginationQueryResult = Apollo.QueryResult<TenantPaginationQuery, TenantPaginationQueryVariables>;
export const CancellationReasonManyDocument = gql`
    query cancellationReasonMany($filter: FilterFindManyCancellationReasonInput, $sort: SortFindManyCancellationReasonInput) {
  cancellationReasonMany(filter: $filter, sort: $sort) {
    reason
    index
    isEnabled
    _id
  }
}
    `;

/**
 * __useCancellationReasonManyQuery__
 *
 * To run a query within a React component, call `useCancellationReasonManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCancellationReasonManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCancellationReasonManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useCancellationReasonManyQuery(baseOptions?: Apollo.QueryHookOptions<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>(CancellationReasonManyDocument, options);
      }
export function useCancellationReasonManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>(CancellationReasonManyDocument, options);
        }
export type CancellationReasonManyQueryHookResult = ReturnType<typeof useCancellationReasonManyQuery>;
export type CancellationReasonManyLazyQueryHookResult = ReturnType<typeof useCancellationReasonManyLazyQuery>;
export type CancellationReasonManyQueryResult = Apollo.QueryResult<CancellationReasonManyQuery, CancellationReasonManyQueryVariables>;
export const CutsheetPaginationDocument = gql`
    query CutsheetPagination($sort: SortFindManyCutsheetInput!, $filter: FilterFindManyCutsheetInput!, $page: Int!, $perPage: Int!) {
  cutsheetPagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      ...CutsheetFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${CutsheetFragmentFragmentDoc}`;

/**
 * __useCutsheetPaginationQuery__
 *
 * To run a query within a React component, call `useCutsheetPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCutsheetPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCutsheetPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useCutsheetPaginationQuery(baseOptions: Apollo.QueryHookOptions<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>(CutsheetPaginationDocument, options);
      }
export function useCutsheetPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>(CutsheetPaginationDocument, options);
        }
export type CutsheetPaginationQueryHookResult = ReturnType<typeof useCutsheetPaginationQuery>;
export type CutsheetPaginationLazyQueryHookResult = ReturnType<typeof useCutsheetPaginationLazyQuery>;
export type CutsheetPaginationQueryResult = Apollo.QueryResult<CutsheetPaginationQuery, CutsheetPaginationQueryVariables>;
export const IntegrationOneDocument = gql`
    query IntegrationOne($filter: FilterFindOneIntegrationInput) {
  integrationOne(filter: $filter) {
    _id
    name
    config
  }
}
    `;

/**
 * __useIntegrationOneQuery__
 *
 * To run a query within a React component, call `useIntegrationOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useIntegrationOneQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationOneQuery, IntegrationOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationOneQuery, IntegrationOneQueryVariables>(IntegrationOneDocument, options);
      }
export function useIntegrationOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationOneQuery, IntegrationOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationOneQuery, IntegrationOneQueryVariables>(IntegrationOneDocument, options);
        }
export type IntegrationOneQueryHookResult = ReturnType<typeof useIntegrationOneQuery>;
export type IntegrationOneLazyQueryHookResult = ReturnType<typeof useIntegrationOneLazyQuery>;
export type IntegrationOneQueryResult = Apollo.QueryResult<IntegrationOneQuery, IntegrationOneQueryVariables>;
export const InvoiceByIdDocument = gql`
    query invoiceById($id: MongoID!) {
  invoiceById(_id: $id) {
    ...InvoiceFragment
  }
}
    ${InvoiceFragmentFragmentDoc}`;

/**
 * __useInvoiceByIdQuery__
 *
 * To run a query within a React component, call `useInvoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceByIdQuery(baseOptions: Apollo.QueryHookOptions<InvoiceByIdQuery, InvoiceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceByIdQuery, InvoiceByIdQueryVariables>(InvoiceByIdDocument, options);
      }
export function useInvoiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceByIdQuery, InvoiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceByIdQuery, InvoiceByIdQueryVariables>(InvoiceByIdDocument, options);
        }
export type InvoiceByIdQueryHookResult = ReturnType<typeof useInvoiceByIdQuery>;
export type InvoiceByIdLazyQueryHookResult = ReturnType<typeof useInvoiceByIdLazyQuery>;
export type InvoiceByIdQueryResult = Apollo.QueryResult<InvoiceByIdQuery, InvoiceByIdQueryVariables>;
export const SearchInvoicesDocument = gql`
    query SearchInvoices($type: String!, $sort: SortFindManyInvoiceInput!, $page: Int!, $perPage: Int!, $search: String, $status: [String!]) {
  searchInvoices(
    type: $type
    sort: $sort
    page: $page
    perPage: $perPage
    search: $search
    status: $status
  ) {
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    count
    items {
      ...InvoiceFragment
    }
  }
}
    ${InvoiceFragmentFragmentDoc}`;

/**
 * __useSearchInvoicesQuery__
 *
 * To run a query within a React component, call `useSearchInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInvoicesQuery({
 *   variables: {
 *      type: // value for 'type'
 *      sort: // value for 'sort'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSearchInvoicesQuery(baseOptions: Apollo.QueryHookOptions<SearchInvoicesQuery, SearchInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchInvoicesQuery, SearchInvoicesQueryVariables>(SearchInvoicesDocument, options);
      }
export function useSearchInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchInvoicesQuery, SearchInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchInvoicesQuery, SearchInvoicesQueryVariables>(SearchInvoicesDocument, options);
        }
export type SearchInvoicesQueryHookResult = ReturnType<typeof useSearchInvoicesQuery>;
export type SearchInvoicesLazyQueryHookResult = ReturnType<typeof useSearchInvoicesLazyQuery>;
export type SearchInvoicesQueryResult = Apollo.QueryResult<SearchInvoicesQuery, SearchInvoicesQueryVariables>;
export const MessagesByChatRoomDocument = gql`
    query MessagesByChatRoom($chatRoomId: MongoID!, $page: Int!, $perPage: Int!) {
  messagesByChatRoom(chatRoomId: $chatRoomId, page: $page, perPage: $perPage) {
    count
    items {
      ...ChatMessageFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ChatMessageFragmentFragmentDoc}`;

/**
 * __useMessagesByChatRoomQuery__
 *
 * To run a query within a React component, call `useMessagesByChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesByChatRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesByChatRoomQuery({
 *   variables: {
 *      chatRoomId: // value for 'chatRoomId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMessagesByChatRoomQuery(baseOptions: Apollo.QueryHookOptions<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>(MessagesByChatRoomDocument, options);
      }
export function useMessagesByChatRoomLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>(MessagesByChatRoomDocument, options);
        }
export type MessagesByChatRoomQueryHookResult = ReturnType<typeof useMessagesByChatRoomQuery>;
export type MessagesByChatRoomLazyQueryHookResult = ReturnType<typeof useMessagesByChatRoomLazyQuery>;
export type MessagesByChatRoomQueryResult = Apollo.QueryResult<MessagesByChatRoomQuery, MessagesByChatRoomQueryVariables>;
export const MyChatRoomsDocument = gql`
    query MyChatRooms($customerId: MongoID, $page: Int!, $perPage: Int!) {
  myChatRooms(customerId: $customerId, page: $page, perPage: $perPage) {
    count
    items {
      ...ChatRoomFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${ChatRoomFragmentFragmentDoc}`;

/**
 * __useMyChatRoomsQuery__
 *
 * To run a query within a React component, call `useMyChatRoomsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyChatRoomsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyChatRoomsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useMyChatRoomsQuery(baseOptions: Apollo.QueryHookOptions<MyChatRoomsQuery, MyChatRoomsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyChatRoomsQuery, MyChatRoomsQueryVariables>(MyChatRoomsDocument, options);
      }
export function useMyChatRoomsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyChatRoomsQuery, MyChatRoomsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyChatRoomsQuery, MyChatRoomsQueryVariables>(MyChatRoomsDocument, options);
        }
export type MyChatRoomsQueryHookResult = ReturnType<typeof useMyChatRoomsQuery>;
export type MyChatRoomsLazyQueryHookResult = ReturnType<typeof useMyChatRoomsLazyQuery>;
export type MyChatRoomsQueryResult = Apollo.QueryResult<MyChatRoomsQuery, MyChatRoomsQueryVariables>;
export const NotePaginationDocument = gql`
    query NotePagination($sort: SortFindManyNoteInput!, $filter: FilterFindManyNoteInput!, $page: Int!, $perPage: Int!) {
  notePagination(sort: $sort, filter: $filter, page: $page, perPage: $perPage) {
    count
    items {
      ...NoteFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${NoteFragmentFragmentDoc}`;

/**
 * __useNotePaginationQuery__
 *
 * To run a query within a React component, call `useNotePaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotePaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotePaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotePaginationQuery(baseOptions: Apollo.QueryHookOptions<NotePaginationQuery, NotePaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotePaginationQuery, NotePaginationQueryVariables>(NotePaginationDocument, options);
      }
export function useNotePaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotePaginationQuery, NotePaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotePaginationQuery, NotePaginationQueryVariables>(NotePaginationDocument, options);
        }
export type NotePaginationQueryHookResult = ReturnType<typeof useNotePaginationQuery>;
export type NotePaginationLazyQueryHookResult = ReturnType<typeof useNotePaginationLazyQuery>;
export type NotePaginationQueryResult = Apollo.QueryResult<NotePaginationQuery, NotePaginationQueryVariables>;
export const NotificationSettingsByVendorIdDocument = gql`
    query NotificationSettingsByVendorId($vendorId: MongoID!, $page: Int!, $perPage: Int!) {
  findNotificationSettingsByVendorId(
    vendorId: $vendorId
    page: $page
    perPage: $perPage
  ) {
    count
    items {
      ...NotificationSettingFragment
    }
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${NotificationSettingFragmentFragmentDoc}`;

/**
 * __useNotificationSettingsByVendorIdQuery__
 *
 * To run a query within a React component, call `useNotificationSettingsByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingsByVendorIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useNotificationSettingsByVendorIdQuery(baseOptions: Apollo.QueryHookOptions<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>(NotificationSettingsByVendorIdDocument, options);
      }
export function useNotificationSettingsByVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>(NotificationSettingsByVendorIdDocument, options);
        }
export type NotificationSettingsByVendorIdQueryHookResult = ReturnType<typeof useNotificationSettingsByVendorIdQuery>;
export type NotificationSettingsByVendorIdLazyQueryHookResult = ReturnType<typeof useNotificationSettingsByVendorIdLazyQuery>;
export type NotificationSettingsByVendorIdQueryResult = Apollo.QueryResult<NotificationSettingsByVendorIdQuery, NotificationSettingsByVendorIdQueryVariables>;
export const NotificationSettingsOneDocument = gql`
    query NotificationSettingsOne($filter: FilterFindOneNotificationSettingInput) {
  notificationSettingsOne(filter: $filter) {
    ...NotificationSettingFragment
  }
}
    ${NotificationSettingFragmentFragmentDoc}`;

/**
 * __useNotificationSettingsOneQuery__
 *
 * To run a query within a React component, call `useNotificationSettingsOneQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationSettingsOneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationSettingsOneQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNotificationSettingsOneQuery(baseOptions?: Apollo.QueryHookOptions<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>(NotificationSettingsOneDocument, options);
      }
export function useNotificationSettingsOneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>(NotificationSettingsOneDocument, options);
        }
export type NotificationSettingsOneQueryHookResult = ReturnType<typeof useNotificationSettingsOneQuery>;
export type NotificationSettingsOneLazyQueryHookResult = ReturnType<typeof useNotificationSettingsOneLazyQuery>;
export type NotificationSettingsOneQueryResult = Apollo.QueryResult<NotificationSettingsOneQuery, NotificationSettingsOneQueryVariables>;
export const PrimalCutBlockerManyDocument = gql`
    query PrimalCutBlockerMany($filter: FilterFindManyPrimalCutBlockerInput!, $skip: Int, $limit: Int) {
  primalCutBlockerMany(filter: $filter, skip: $skip, limit: $limit) {
    ...PrimalCutBlockerFragment
  }
}
    ${PrimalCutBlockerFragmentFragmentDoc}`;

/**
 * __usePrimalCutBlockerManyQuery__
 *
 * To run a query within a React component, call `usePrimalCutBlockerManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutBlockerManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalCutBlockerManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePrimalCutBlockerManyQuery(baseOptions: Apollo.QueryHookOptions<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>(PrimalCutBlockerManyDocument, options);
      }
export function usePrimalCutBlockerManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>(PrimalCutBlockerManyDocument, options);
        }
export type PrimalCutBlockerManyQueryHookResult = ReturnType<typeof usePrimalCutBlockerManyQuery>;
export type PrimalCutBlockerManyLazyQueryHookResult = ReturnType<typeof usePrimalCutBlockerManyLazyQuery>;
export type PrimalCutBlockerManyQueryResult = Apollo.QueryResult<PrimalCutBlockerManyQuery, PrimalCutBlockerManyQueryVariables>;
export const PrimalCutManyDocument = gql`
    query PrimalCutMany($filter: FilterFindManyPrimalCutInput) {
  primalCutMany(filter: $filter) {
    name
    cutType {
      name
      _id
    }
    order
    _id
    isDeleted
    primal {
      name
      order
      _id
      group {
        processorSettings
        isDefault
        animalSpecies
        inspectionLevel
        name
        order
        _id
      }
    }
  }
}
    `;

/**
 * __usePrimalCutManyQuery__
 *
 * To run a query within a React component, call `usePrimalCutManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalCutManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePrimalCutManyQuery(baseOptions?: Apollo.QueryHookOptions<PrimalCutManyQuery, PrimalCutManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalCutManyQuery, PrimalCutManyQueryVariables>(PrimalCutManyDocument, options);
      }
export function usePrimalCutManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalCutManyQuery, PrimalCutManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalCutManyQuery, PrimalCutManyQueryVariables>(PrimalCutManyDocument, options);
        }
export type PrimalCutManyQueryHookResult = ReturnType<typeof usePrimalCutManyQuery>;
export type PrimalCutManyLazyQueryHookResult = ReturnType<typeof usePrimalCutManyLazyQuery>;
export type PrimalCutManyQueryResult = Apollo.QueryResult<PrimalCutManyQuery, PrimalCutManyQueryVariables>;
export const PrimalCutTypeManyDocument = gql`
    query PrimalCutTypeMany($filter: FilterFindManyPrimalCutTypeInput, $skip: Int, $limit: Int) {
  primalCutTypeMany(filter: $filter, skip: $skip, limit: $limit) {
    _id
    name
    isDeleted
    animalSpecies
    processorSettings
  }
}
    `;

/**
 * __usePrimalCutTypeManyQuery__
 *
 * To run a query within a React component, call `usePrimalCutTypeManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalCutTypeManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalCutTypeManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePrimalCutTypeManyQuery(baseOptions?: Apollo.QueryHookOptions<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>(PrimalCutTypeManyDocument, options);
      }
export function usePrimalCutTypeManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>(PrimalCutTypeManyDocument, options);
        }
export type PrimalCutTypeManyQueryHookResult = ReturnType<typeof usePrimalCutTypeManyQuery>;
export type PrimalCutTypeManyLazyQueryHookResult = ReturnType<typeof usePrimalCutTypeManyLazyQuery>;
export type PrimalCutTypeManyQueryResult = Apollo.QueryResult<PrimalCutTypeManyQuery, PrimalCutTypeManyQueryVariables>;
export const PrimalGroupManyDocument = gql`
    query PrimalGroupMany($filter: FilterFindManyPrimalGroupInput, $sort: SortFindManyPrimalGroupInput) {
  primalGroupMany(filter: $filter, sort: $sort) {
    processorSettings
    isDefault
    animalSpecies
    inspectionLevel
    name
    order
    isDeleted
    primals {
      isDeleted
      cuts {
        isDeleted
        name
        description
        cutType {
          name
          _id
        }
        order
        _id
      }
      order
      name
      description
      _id
    }
    _id
  }
}
    `;

/**
 * __usePrimalGroupManyQuery__
 *
 * To run a query within a React component, call `usePrimalGroupManyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrimalGroupManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrimalGroupManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function usePrimalGroupManyQuery(baseOptions?: Apollo.QueryHookOptions<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>(PrimalGroupManyDocument, options);
      }
export function usePrimalGroupManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>(PrimalGroupManyDocument, options);
        }
export type PrimalGroupManyQueryHookResult = ReturnType<typeof usePrimalGroupManyQuery>;
export type PrimalGroupManyLazyQueryHookResult = ReturnType<typeof usePrimalGroupManyLazyQuery>;
export type PrimalGroupManyQueryResult = Apollo.QueryResult<PrimalGroupManyQuery, PrimalGroupManyQueryVariables>;
export const ProcessingPartnersDocument = gql`
    query processingPartners {
  processingPartners {
    _id
    isEnabled
    enabledAnimals
    vendor {
      _id
      shop_name
      address {
        city
        state
      }
      tenant {
        name
        picture_url
      }
    }
    slug
  }
}
    `;

/**
 * __useProcessingPartnersQuery__
 *
 * To run a query within a React component, call `useProcessingPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingPartnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useProcessingPartnersQuery(baseOptions?: Apollo.QueryHookOptions<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>(ProcessingPartnersDocument, options);
      }
export function useProcessingPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>(ProcessingPartnersDocument, options);
        }
export type ProcessingPartnersQueryHookResult = ReturnType<typeof useProcessingPartnersQuery>;
export type ProcessingPartnersLazyQueryHookResult = ReturnType<typeof useProcessingPartnersLazyQuery>;
export type ProcessingPartnersQueryResult = Apollo.QueryResult<ProcessingPartnersQuery, ProcessingPartnersQueryVariables>;
export const ProcessorCustomerByIdDocument = gql`
    query ProcessorCustomerById($id: MongoID!) {
  userById(_id: $id) {
    first_name
    last_name
    email
    phone
    enabled
    company
    _id
  }
}
    `;

/**
 * __useProcessorCustomerByIdQuery__
 *
 * To run a query within a React component, call `useProcessorCustomerByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorCustomerByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorCustomerByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessorCustomerByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>(ProcessorCustomerByIdDocument, options);
      }
export function useProcessorCustomerByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>(ProcessorCustomerByIdDocument, options);
        }
export type ProcessorCustomerByIdQueryHookResult = ReturnType<typeof useProcessorCustomerByIdQuery>;
export type ProcessorCustomerByIdLazyQueryHookResult = ReturnType<typeof useProcessorCustomerByIdLazyQuery>;
export type ProcessorCustomerByIdQueryResult = Apollo.QueryResult<ProcessorCustomerByIdQuery, ProcessorCustomerByIdQueryVariables>;
export const ProcessorCustomersPaginationDocument = gql`
    query processorCustomersPagination($page: Int!, $perPage: Int!, $search: String, $sort: SortFindManyUserInput!, $vendorId: MongoID!) {
  getProcessorCustomers(
    page: $page
    perPage: $perPage
    search: $search
    sort: $sort
    vendorId: $vendorId
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      first_name
      last_name
      email
      phone
      company
      _id
    }
  }
}
    `;

/**
 * __useProcessorCustomersPaginationQuery__
 *
 * To run a query within a React component, call `useProcessorCustomersPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorCustomersPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorCustomersPaginationQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *      sort: // value for 'sort'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProcessorCustomersPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>(ProcessorCustomersPaginationDocument, options);
      }
export function useProcessorCustomersPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>(ProcessorCustomersPaginationDocument, options);
        }
export type ProcessorCustomersPaginationQueryHookResult = ReturnType<typeof useProcessorCustomersPaginationQuery>;
export type ProcessorCustomersPaginationLazyQueryHookResult = ReturnType<typeof useProcessorCustomersPaginationLazyQuery>;
export type ProcessorCustomersPaginationQueryResult = Apollo.QueryResult<ProcessorCustomersPaginationQuery, ProcessorCustomersPaginationQueryVariables>;
export const ProcessorNotificationPaginationDocument = gql`
    query processorNotificationPagination($sort: SortFindManyProcessorNotificationInput!, $filter: FilterFindManyProcessorNotificationInput!, $page: Int!, $perPage: Int!) {
  processorNotificationPagination(
    sort: $sort
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      vendor
      notificationType
      type
      sentTo
      sentOn
      errorMessage
    }
  }
}
    `;

/**
 * __useProcessorNotificationPaginationQuery__
 *
 * To run a query within a React component, call `useProcessorNotificationPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorNotificationPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorNotificationPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProcessorNotificationPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>(ProcessorNotificationPaginationDocument, options);
      }
export function useProcessorNotificationPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>(ProcessorNotificationPaginationDocument, options);
        }
export type ProcessorNotificationPaginationQueryHookResult = ReturnType<typeof useProcessorNotificationPaginationQuery>;
export type ProcessorNotificationPaginationLazyQueryHookResult = ReturnType<typeof useProcessorNotificationPaginationLazyQuery>;
export type ProcessorNotificationPaginationQueryResult = Apollo.QueryResult<ProcessorNotificationPaginationQuery, ProcessorNotificationPaginationQueryVariables>;
export const ProcessorSchedulingByIdDocument = gql`
    query ProcessorSchedulingById($id: MongoID!, $includeCutsheetInformation: Boolean = false) {
  processorSchedulingById(_id: $id) {
    vendor {
      shop_name
      address {
        first_name
        last_name
        city
        state
        email
        phone
        _id
      }
    }
    dropoffDate
    dropoffDateStr
    status
    statusLastUpdated
    animalSpecies
    headCount
    refundDeadlineDays
    requestedBy {
      _id
      first_name
      last_name
      phone
      email
      phone
    }
    deposit {
      amount
    }
    animalHeads {
      _id
      splitType
      producerIdentifier
      inspectionLevel
      isHangingWeightPerSide
      hangingWeightSideA
      hangingWeightSideB
      hangingWeight
      liveWeight
      grade
      yield
      tracking
      publicId
      cutsheetInformation @include(if: $includeCutsheetInformation) {
        cutsheet {
          ...CutsheetFragment
        }
        splitPart
        quantity
        notes
        locked
        contactUser {
          _id
          email
          first_name
          last_name
          phone
          company
        }
        _id
      }
      isKillAndChill
    }
    linkedInvoices {
      ...InvoiceFragment
    }
    _id
  }
}
    ${CutsheetFragmentFragmentDoc}
${InvoiceFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingByIdQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      includeCutsheetInformation: // value for 'includeCutsheetInformation'
 *   },
 * });
 */
export function useProcessorSchedulingByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>(ProcessorSchedulingByIdDocument, options);
      }
export function useProcessorSchedulingByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>(ProcessorSchedulingByIdDocument, options);
        }
export type ProcessorSchedulingByIdQueryHookResult = ReturnType<typeof useProcessorSchedulingByIdQuery>;
export type ProcessorSchedulingByIdLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingByIdLazyQuery>;
export type ProcessorSchedulingByIdQueryResult = Apollo.QueryResult<ProcessorSchedulingByIdQuery, ProcessorSchedulingByIdQueryVariables>;
export const ProcessorSchedulingCalendarDocument = gql`
    query ProcessorSchedulingCalendar($vendorId: MongoID!, $startDate: Date!, $endDate: Date!, $filter: FilterFindManyProcessorSchedulingInput) {
  getProcessorSchedulingCalendar(
    vendorId: $vendorId
    startDate: $startDate
    endDate: $endDate
    filter: $filter
  ) {
    ...ProcessorSchedulingCalendarFragment
  }
}
    ${ProcessorSchedulingCalendarFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingCalendarQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingCalendarQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProcessorSchedulingCalendarQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>(ProcessorSchedulingCalendarDocument, options);
      }
export function useProcessorSchedulingCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>(ProcessorSchedulingCalendarDocument, options);
        }
export type ProcessorSchedulingCalendarQueryHookResult = ReturnType<typeof useProcessorSchedulingCalendarQuery>;
export type ProcessorSchedulingCalendarLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingCalendarLazyQuery>;
export type ProcessorSchedulingCalendarQueryResult = Apollo.QueryResult<ProcessorSchedulingCalendarQuery, ProcessorSchedulingCalendarQueryVariables>;
export const ProcessorSchedulingFilteredDocument = gql`
    query processorSchedulingFiltered($page: Int!, $perPage: Int!, $searchByContact: String, $sort: SortFindManyProcessorSchedulingInput!, $statusFilter: [String!], $vendorId: MongoID!) {
  getFilteredProcessorScheduling(
    page: $page
    perPage: $perPage
    searchByContact: $searchByContact
    sort: $sort
    statusFilter: $statusFilter
    vendorId: $vendorId
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      firstKillDate
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        cutsheetInformation {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
          }
          splitPart
          quantity
          notes
          locked
          contactUser {
            _id
            email
            first_name
            last_name
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingFilteredQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingFilteredQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      searchByContact: // value for 'searchByContact'
 *      sort: // value for 'sort'
 *      statusFilter: // value for 'statusFilter'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProcessorSchedulingFilteredQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>(ProcessorSchedulingFilteredDocument, options);
      }
export function useProcessorSchedulingFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>(ProcessorSchedulingFilteredDocument, options);
        }
export type ProcessorSchedulingFilteredQueryHookResult = ReturnType<typeof useProcessorSchedulingFilteredQuery>;
export type ProcessorSchedulingFilteredLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingFilteredLazyQuery>;
export type ProcessorSchedulingFilteredQueryResult = Apollo.QueryResult<ProcessorSchedulingFilteredQuery, ProcessorSchedulingFilteredQueryVariables>;
export const ProcessorSchedulingManyDocument = gql`
    query processorSchedulingMany($filter: FilterFindManyProcessorSchedulingInput, $skip: Int, $limit: Int) {
  processorSchedulingMany(filter: $filter, skip: $skip, limit: $limit) {
    ...ProcessorSchedulingSlimFragment
    vendor {
      _id
    }
    dropoffDate
    status
    statusLastUpdated
    animalSpecies
    headCount
    animalHeads {
      _id
      inspectionLevel
      cutsheetInformation {
        _id
        cutsheet {
          _id
        }
      }
    }
  }
}
    ${ProcessorSchedulingSlimFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingManyQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingManyQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProcessorSchedulingManyQuery(baseOptions?: Apollo.QueryHookOptions<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>(ProcessorSchedulingManyDocument, options);
      }
export function useProcessorSchedulingManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>(ProcessorSchedulingManyDocument, options);
        }
export type ProcessorSchedulingManyQueryHookResult = ReturnType<typeof useProcessorSchedulingManyQuery>;
export type ProcessorSchedulingManyLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingManyLazyQuery>;
export type ProcessorSchedulingManyQueryResult = Apollo.QueryResult<ProcessorSchedulingManyQuery, ProcessorSchedulingManyQueryVariables>;
export const ProcessorSchedulingPaginationDocument = gql`
    query ProcessorSchedulingPagination($sort: SortFindManyProcessorSchedulingInput!, $filter: FilterFindManyProcessorSchedulingInput!, $page: Int!, $perPage: Int!) {
  processorSchedulingPagination(
    sort: $sort
    filter: $filter
    page: $page
    perPage: $perPage
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      vendor {
        shop_name
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        cutsheetInformation {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
            extras {
              ...ExtrasFragment
            }
            trim {
              ...TrimFragment
            }
          }
          splitPart
          quantity
          notes
          locked
          contactUser {
            _id
            email
            first_name
            last_name
            phone
          }
        }
        isKillAndChill
      }
    }
  }
}
    ${ExtrasFragmentFragmentDoc}
${TrimFragmentFragmentDoc}`;

/**
 * __useProcessorSchedulingPaginationQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingPaginationQuery({
 *   variables: {
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useProcessorSchedulingPaginationQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>(ProcessorSchedulingPaginationDocument, options);
      }
export function useProcessorSchedulingPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>(ProcessorSchedulingPaginationDocument, options);
        }
export type ProcessorSchedulingPaginationQueryHookResult = ReturnType<typeof useProcessorSchedulingPaginationQuery>;
export type ProcessorSchedulingPaginationLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingPaginationLazyQuery>;
export type ProcessorSchedulingPaginationQueryResult = Apollo.QueryResult<ProcessorSchedulingPaginationQuery, ProcessorSchedulingPaginationQueryVariables>;
export const ProcessorSchedulingWithMissingCutsheetsDocument = gql`
    query processorSchedulingWithMissingCutsheets($page: Int!, $perPage: Int!, $sort: SortFindManyProcessorSchedulingInput!, $vendorId: MongoID, $customerId: MongoID) {
  findProcessorSchedulingsWithMissingCutsheets(
    page: $page
    perPage: $perPage
    sort: $sort
    vendorId: $vendorId
    customerId: $customerId
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      firstKillDate
      vendor {
        shop_name
      }
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        cutsheetInformation {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
          }
          splitPart
          quantity
          notes
          locked
          contactUser {
            _id
            email
            first_name
            last_name
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingWithMissingCutsheetsQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingWithMissingCutsheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingWithMissingCutsheetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingWithMissingCutsheetsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sort: // value for 'sort'
 *      vendorId: // value for 'vendorId'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useProcessorSchedulingWithMissingCutsheetsQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>(ProcessorSchedulingWithMissingCutsheetsDocument, options);
      }
export function useProcessorSchedulingWithMissingCutsheetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>(ProcessorSchedulingWithMissingCutsheetsDocument, options);
        }
export type ProcessorSchedulingWithMissingCutsheetsQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingCutsheetsQuery>;
export type ProcessorSchedulingWithMissingCutsheetsLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingCutsheetsLazyQuery>;
export type ProcessorSchedulingWithMissingCutsheetsQueryResult = Apollo.QueryResult<ProcessorSchedulingWithMissingCutsheetsQuery, ProcessorSchedulingWithMissingCutsheetsQueryVariables>;
export const ProcessorSchedulingWithMissingHangingWeightsDocument = gql`
    query processorSchedulingWithMissingHangingWeights($page: Int!, $perPage: Int!, $sort: SortFindManyProcessorSchedulingInput!, $vendorId: MongoID!) {
  findProcessorSchedulingsWithMissingHangingWeights(
    page: $page
    perPage: $perPage
    sort: $sort
    vendorId: $vendorId
  ) {
    count
    pageInfo {
      currentPage
      perPage
      pageCount
      itemCount
      hasNextPage
      hasPreviousPage
    }
    items {
      _id
      animalSpecies
      dropoffDate
      headCount
      status
      statusLastUpdated
      firstKillDate
      vendor {
        shop_name
      }
      requestedBy {
        _id
        first_name
        last_name
        phone
        email
        company
      }
      deposit {
        amount
      }
      animalHeads {
        _id
        publicId
        producerIdentifier
        splitType
        inspectionLevel
        hangingWeight
        isHangingWeightPerSide
        hangingWeightSideA
        hangingWeightSideB
        butcherSlotPrice
        tracking
        killDate
        liveWeight
        sex
        cutDate
        cutsheetInformation {
          _id
          cutsheet {
            _id
            name
            type
            pricePerPound
          }
          splitPart
          quantity
          notes
          locked
          contactUser {
            _id
            email
            first_name
            last_name
            phone
          }
        }
      }
    }
  }
}
    `;

/**
 * __useProcessorSchedulingWithMissingHangingWeightsQuery__
 *
 * To run a query within a React component, call `useProcessorSchedulingWithMissingHangingWeightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessorSchedulingWithMissingHangingWeightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessorSchedulingWithMissingHangingWeightsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sort: // value for 'sort'
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useProcessorSchedulingWithMissingHangingWeightsQuery(baseOptions: Apollo.QueryHookOptions<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>(ProcessorSchedulingWithMissingHangingWeightsDocument, options);
      }
export function useProcessorSchedulingWithMissingHangingWeightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>(ProcessorSchedulingWithMissingHangingWeightsDocument, options);
        }
export type ProcessorSchedulingWithMissingHangingWeightsQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingHangingWeightsQuery>;
export type ProcessorSchedulingWithMissingHangingWeightsLazyQueryHookResult = ReturnType<typeof useProcessorSchedulingWithMissingHangingWeightsLazyQuery>;
export type ProcessorSchedulingWithMissingHangingWeightsQueryResult = Apollo.QueryResult<ProcessorSchedulingWithMissingHangingWeightsQuery, ProcessorSchedulingWithMissingHangingWeightsQueryVariables>;
export const StateManyDocument = gql`
    query StateMany {
  stateMany(sort: STATE_ASC) {
    name
    code
    _id
  }
}
    `;

/**
 * __useStateManyQuery__
 *
 * To run a query within a React component, call `useStateManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStateManyQuery({
 *   variables: {
 *   },
 * });
 */
export function useStateManyQuery(baseOptions?: Apollo.QueryHookOptions<StateManyQuery, StateManyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StateManyQuery, StateManyQueryVariables>(StateManyDocument, options);
      }
export function useStateManyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StateManyQuery, StateManyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StateManyQuery, StateManyQueryVariables>(StateManyDocument, options);
        }
export type StateManyQueryHookResult = ReturnType<typeof useStateManyQuery>;
export type StateManyLazyQueryHookResult = ReturnType<typeof useStateManyLazyQuery>;
export type StateManyQueryResult = Apollo.QueryResult<StateManyQuery, StateManyQueryVariables>;
export const UserSettingsByUserIdDocument = gql`
    query UserSettingsByUserId($userId: MongoID!) {
  userSettingsByUserId(userId: $userId) {
    settings {
      calendar {
        dateConfiguration
        calendarView
        showAllEvents
      }
    }
  }
}
    `;

/**
 * __useUserSettingsByUserIdQuery__
 *
 * To run a query within a React component, call `useUserSettingsByUserIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSettingsByUserIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSettingsByUserIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSettingsByUserIdQuery(baseOptions: Apollo.QueryHookOptions<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>(UserSettingsByUserIdDocument, options);
      }
export function useUserSettingsByUserIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>(UserSettingsByUserIdDocument, options);
        }
export type UserSettingsByUserIdQueryHookResult = ReturnType<typeof useUserSettingsByUserIdQuery>;
export type UserSettingsByUserIdLazyQueryHookResult = ReturnType<typeof useUserSettingsByUserIdLazyQuery>;
export type UserSettingsByUserIdQueryResult = Apollo.QueryResult<UserSettingsByUserIdQuery, UserSettingsByUserIdQueryVariables>;
export const UserTenantVendorDocument = gql`
    query UserTenantVendor {
  userTenantVendor {
    ...UserFragment
  }
}
    ${UserFragmentFragmentDoc}`;

/**
 * __useUserTenantVendorQuery__
 *
 * To run a query within a React component, call `useUserTenantVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTenantVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTenantVendorQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTenantVendorQuery(baseOptions?: Apollo.QueryHookOptions<UserTenantVendorQuery, UserTenantVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTenantVendorQuery, UserTenantVendorQueryVariables>(UserTenantVendorDocument, options);
      }
export function useUserTenantVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTenantVendorQuery, UserTenantVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTenantVendorQuery, UserTenantVendorQueryVariables>(UserTenantVendorDocument, options);
        }
export type UserTenantVendorQueryHookResult = ReturnType<typeof useUserTenantVendorQuery>;
export type UserTenantVendorLazyQueryHookResult = ReturnType<typeof useUserTenantVendorLazyQuery>;
export type UserTenantVendorQueryResult = Apollo.QueryResult<UserTenantVendorQuery, UserTenantVendorQueryVariables>;
export const VendorListDocument = gql`
    query VendorList($startDate: String!, $endDate: String!) {
  vendorList(startDate: $startDate, endDate: $endDate) {
    _id
    shop_name
    tenant {
      name
    }
  }
}
    `;

/**
 * __useVendorListQuery__
 *
 * To run a query within a React component, call `useVendorListQuery` and pass it any options that fit your needs.
 * When your component renders, `useVendorListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVendorListQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useVendorListQuery(baseOptions: Apollo.QueryHookOptions<VendorListQuery, VendorListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VendorListQuery, VendorListQueryVariables>(VendorListDocument, options);
      }
export function useVendorListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VendorListQuery, VendorListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VendorListQuery, VendorListQueryVariables>(VendorListDocument, options);
        }
export type VendorListQueryHookResult = ReturnType<typeof useVendorListQuery>;
export type VendorListLazyQueryHookResult = ReturnType<typeof useVendorListLazyQuery>;
export type VendorListQueryResult = Apollo.QueryResult<VendorListQuery, VendorListQueryVariables>;
export const ProcessingJobByIdDocument = gql`
    query ProcessingJobById($jobId: MongoID!, $includeNotificationHistory: Boolean!, $includeProcessorSettings: Boolean!) {
  findProcessorSchedulingById(_id: $jobId) {
    ...ProcessorSchedulingFragment
    notificationHistory @include(if: $includeNotificationHistory) {
      notificationType
      type
      sentTo
      sentOn
      user {
        _id
        first_name
        last_name
        email
        phone
      }
      errorMessage {
        message
        code
      }
    }
    processorSettings @include(if: $includeProcessorSettings) {
      _id
      enabledAnimalSplits
      animalSettings {
        species
        inspectionLevels
        splitTypes
      }
      killAndChillSettings {
        species
        isEnabled
        pricePerHead
      }
    }
  }
}
    ${ProcessorSchedulingFragmentFragmentDoc}`;

/**
 * __useProcessingJobByIdQuery__
 *
 * To run a query within a React component, call `useProcessingJobByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessingJobByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessingJobByIdQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      includeNotificationHistory: // value for 'includeNotificationHistory'
 *      includeProcessorSettings: // value for 'includeProcessorSettings'
 *   },
 * });
 */
export function useProcessingJobByIdQuery(baseOptions: Apollo.QueryHookOptions<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>(ProcessingJobByIdDocument, options);
      }
export function useProcessingJobByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>(ProcessingJobByIdDocument, options);
        }
export type ProcessingJobByIdQueryHookResult = ReturnType<typeof useProcessingJobByIdQuery>;
export type ProcessingJobByIdLazyQueryHookResult = ReturnType<typeof useProcessingJobByIdLazyQuery>;
export type ProcessingJobByIdQueryResult = Apollo.QueryResult<ProcessingJobByIdQuery, ProcessingJobByIdQueryVariables>;
export const WaitlistByVendorIdDocument = gql`
    query WaitlistByVendorId($vendorId: MongoID!) {
  waitlistByVendorId(vendorId: $vendorId) {
    ...WaitlistFragment
  }
}
    ${WaitlistFragmentFragmentDoc}`;

/**
 * __useWaitlistByVendorIdQuery__
 *
 * To run a query within a React component, call `useWaitlistByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useWaitlistByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaitlistByVendorIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *   },
 * });
 */
export function useWaitlistByVendorIdQuery(baseOptions: Apollo.QueryHookOptions<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>(WaitlistByVendorIdDocument, options);
      }
export function useWaitlistByVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>(WaitlistByVendorIdDocument, options);
        }
export type WaitlistByVendorIdQueryHookResult = ReturnType<typeof useWaitlistByVendorIdQuery>;
export type WaitlistByVendorIdLazyQueryHookResult = ReturnType<typeof useWaitlistByVendorIdLazyQuery>;
export type WaitlistByVendorIdQueryResult = Apollo.QueryResult<WaitlistByVendorIdQuery, WaitlistByVendorIdQueryVariables>;